/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
// eslint-disable-next-line import/order
import {
  jotaiStore,
  showModalAtom,
  showArtworkHistoryModalAtom,
  variantIdAtom,
  productIdAtom,
  catalogNumberAtom,
  printAsIsAtom,
  neckLabelAtom,
  dtfMaxWidthAtom,
  dtfMaxHeightAtom,
  dtfMinWidthAtom,
  dtfMinHeightAtom,
  pdpTypeAtom,
  preCutAtom,
  productSlugAtom,
  showCTAAtom,
  favoritesAtom,
  stickerAtom,
  currentStoreAtom,
  allowForceBgRemoveAtom,
  canvaReviewerAtom,
  unitPriceAtom,
  printingServiceNameAtom,
  cachedArtworkPricesAtom,
  dtfCategoryAtom,
  spanglesAtom,
  canvaDtfEnabledStateAtom,
  showMultiSizeArtworkAtom,
  enablePreCutAtom,
  preCutPriceAtom,
  preCutEnabledAtom,
  preCutDurationAtom,
  preCutUpsellThresholdAtom,
  loadFromConfigAtom,
  artworksStateAtom,
  artworkHistoryAtom,
  artworkHistoryPaginationAtom,
  summaryAtom,
  bogoPromotionDataAtom,
  simulationAtom,
  fileToRemoveAtom,
  showDiscardModalAtom,
  discardedAtom,
  fetchControllerAtom,
  useDefaultValuesAtom,
  showFilesErrorAtom,
  replaceArtworkAtom,
  errorTypesAtom,
  isRetryingAtom,
  allRetryFailedAtom,
  localeAtom,
  experimentsAtom,
  minStickerQuantityAtom,
  userTypeAtom,
  bogoEligibilityAtom,
  bogoMaxDimensionLabelAtom,
  promotionResolutionAtom,
  transferPdpBackButtonDetectionAtom,
  spangleConfigAtom,
  sizeErrorTypesAtom,
  isMobileAtom,
  enableMobileFooterCTAAtom,
  dtfChannelUuidAtom,
  isEnhancementLoadingAtom,
  isSubmittingAtom,
  actionCableOptionsAtom,
  actionCableConnectedAtom,
  stickerQrScannedAtom,
  cableAtom,
  businessLineAtom,
  isPuffAtom,
  puffAtom,
  isProColorAtom,
  cmykSoftProofEnabledAtom,
  isStickerAtom,
  isDieCutStickerAtom,
  isStickerSampleAtom,
  isJiffyMadeAtom,
  printReadyInfoConfigAtom,
  loadingAtom,
  isJerseyNumbersAtom,
  isLettersAtom,
  letterPreviewMessagesAtom,
  artworkBackgroundAtom,
  backgroundTypeAtom,
  stickersStyleOptionsAtom,
  letterPreviewLoadingAtom,
  isGoldFoilAtom,
  forcePdpTransfersRedrawAtom,
  pinBasedRedrawEnabledAtom,
  pinBasedRedrawEscapedAtom,
  enableRedrawAtom,
  isPricingLoadingAtom,
  enhancementNoteAtom,
  puffMaxImageCountAtom,
  previewCanvasSizeAtom,
  gangSheetBuilderAtom,
  showGangSheetBuilderAtom,
  generatedGangSheetsAtom,
  gangSheetBuilderShopIdAtom,
  showGangSheetBuilderFeatureAtom,
  isGangSheetBuilderAtom,
  gangSheetBuilderVariantsAtom,
  gangSheetBuilderSettingsAtom,
  gangSheetBuilderSizesAtom,
  isDtfSheetAtom,
  gangSheetBulkPriceAtom,
  storeCreditInfoAtom,
  presetMockupColorAtom,
  gangSheetBuilderCarouselsAtom,
  updatePricingAbortSignalAtom,
  preloadedDesignIdAtom,
  reorderEnabledAtom,
  validateArtworkStartTimeAtom,
  validateArtworkStartEventIntervalIDAtom,
  enhancementStuckAt60sAtom,
  enhancementTimedOutAtom,
  paidExpertEditAddonEnabledAtom,
  gangSheetCatalogNumbersAtom,
  customerReviewOnRedrawsAtom,
  customerReviewOnTransferRedrawsAtom,
  klaviyoSmsTransactionalSubscribedAtom,
  smsTransactionalSubscriptionPdpEnabledAtom,
  smsTransactionalPhoneAtom,
  smsTransactionalSubscribeButtonTextAtom,
  messagingConsentsAtom,
  blankItemsCountAtom,
  transfersInCartCountAtom,
  isNewToTransfersAtom,
  showPinningModalAtom,
  pinningArtworkIndexAtom,
  pinningModalSessionIdAtom,
  pinningSessionLoadingAtom,
  pendingInitialMessageAtom,
  pendingPinningInvalidationAtom,
  lastConfirmedConfigSectionAtom
} from "./store.atoms";
import type { ArtworkItem, FontDetail, SizesAndQuantityItem } from "./types";
import { extractAddToCartErrorMessage } from "./addToCartErrorExtractor";
import { buildDtfAddBlockedProperties, DTF_ADD_BLOCKED_EVENT } from "./dtfAddBlockedEvent";

/* eslint-disable no-param-reassign, max-lines, no-return-await */
import {
  getImageDimensions,
  logUnsupportedFileTypeEvent,
  validateAndMaterializeFile
} from "common/file-type-helper";
import { MIN_IMAGE_DIMENSION_PX } from "common/artwork-file-types";
import { getUploadTimeout } from "common/upload-constants";
import getVariantInfo from "common/jiffy/get-variant";
import { redirectTo } from "common/utils/browser";
import { deleteCookie } from "common/utils/cookie";
import { isSessionExpired } from "common/utils/csrf-token-manager";
import { objNamesToCamelCase } from "common/utils/helpers/cases";
import { findIndexById } from "common/utils/helpers/find-index-by-id";
import sendServerSideConversion from "common/utils/conversion-tracking";
import { isBenignUploadError } from "common/utils/app-monitoring/benign-upload-error";
import { logUploadError } from "common/utils/app-monitoring/log-upload-error";
import isRelevantBrowserError from "common/utils/app-monitoring/is-relevant-browser-error";
import { notifyError } from "common/utils/app-monitoring/notify";
import { tryParse } from "common/utils/json";
import {
  getErrorContext,
  logUploadErrorEvent
} from "common/utils/mixpanel/dropzone-error-event-tracker";
import { submitCompletedEvent, submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import { submitProcolorRoutableTaggedForArtwork } from "common/utils/mixpanel/dtf-procolor-event";
import { emitTransferUploadParallelEvent } from "common/utils/transfer-upload/parallel-emitter";
import { setUploadUuid } from "common/utils/transfer-upload/upload-uuid-tracker";
import mobileApp from "common/utils/mobile/app";
import { DTF_PROGRESS_MAPPING } from "common/utils/progress-bar/constants";
import { shouldReportError } from "common/utils/request/request";
import { asyncRetryIfTransientError } from "common/utils/retries";
import {
  trackRudderstackImageProcessingCompleted,
  trackRudderstackImageRemoved,
  trackRudderstackImageUploadRetry,
  trackRudderstackImageUploadStarted
} from "common/utils/rudderstack/tracker.react";
import { getStickerDimensions } from "common/utils/stickers";
import { DEFAULT_STICKER_VALUES } from "common/utils/stickers/constants";
import idleCallback from "common/utils/ui/idle_callback";
import { generateUUID } from "common/utils/uuid";
import { incrementHeaderCounter } from "components/jiffy/masthead-cart/masthead-cart";
import {
  deliveryDateResponse,
  reloadDeliveryEstimates
} from "components/jiffy/product-details-delivery-date-simple/init-dates";
import validationErrors from "components/jiffy/product-details-quantity-form/show-product-modules/validation-errors";
import { sendDataLayer } from "jiffy-analytics";
import { api } from "jiffy-api";
import { EventBus, Events } from "jiffy-store";
import debounce from "lodash.debounce";
import { createJotaiPiniaFacadeForReact } from "common/vue/createJotaiPiniaFacadeForReact";
import { startPinSessionRecording } from "../design-lab/shared/lib/pinSessionRecording";
import {
  calculateDefaultDimensions,
  calculateDimensions,
  convertImageToHexColor,
  getDtfPlacementSummary,
  getFormPayload,
  getIsBuyItAgainStatus,
  getPdpImage,
  getRandomId,
  groupByKeyPrefix,
  isPurgeableUploadError,
  recalculateCustomSizes,
  validateGangSheetDimensions,
  zipArray,
  zipArrayByKey
} from "./utils";
import {
  BACKEND_TRIGGERED_ENHANCEMENT_ELIGIBLE_CATALOG,
  DEFAULT_PUFF_VALUES,
  DEFAULT_SPANGLE_VALUES,
  DEFAULT_VALUES,
  DTF001_CATALOG_NUMBER,
  GANG_DEFAULT_VALUES,
  GOLD_FOIL_HEX,
  JERSEY_NUMBERS_DEFAULT_VALUES,
  LETTER_DEFAULTS,
  LETTERS_FILL_IN_VALUES,
  MIXPANEL_METADATA_KEYS,
  RETRY_INTERVALS
} from "./common/constants";
import { isTransientServerError } from "./common/is-transient-server-error";
import { buildProColorUploadSeed } from "./common/seed";
import initCable from "./dtf-channel"; // eslint-disable-line import/no-cycle
import { trackAddToCart } from "./dtf-ga-tracker";
import ErrorTypes from "./error-types";
import { cancelSession, createSession } from "./PinningSession/composables/usePinningSession";
import {
  trackPinsSessionSummaryEditClicked,
  trackTransfersPinningInstructionsRemoved,
  trackTransfersPinsCtaClicked
} from "./PinningSession/transfersPinningAnalytics";
import { SPANGLE_MODES, useSpanglesStore, spanglesStore } from "./spangles-module"; // eslint-disable-line import/no-cycle
import transfersPollingService from "./transfers-polling-service";

const recordFromUnknown = (value: unknown): Record<string, unknown> | null =>
  value !== null && typeof value === "object" ? (value as Record<string, unknown>) : null;

const stringFromUnknown = (value: unknown): string | null =>
  typeof value === "string" ? value : null;

const numberFromUnknown = (value: unknown): number | null =>
  typeof value === "number" ? value : null;

const getStructuredErrorContext = (error: unknown) => {
  const errorRecord = recordFromUnknown(error);
  const responseRecord = recordFromUnknown(errorRecord?.["response"]);
  const errorConstructor = errorRecord?.constructor;
  const constructorName =
    typeof errorConstructor === "function" ? stringFromUnknown(errorConstructor.name) : null;

  return {
    errorMessage:
      stringFromUnknown(errorRecord?.["message"]) ||
      stringFromUnknown(errorRecord?.["error"]) ||
      String(error),
    errorType: stringFromUnknown(errorRecord?.["name"]) || constructorName || typeof error,
    httpStatus:
      numberFromUnknown(responseRecord?.["status"]) || numberFromUnknown(errorRecord?.["status"]),
    responseData:
      responseRecord && Object.prototype.hasOwnProperty.call(responseRecord, "data")
        ? responseRecord["data"]
        : errorRecord?.["response"]
  };
};

const DEFAULT_SIMULATION_ARTWORK = {
  ...LETTER_DEFAULTS,
  widthEdited: false,
  isSimulated: true,
  id: "simulation",
  style: null,
  height: null,
  color: null,
  quantity: 1,
  quantities: {},
  sizes: {},
  prices: {},
  enhancementNote: "",
  enhancementFeedbackSubmitted: false,
  enhancementRatingSubmitted: false,
  enhancementSatisfied: null,
  sizesAndQuantities: [],
  enhancementTier: "full_enhancements"
};

const initialState = {
  showModal: false,
  showArtworkHistoryModal: false,
  variantId: null,
  productId: null,
  catalogNumber: null,
  printAsIs: false,
  neckLabel: false,
  dtfMaxWidth: null,
  dtfMaxHeight: null,
  dtfMinWidth: null,
  dtfMinHeight: null,
  pdpType: null,
  preCut: false,
  productSlug: "",
  showCTA: false,
  favorites: [],
  sticker: null,
  currentStore: null,
  allowForceBgRemove: false,
  canvaReviewer: null,
  unitPrice: null,
  printingServiceName: null,
  cachedArtworkPrices: {},
  dtfCategory: null,
  spangles: [],
  canvaDtfEnabledState: false,
  showMultiSizeArtwork: false,
  enablePreCut: false,
  preCutPrice: 0,
  preCutEnabled: false,
  preCutDuration: null,
  preCutUpsellThreshold: 0,
  loadFromConfig: true,
  artworksState: [],
  artworkHistory: [],
  artworkHistoryPagination: {
    page: 1
  },
  /**
   * @type {import('./types').PriceSummary}
   */
  summary: {
    orderTotal: "0.0",
    productCartQuantity: 0
  },
  /**
   * BOGO promotion data from the pricing API
   * @type {{ applicable: boolean, freeQtyAvailable?: number, artworks?: object }}
   */
  bogoPromotionData: {
    applicable: false
  },
  /**
   * @type {import('./types').Standard.Artwork | import('./types').Sticker.Artwork}
   */
  simulation: { ...DEFAULT_SIMULATION_ARTWORK },
  fileToRemove: null,
  showDiscardModal: false,
  discarded: null,
  fetchController: null,
  useDefaultValues: false,
  showFilesError: false,
  replaceArtwork: false,
  errorTypes: ErrorTypes,
  isRetrying: false,
  allRetryFailed: false,
  locale: "en-US",
  experiments: {},
  minStickerQuantity: 10,
  userType: "guest_user",
  bogoEligibility: { visible: false, reason: null },
  bogoMaxDimensionLabel: '12"x12"',
  promotionResolution: { winner: "none" },

  transferPdpBackButtonDetection: false,
  spangleConfig: {
    spangleAlgorithms: [],
    isSpangle: false,
    spangleColors: []
  },
  sizeErrorTypes: [
    ErrorTypes.INVALID_WIDTH.toString(),
    ErrorTypes.INVALID_HEIGHT.toString(),
    ErrorTypes.NEGATIVE_VALUES.toString(),
    ErrorTypes.MIN_PRINT_SIZE.toString(),
    ErrorTypes.MAX_PRINT_SIZE.toString(),
    ErrorTypes.UPSCALE_THRESHOLD_EXCEEDED.toString()
  ],

  isMobile: false,
  enableMobileFooterCTA: false,
  dtfChannelUuid: null,
  isEnhancementLoading: false,
  // Guards against duplicate line items when the user rapid-fires Add to Cart
  // before the first POST /api/cart/dtf_add completes.
  isSubmitting: false,
  actionCableOptions: {},
  actionCableConnected: false,
  stickerQrScanned: false,
  cable: null,
  businessLine: null,
  isPuff: false,
  puff: { ...DEFAULT_PUFF_VALUES },
  isProColor: false,
  cmykSoftProofEnabled: false,
  isSticker: false,
  isDieCutSticker: false,
  isStickerSample: false,
  isJiffyMade: false,
  printReadyInfoConfig: {
    show: false,
    expanded: false
  },
  loading: {
    removeBg: false
  },
  isJerseyNumbers: false,
  isLetters: false,
  letterPreviewMessages: {},
  artworkBackground: "transparent",
  backgroundType: "checkered",
  stickersStyleOptions: false,
  letterPreviewLoading: false,
  isGoldFoil: false,
  forcePdpTransfersRedraw: false,
  pinBasedRedrawEnabled: false,
  pinBasedRedrawEscaped: false,
  enableRedraw: false,
  isPricingLoading: false,
  enhancementNote: "",
  puffMaxImageCount: 1,
  previewCanvasSize: { width: 0, height: 0 },
  gangSheetBuilder: null,
  showGangSheetBuilder: false,
  generatedGangSheets: [],
  gangSheetBuilderShopId: null,
  showGangSheetBuilderFeature: false,
  isGangSheetBuilder: false,
  gangSheetBuilderVariants: [],
  gangSheetBuilderSettings: {},
  gangSheetBuilderSizes: [],
  isDtfSheet: false,
  gangSheetBulkPrice: {},
  storeCreditInfo: {},
  presetMockupColor: ["#E1E1E1"],
  gangSheetBuilderCarousels: {},
  updatePricingAbortSignal: null,
  preloadedDesignId: null,
  reorderEnabled: false,
  validateArtworkStartTime: {},
  validateArtworkStartEventIntervalID: {},
  paidExpertEditAddonEnabled: false,
  gangSheetCatalogNumbers: [],
  customerReviewOnRedraws: false,
  customerReviewOnTransferRedraws: false,
  pinSessionRecording: false,
  pinSessionForceMixpanelRecording: false,
  klaviyoSmsTransactionalSubscribed: false,
  smsTransactionalSubscriptionPdpEnabled: false,
  smsTransactionalPhone: "",
  smsTransactionalSubscribeButtonText: "Subscribe",
  messagingConsents: { smsTransactional: true },
  blankItemsCount: 0,
  transfersInCartCount: 0,
  isNewToTransfers: null,
  showPinningModal: false,
  pinningArtworkIndex: null,
  pinningModalSessionId: null,
  pinningSessionLoading: false,
  pendingInitialMessage: null,
  pendingPinningInvalidation: null,
  lastConfirmedConfigSection: null
};

const emptyArtworkItem = {
  id: null,
  file: null,
  name: null,
  isFile: true,
  metadata: null,
  borneoMetadata: null,
  isLoading: true,
  removeBackground: false,
  width: null,
  height: null,
  quantity: null,
  pricing: {},
  isValid: true,
  projectId: null,
  uploadError: null,
  uploadErrorCode: null,
  imageTooSmall: false,
  toggleBackgroundError: null,
  originalWidth: null,
  originalHeight: null,
  progress: 0,
  retryFailed: false,
  currentProgress: 0,
  lastWebSocketEvent: null,
  lastWebSocketEventData: {},
  spangled: false,
  spangledImageUrl: null,
  cutlineUrl: null,
  imageProcessingCompletedEventSent: false,
  color: null,
  paddingSize: "no_padding",
  bgColor: null,
  data: {},
  printReadyInfo: {},
  processTimeStamp: null,
  annotateEnabled: false,
  annotateMode: "keep",
  annotatedPoints: [],
  annotatedCanvasWidth: null,
  annotatedCanvasHeight: null,
  annotatedXOffset: 0,
  annotatedYOffset: 0,
  revisionImageUrls: [],
  revisionPosition: 0,
  sizesAndQuantities: [],
  enhancedNoBgUrl: null,
  enhancedWithBgUrl: null,
  enhancementCompleted: false,
  enhancementFeedbackSubmitted: false,
  enhancementRatingSubmitted: false,
  originalDpi: 0,
  sizeBasedDpi: 0,
  enhancedDpi: 0,
  sliderPreviewUrl: null,
  downscaledOriginalImage: null,
  catalogNumber: null,
  fromGangSheetBuilder: false,
  enhancementTier: "full_enhancements"
};

const summarizeFonts = (fontDetails: FontDetail[]) =>
  fontDetails.reduce(
    (acc: { fontFamilies: string[]; textEffects: string[] }, font: FontDetail) => {
      if (font.font_family) {
        acc.fontFamilies.push(font.font_family);
      }
      if (font.text_effect?.name) {
        acc.textEffects.push(font.text_effect.name);
      }
      return acc;
    },
    { fontFamilies: [], textEffects: [] }
  );

const validation = validationErrors();

// Helper function to map size and quantity data
function mapSizeAndQuantity({ width, height, quantity, preset, size }: SizesAndQuantityItem) {
  return { width, height, quantity, preset, size };
}

/**
 * Determines the preview image name for a pinning session based on the artwork's
 * enhancement tier and background removal setting.
 * Matches the Design Lab logic in RequestDesignChanges.getPreviewImageName.
 */
function getArtworkPreviewImageName(artwork: ArtworkItem) {
  if (artwork.manualEditUrl) {
    return "manual_edit_image";
  }

  const tier = artwork.enhancementTier;

  if (tier === "print_original") {
    return "original_image";
  }

  if (tier === "full_enhancements") {
    if (artwork.removeBackground && artwork.canRemoveBg) {
      return "image_no_background";
    }
    return "image_with_background";
  }

  return undefined;
}

function deriveArtworkHistoryFingerprint(status: number | undefined, body: string): string {
  if (status === 403) {
    if (/cloudfront|request blocked/i.test(body)) return "cloudfront_403";
    if (/^"?Forbidden(?:\\n|\n)?"?$/i.test(body.trim())) return "rack_attack_allow2ban";
    return "http_403";
  }
  if (status === 429) {
    if (/application request limit/i.test(body)) return "rack_attack_throttle";
    return "http_429";
  }
  if (status !== undefined) return `http_${status}`;
  return "network";
}

// Helper function to transform artwork for form submission
function transformArtworkToFormData(artwork: ArtworkItem, store: Record<string, unknown>) {
  const sizes = (artwork.sizesAndQuantities || []).filter(
    ({ quantity }: SizesAndQuantityItem) => Number(quantity) > 0
  );
  const llmRedrawRequestId =
    ["custom", "full_enhancements"].includes(artwork.enhancementTier) && artwork.llmRedrawRequestId
      ? artwork.llmRedrawRequestId
      : null;

  return {
    artwork_id: artwork.id,
    width: artwork.width,
    height: artwork.height,
    // @ts-ignore TS(TS4111)
    quantity: store.showMultiSize ? 1 : Number(artwork.quantity),
    from_dam: artwork.fromDam,
    // @ts-ignore TS(TS4111)
    variant_id: artwork.variantId || store.variantId,
    metadata: artwork.metadata,
    borneo_metadata: artwork.borneoMetadata,
    project_id: artwork.projectId,
    spangled_image_url: artwork.spangledImageUrl,
    spangled: artwork.spangled,
    spangle_csv: artwork.spangleCsv,
    spangle_pages_info: artwork.spanglePagesInfo,
    spangle_positions_json: artwork.spanglePositionsJson,
    color: artwork.color,
    padding_size: artwork.paddingSize,
    preview_url: artwork.url || artwork.originalNoBgUrl,
    bg_color: artwork.bgColor,
    shape: artwork.shape,
    remove_background: artwork.removeBackground,
    enhancement_request_note: artwork.enhancementNote,
    llm_redraw_request_id: llmRedrawRequestId,
    enhancement_tier: artwork.enhancementTier,
    enhance_image: artwork.enhanceImage,
    from_gang_sheet_builder: artwork.fromGangSheetBuilder,
    catalog_number: artwork.catalogNumber,
    sizes_and_quantities: sizes.map(mapSizeAndQuantity),
    // @ts-ignore TS(TS4111)
    messaging_consents: store.messagingConsents || { smsTransactional: true },
    ...(artwork.pinningSessionId && { pinning_session_id: artwork.pinningSessionId }),
    ...(artwork.editImageManual && { edit_image_manual: true })
  };
}

export const useDtfStore = createJotaiPiniaFacadeForReact({
  jotaiStore,

  state: {
    showModal: showModalAtom,
    showArtworkHistoryModal: showArtworkHistoryModalAtom,
    variantId: variantIdAtom,
    productId: productIdAtom,
    catalogNumber: catalogNumberAtom,
    printAsIs: printAsIsAtom,
    neckLabel: neckLabelAtom,
    dtfMaxWidth: dtfMaxWidthAtom,
    dtfMaxHeight: dtfMaxHeightAtom,
    dtfMinWidth: dtfMinWidthAtom,
    dtfMinHeight: dtfMinHeightAtom,
    pdpType: pdpTypeAtom,
    preCut: preCutAtom,
    productSlug: productSlugAtom,
    showCTA: showCTAAtom,
    favorites: favoritesAtom,
    sticker: stickerAtom,
    currentStore: currentStoreAtom,
    allowForceBgRemove: allowForceBgRemoveAtom,
    canvaReviewer: canvaReviewerAtom,
    unitPrice: unitPriceAtom,
    printingServiceName: printingServiceNameAtom,
    cachedArtworkPrices: cachedArtworkPricesAtom,
    dtfCategory: dtfCategoryAtom,
    spangles: spanglesAtom,
    canvaDtfEnabledState: canvaDtfEnabledStateAtom,
    showMultiSizeArtwork: showMultiSizeArtworkAtom,
    enablePreCut: enablePreCutAtom,
    preCutPrice: preCutPriceAtom,
    preCutEnabled: preCutEnabledAtom,
    preCutDuration: preCutDurationAtom,
    preCutUpsellThreshold: preCutUpsellThresholdAtom,
    loadFromConfig: loadFromConfigAtom,
    artworksState: artworksStateAtom,
    artworkHistory: artworkHistoryAtom,
    artworkHistoryPagination: artworkHistoryPaginationAtom,
    summary: summaryAtom,
    bogoPromotionData: bogoPromotionDataAtom,
    simulation: simulationAtom,
    fileToRemove: fileToRemoveAtom,
    showDiscardModal: showDiscardModalAtom,
    discarded: discardedAtom,
    fetchController: fetchControllerAtom,
    useDefaultValues: useDefaultValuesAtom,
    showFilesError: showFilesErrorAtom,
    replaceArtwork: replaceArtworkAtom,
    errorTypes: errorTypesAtom,
    isRetrying: isRetryingAtom,
    allRetryFailed: allRetryFailedAtom,
    locale: localeAtom,
    experiments: experimentsAtom,
    minStickerQuantity: minStickerQuantityAtom,
    userType: userTypeAtom,
    bogoEligibility: bogoEligibilityAtom,
    bogoMaxDimensionLabel: bogoMaxDimensionLabelAtom,
    promotionResolution: promotionResolutionAtom,

    transferPdpBackButtonDetection: transferPdpBackButtonDetectionAtom,
    spangleConfig: spangleConfigAtom,
    sizeErrorTypes: sizeErrorTypesAtom,
    isMobile: isMobileAtom,
    enableMobileFooterCTA: enableMobileFooterCTAAtom,
    dtfChannelUuid: dtfChannelUuidAtom,
    isEnhancementLoading: isEnhancementLoadingAtom,
    isSubmitting: isSubmittingAtom,
    actionCableOptions: actionCableOptionsAtom,
    actionCableConnected: actionCableConnectedAtom,
    stickerQrScanned: stickerQrScannedAtom,
    cable: cableAtom,
    businessLine: businessLineAtom,
    isPuff: isPuffAtom,
    puff: puffAtom,
    isProColor: isProColorAtom,
    cmykSoftProofEnabled: cmykSoftProofEnabledAtom,
    isSticker: isStickerAtom,
    isDieCutSticker: isDieCutStickerAtom,
    isStickerSample: isStickerSampleAtom,
    isJiffyMade: isJiffyMadeAtom,
    printReadyInfoConfig: printReadyInfoConfigAtom,
    loading: loadingAtom,
    isJerseyNumbers: isJerseyNumbersAtom,
    isLetters: isLettersAtom,
    letterPreviewMessages: letterPreviewMessagesAtom,
    artworkBackground: artworkBackgroundAtom,
    backgroundType: backgroundTypeAtom,
    stickersStyleOptions: stickersStyleOptionsAtom,
    letterPreviewLoading: letterPreviewLoadingAtom,
    isGoldFoil: isGoldFoilAtom,
    forcePdpTransfersRedraw: forcePdpTransfersRedrawAtom,
    pinBasedRedrawEnabled: pinBasedRedrawEnabledAtom,
    pinBasedRedrawEscaped: pinBasedRedrawEscapedAtom,
    enableRedraw: enableRedrawAtom,
    isPricingLoading: isPricingLoadingAtom,
    enhancementNote: enhancementNoteAtom,
    puffMaxImageCount: puffMaxImageCountAtom,
    previewCanvasSize: previewCanvasSizeAtom,
    gangSheetBuilder: gangSheetBuilderAtom,
    showGangSheetBuilder: showGangSheetBuilderAtom,
    generatedGangSheets: generatedGangSheetsAtom,
    gangSheetBuilderShopId: gangSheetBuilderShopIdAtom,
    showGangSheetBuilderFeature: showGangSheetBuilderFeatureAtom,
    isGangSheetBuilder: isGangSheetBuilderAtom,
    gangSheetBuilderVariants: gangSheetBuilderVariantsAtom,
    gangSheetBuilderSettings: gangSheetBuilderSettingsAtom,
    gangSheetBuilderSizes: gangSheetBuilderSizesAtom,
    isDtfSheet: isDtfSheetAtom,
    gangSheetBulkPrice: gangSheetBulkPriceAtom,
    storeCreditInfo: storeCreditInfoAtom,
    presetMockupColor: presetMockupColorAtom,
    gangSheetBuilderCarousels: gangSheetBuilderCarouselsAtom,
    updatePricingAbortSignal: updatePricingAbortSignalAtom,
    preloadedDesignId: preloadedDesignIdAtom,
    reorderEnabled: reorderEnabledAtom,
    validateArtworkStartTime: validateArtworkStartTimeAtom,
    validateArtworkStartEventIntervalID: validateArtworkStartEventIntervalIDAtom,
    // MN-4782
    enhancementStuckAt60s: enhancementStuckAt60sAtom,
    enhancementTimedOut: enhancementTimedOutAtom,
    paidExpertEditAddonEnabled: paidExpertEditAddonEnabledAtom,
    gangSheetCatalogNumbers: gangSheetCatalogNumbersAtom,
    customerReviewOnRedraws: customerReviewOnRedrawsAtom,
    customerReviewOnTransferRedraws: customerReviewOnTransferRedrawsAtom,
    klaviyoSmsTransactionalSubscribed: klaviyoSmsTransactionalSubscribedAtom,
    smsTransactionalSubscriptionPdpEnabled: smsTransactionalSubscriptionPdpEnabledAtom,
    smsTransactionalPhone: smsTransactionalPhoneAtom,
    smsTransactionalSubscribeButtonText: smsTransactionalSubscribeButtonTextAtom,
    messagingConsents: messagingConsentsAtom,
    blankItemsCount: blankItemsCountAtom,
    transfersInCartCount: transfersInCartCountAtom,
    isNewToTransfers: isNewToTransfersAtom,
    showPinningModal: showPinningModalAtom,
    pinningArtworkIndex: pinningArtworkIndexAtom,
    pinningModalSessionId: pinningModalSessionIdAtom,
    pinningSessionLoading: pinningSessionLoadingAtom,
    pendingInitialMessage: pendingInitialMessageAtom,
    pendingPinningInvalidation: pendingPinningInvalidationAtom,
    lastConfirmedConfigSection: lastConfirmedConfigSectionAtom
  },

  getters: {
    showSampleAddToCart() {
      const urlParams = new URLSearchParams(window.location.search);

      return (
        urlParams.get("spt") === "true" &&
        this.catalogNumber === DTF001_CATALOG_NUMBER &&
        this.simulation.unitPrice > 0
      );
    },
    isGuest() {
      return this.userType === "guest_user";
    },
    /**
     * Returns BOGO-adjusted pricing data for a specific artwork/size
     * @returns {function(string, string, string): {freeQty: number, discountedTotalPrice: number} | null}
     */
    getBogoAdjustedPrice() {
      return (artworkId: string, sizeId: string, sizeKey: string) => {
        if (!this.bogoPromotionData?.applicable || !this.bogoPromotionData?.artworks) {
          return null;
        }

        const artworkData = this.bogoPromotionData.artworks[artworkId];
        if (!artworkData) return null;

        // Normalize sizeId: objNamesToCamelCase converts UUIDs with dashes
        // e.g., "411cb8e6-6b64-4b16-9ec5-b4b1c3d12606" becomes "411cb8e66b644b169ec5B4b1c3d12606"
        const normalizedSizeId = sizeId.replace(/[^a-zA-Z0-9]+(.)/g, (_m: string, chr: string) =>
          chr.toUpperCase()
        );
        const sizeData = artworkData[normalizedSizeId];
        if (!sizeData) return null;

        // Normalize sizeKey: ensure 2 decimal places to match backend format
        const [width, height] = sizeKey.split("x");
        // @ts-ignore TS(TS2345)
        const normalizedSizeKey = `${parseFloat(width).toFixed(2)}x${parseFloat(height).toFixed(2)}`;

        return sizeData[normalizedSizeKey] || null;
      };
    },
    /**
     * Returns total free quantity available from BOGO promotion
     * @returns {number}
     */
    bogoFreeQtyAvailable() {
      return this.bogoPromotionData?.freeQtyAvailable || 0;
    },
    /**
     * Returns whether BOGO promotion is applicable
     * @returns {boolean}
     */
    isBogoApplicable() {
      return this.bogoPromotionData?.applicable || false;
    },
    /**
     * @returns {Array<import('./types').Standard.Artwork | import('./types').Sticker.Artwork>}
     */
    artworks() {
      return this.artworksState.length ? this.artworksState : [this.simulation];
    },
    modalArtworks() {
      return this.artworks;
    },
    isFavorite() {
      return this.favorites.includes(this.productId);
    },
    withPreCut() {
      return this.preCutEnabled && this.preCutPrice > 0;
    },
    files() {
      return this.artworks.filter(({ isFile }: ArtworkItem) => isFile);
    },
    loadedArtworks() {
      return this.artworks.filter(({ isFile }: ArtworkItem) => !isFile);
    },
    allArtworksAiApproved() {
      const loaded: ArtworkItem[] = this.loadedArtworks;
      if (loaded.length === 0) return false;
      const artworksWithEdits = loaded.filter(
        (a: ArtworkItem) => a.pinningSessionId || a.enhancementNote?.trim()
      );
      if (artworksWithEdits.length === 0) return false;
      return artworksWithEdits.every((a: ArtworkItem) => a.pinningSessionState === "approved");
    },
    canvaDtfEnabled() {
      return this.canvaDtfEnabledState && this.catalogNumber === DTF001_CATALOG_NUMBER;
    },
    mobileFooterCTAEnabled() {
      return this.isMobile && this.enableMobileFooterCTA;
    },
    jerseyFormArtworks() {
      const artwork = this.letterNumberArtwork;
      return [
        {
          style: artwork.style,
          height: artwork.height,
          width: artwork.width,
          color: artwork.color,
          quantities: artwork.quantities,
          quantity: artwork.quantity,
          metadata: {}
        }
      ];
    },
    letterFormArtworks() {
      const artwork = this.letterNumberArtwork;
      const texts = artwork.texts.filter(Boolean);
      return [
        {
          texts,
          font: artwork.font,
          style: artwork.style,
          height: artwork.height,
          width: artwork.width,
          color: artwork.color,
          quantity: texts.length,
          max_length: artwork.maxLength,
          metadata: {}
        }
      ];
    },
    formArtworks() {
      if (this.isJerseyNumbers) {
        return this.jerseyFormArtworks;
      }

      if (this.isLetters) {
        return this.letterFormArtworks;
      }

      return this.artworksState
        .filter((artwork: ArtworkItem) => !artwork.imageTooSmall)
        .map((artwork: ArtworkItem) =>
          transformArtworkToFormData(artwork, this as unknown as Record<string, unknown>)
        );
    },
    letterNumberArtworks() {
      const { quantities, ...artwork } = this.letterNumberArtwork;
      const image = getPdpImage();
      if (this.isJerseyNumbers) {
        return Object.keys(quantities).map(key => ({
          ...artwork,
          id: key,
          url: image,
          pricing: { unitPrice: artwork.prices[key]?.unitPrice },
          number: key,
          height: artwork.sizes[key]?.height,
          width: artwork.sizes[key]?.width,
          quantity: quantities[key],
          preCut: this.preCut
        }));
      }

      const texts = artwork.texts.filter(Boolean);
      return texts.map((text: string, index: number) => ({
        ...artwork,
        id: index + 1,
        url: image,
        pricing: { unitPrice: artwork.prices[index + 1]?.unitPrice },
        text,
        height: artwork.sizes[index]?.height,
        width: artwork.sizes[index]?.width,
        quantity: 1,
        preCut: this.preCut
      }));
    },
    /* eslint-disable max-lines-per-function */
    csmData() {
      const artworks =
        this.isJerseyNumbers || this.isLetters ? this.letterNumberArtworks : this.artworksState;
      const result = artworks.map((artwork: ArtworkItem & { text?: string; number?: string }) => {
        let sizeText = `${artwork.width}" x ${artwork.height}"`;
        if (this.isJerseyNumbers) {
          sizeText = `Height ${artwork.height}"`;
        } else if (this.isLetters) {
          sizeText = `${Number(artwork.width).toFixed(2)}" x ${Number(artwork.height).toFixed(2)}"`;
        } else if (this.printAsIs) {
          sizeText = `${artwork.width}" x ${artwork.lengthFoot}'`;
        }

        const currency = this.locale === "en-CA" ? "C$" : "$";

        const catalogText = (() => {
          if (this.sticker) {
            return "Jiffy Stickers";
          }

          if (this.spangleConfig.isSpangle) {
            return "Jiffy Spangles";
          }

          if (this.isPuff) {
            return "Puff Transfers";
          }

          if (this.isJerseyNumbers) {
            return `Numbers (#${artwork.number})`;
          }

          if (this.isLetters) {
            // @ts-ignore TS(TS18048)
            return `Custom Names ("${artwork.text.toUpperCase()}")`;
          }

          return "Jiffy Transfers";
        })();

        return {
          id: artwork.id,
          dieCutProductId: artwork.dieCutProductId,
          dieCutVariantId: artwork.dieCutVariantId,
          catalogNumber: catalogText,
          productId: this.productId,
          variantId: this.variantId,
          color: "",
          image: artwork.url,
          size: sizeText,
          quantity: artwork.quantity,
          cutlineUrl: artwork.cutlineUrl,
          // @ts-ignore TS(TS4111)
          price: `${currency}${Number(artwork.pricing.unitPrice).toFixed(2)}`,
          preCut: this.preCut,
          preCutPrice: this.preCutPrice
        };
      }, []);

      // Add enhancement services (same as csmDataMultiSize)
      if (this.summary.enhancements) {
        const currency = this.locale === "en-CA" ? "C$" : "$";
        const { isStandardDTFProduct } = this;

        Object.values(this.summary.enhancements).forEach(enhancement => {
          // Only show print_original enhancements when experiment is active
          // @ts-ignore TS(TS18046)
          const isPrintOriginalService = enhancement.serviceName === "Print As Is Notes";
          if (isPrintOriginalService && !isStandardDTFProduct) {
            return;
          }

          result.push({
            // @ts-ignore TS(TS18046)
            catalogNumber: enhancement.serviceName,
            // @ts-ignore TS(TS18046)
            priceTotal: `${currency}${Number(enhancement.totalPrice).toFixed(2)}`,
            // @ts-ignore TS(TS18046)
            quantity: enhancement.quantity,
            isEnhancement: true
          });
        });
      }

      return result;
    },
    csmDataMultiSize() {
      const csmData: Record<string, unknown>[] = [];
      const currency = this.locale === "en-CA" ? "C$" : "$";

      this.artworksState.forEach(({ id, sizesAndQuantities, url }: ArtworkItem) => {
        sizesAndQuantities
          .filter(({ quantity }: SizesAndQuantityItem) => Number(quantity) > 0)
          .forEach((item: SizesAndQuantityItem) => {
            const artworkId = String(id);
            const sizeKey = `${item.width}x${item.height}`;
            const bogoPrice =
              !this.isGuest && item.id
                ? this.getBogoAdjustedPrice(artworkId, item.id, sizeKey)
                : null;

            const csmItem = {
              id,
              catalogNumber: "Jiffy Transfers",
              productId: this.productId,
              variantId: this.variantId,
              color: "",
              image: url,
              size: `${item.width}" x ${item.height}${this.printAsIs ? "'" : '"'}`,
              quantity: item.quantity,
              price: `${currency}${Number(item.unitPrice).toFixed(2)}`,
              preCut: this.preCut,
              preCutPrice: this.preCutPrice
            };

            if (bogoPrice) {
              // @ts-ignore TS(TS2339)
              csmItem.priceTotal = `${currency}${bogoPrice.discountedTotalPrice.toFixed(2)}`;
            }

            csmData.push(csmItem);
          });
      });

      if (this.summary.enhancements) {
        const { isStandardDTFProduct } = this;

        Object.values(this.summary.enhancements).forEach(enhancement => {
          // Only show print_original enhancements when experiment is active
          // @ts-ignore TS(TS18046)
          const isPrintOriginalService = enhancement.serviceName === "Print As Is Notes";
          if (isPrintOriginalService && !isStandardDTFProduct) {
            return;
          }

          csmData.push({
            // @ts-ignore TS(TS18046)
            catalogNumber: enhancement.serviceName,
            // @ts-ignore TS(TS18046)
            priceTotal: `${currency}${Number(enhancement.totalPrice).toFixed(2)}`,
            // @ts-ignore TS(TS18046)
            quantity: enhancement.quantity
          });
        });
      }
      return csmData;
    },
    /* eslint-enable max-lines-per-function */
    totalQuantity() {
      if (this.isJerseyNumbers || this.isLetters) {
        return this.letterNumberArtwork.quantity;
      }

      if (this.showMultiSize) {
        return this.artworksState.reduce(
          (artworkTotal: number, { sizesAndQuantities }: ArtworkItem) =>
            artworkTotal +
            sizesAndQuantities.reduce(
              (sizesTotal: number, { quantity }: SizesAndQuantityItem) =>
                sizesTotal + Number(quantity),
              0
            ),
          0
        );
      }

      return this.artworksState.reduce(
        (acc: number, { quantity }: ArtworkItem) => acc + Number(quantity),
        0
      );
    },
    outOfStock() {
      if (this.isGangSheetBuilder) return false;

      // @ts-ignore TS(TS18048)
      const available = window.inventory[this.variantId];
      return available == null || available === 0;
    },
    dtfTypeDropText() {
      return this.printAsIs ? "Drop your gang sheets here" : "Drop your images here";
    },
    isLetterReadyForOrder() {
      const { style, font, height, maxLength, color, sizes, ...artwork } = this.letterNumberArtwork;
      const texts = artwork.texts.filter(Boolean);
      const quantity = texts.length;
      const allSizesDefined = texts.every((_text: string, index: number) => {
        const size = sizes[index];
        return size && size.width !== undefined && size.height !== undefined;
      });

      return (
        style &&
        font &&
        height &&
        maxLength &&
        color &&
        quantity &&
        artwork.isValid &&
        allSizesDefined
      );
    },
    hasUndismissedResolutionFailures() {
      return this.artworksState.some((a: ArtworkItem) => a.imageTooSmall);
    },
    resolutionFailureCount() {
      return this.artworksState.filter((a: ArtworkItem) => a.imageTooSmall).length;
    },
    // MN-4782
    hasArtworkEnhancementTimedOut() {
      return Object.values(this.enhancementTimedOut as Record<string, boolean>).some(Boolean);
    },
    // Surfaces whether ANY artwork has hit the 60s stuck threshold — consumed
    // by DtfSpanglesActions to override its default `disabled` binding so
    // users can bail out of the Spangle flow during a stuck enhancement
    // (ticket spec: "Enable a 'Cancel' button on Spangle overlay" at 60s).
    hasAnyArtworkStuck() {
      return Object.values(this.enhancementStuckAt60s as Record<string, boolean>).some(Boolean);
    },
    // eslint-disable-next-line max-lines-per-function
    isReadyForOrder() {
      if (this.isJerseyNumbers) {
        const { quantity, quantities, height, ...artwork } = this.letterNumberArtwork;
        return (
          quantity &&
          height &&
          artwork.isValid &&
          Object.keys(quantities).every(key => artwork.prices[key]?.unitPrice)
        );
      }

      if (this.isLetters) {
        return this.isLetterReadyForOrder;
      }

      return (
        Boolean(this.artworksState.length) &&
        this.artworksState.every(this.isArtworkValid) &&
        !this.isPricingLoading
      );
    },
    dpiInstructionsUrl() {
      return this.locale === "en-CA" ? "/ca/artwork-dpi-instructions" : "/artwork-dpi-instructions";
    },
    gangSheetArtworkProductLink() {
      let baseLink;
      if (this.catalogNumber === "DTFGANG001") {
        baseLink = "/jiffytransfers-DTF001.html";
      } else if (this.catalogNumber === "UVDTFGANG") {
        baseLink = "/jiffytransfers-UVDTF01.html";
      } else if (this.catalogNumber === "GANGDTFPC1") {
        baseLink = "/jiffytransfers-DTFPC1.html";
      } else if (this.catalogNumber === "GANGDTFG01") {
        baseLink = "/jiffytransfers-DTFG01.html";
      } else {
        baseLink = "/jiffytransfers-UVDTF01.html";
      }
      return this.locale === "en-CA" ? `/ca${baseLink}` : baseLink;
    },
    spangleAlgorithms() {
      return this.spangleConfig.spangleAlgorithms;
    },
    isSpangle() {
      return this.spangleConfig.isSpangle;
    },
    spangleColors() {
      return this.spangleConfig.spangleColors;
    },
    isFirstArtworkMinQuantityInvalid() {
      const quantity = this.artworksState[0]?.quantity;
      return (
        (this.sticker || this.isPuff || this.isSpangle) &&
        quantity &&
        quantity < this.minStickerQuantity
      );
    },
    removeBgLoading() {
      return this.loading.removeBg;
    },
    isUVDTFSticker() {
      return this.catalogNumber === "UVDTF01";
    },
    letterNumberArtwork() {
      if (this.isJerseyNumbers || this.isLetters) {
        const [artwork] = this.artworks;
        const { summary } = this;
        const retailPrice = artwork.quantity
          ? Number(summary.orderTotal || 0) / artwork.quantity
          : 0;
        const unitPrice = artwork.quantity
          ? Number(summary.orderSubtotal || 0) / artwork.quantity
          : 0;
        const percentage = retailPrice ? 100 * (1 - unitPrice / retailPrice) : 0;
        return {
          ...artwork,
          retailPrice,
          unitPrice,
          percentage
        };
      }

      return null;
    },
    isValidJerseyArtwork() {
      const { isValid, height, sizes, quantities } = this.letterNumberArtwork;
      return isValid && height && Object.keys(sizes).length && Object.keys(quantities).length;
    },
    isLetterPreviewReady() {
      const { style, font, height, maxLength, color, texts, textIndex } = this.letterNumberArtwork;
      const quantity = (texts || []).filter(Boolean).length;
      return style && font && height && maxLength && color && quantity && textIndex !== null;
    },
    pickFromUploadsOrDesigns() {
      return !this.isSpangle && !this.printAsIs;
    },
    initialValues() {
      if (this.printAsIs) {
        return GANG_DEFAULT_VALUES;
      }
      if (this.sticker) {
        return DEFAULT_STICKER_VALUES;
      }
      if (this.isPuff) {
        return DEFAULT_PUFF_VALUES;
      }
      if (this.isSpangle) {
        return DEFAULT_SPANGLE_VALUES;
      }
      if (this.isJerseyNumbers) {
        return JERSEY_NUMBERS_DEFAULT_VALUES;
      }

      return DEFAULT_VALUES;
    },
    showMultiSize() {
      return this.showMultiSizeArtwork;
    },
    showStepsUI() {
      // MN-4937: isStickerSample excluded so the completion-check + missing-step
      // prompt UI does not engage on sticker-sample flows. Those flows render a
      // hidden quantity input instead of <ArtworkQuantity>, so useStepProgress's
      // .artwork-quantity scroll anchor would silently no-op if the prompt ever
      // surfaced.
      return (
        !this.isJerseyNumbers &&
        !this.isLetters &&
        !this.spangleConfig.isSpangle &&
        !this.sticker &&
        !this.isStickerSample
      );
    },
    isGangSheetProduct() {
      return this.catalogNumber && this.gangSheetCatalogNumbers.includes(this.catalogNumber);
    },
    showRedrawUI() {
      return (
        Boolean(this.enableRedraw) &&
        Boolean(this.forcePdpTransfersRedraw) &&
        !this.isGangSheetProduct &&
        !this.isLetters &&
        !this.isJerseyNumbers &&
        // Products with post-processing after having the final image
        !this.sticker &&
        !this.spangleConfig.isSpangle &&
        !this.isGoldFoil &&
        !this.isPuff
      );
    },
    showNewGangSheetErrorMessage() {
      return !this.showModal;
    },
    isCustomerReviewOnRedrawsEnabled() {
      return this.customerReviewOnRedraws && this.customerReviewOnTransferRedraws;
    },
    isStandardArtwork() {
      return (
        !this.printAsIs &&
        !this.isProColor &&
        !this.isSticker &&
        !this.isStickerSample &&
        !this.spangleConfig.isSpangle &&
        !this.isLetters &&
        !this.isJerseyNumbers &&
        !this.isUVDTFSticker
      );
    },
    isCmykSoftProofActive() {
      return this.cmykSoftProofEnabled && this.isStandardArtwork;
    },
    isBackendTriggeredEnhancementEligible() {
      return BACKEND_TRIGGERED_ENHANCEMENT_ELIGIBLE_CATALOG.includes(this.catalogNumber);
    },
    enableAbAiMonetization() {
      // Default behavior for DTF001 products - show the tabbed interface
      return this.catalogNumber === DTF001_CATALOG_NUMBER;
    },
    isStandardDTFProduct() {
      return this.catalogNumber === DTF001_CATALOG_NUMBER;
    },
    isPinBasedRedrawEnabled() {
      return Boolean(this.pinBasedRedrawEnabled) && !this.pinBasedRedrawEscaped;
    },
    showDesignServicesDeliveryBuffer() {
      return !this.isJiffyMade && this.experiments.transfers_design_services_delivery_buffer === 1;
    },
    // Helper getter to validate individual artwork
    isArtworkValid() {
      return (artwork: ArtworkItem) => {
        const validQuantity =
          this.sticker || this.isPuff || this.isSpangle
            ? (artwork.quantity ?? 0) >= this.minStickerQuantity
            : artwork.quantity;

        const sizes = this.showMultiSize
          ? artwork.sizesAndQuantities.filter(
              ({ quantity }: SizesAndQuantityItem) => Number(quantity) > 0
            )
          : artwork.sizesAndQuantities;

        const validMultiQuantity = this.showMultiSize
          ? sizes.length > 0 &&
            sizes.every(({ quantity }: SizesAndQuantityItem) => Number(quantity) > 0)
          : validQuantity;

        const isValidColor = !this.isPuff || Boolean(artwork.color);
        const artworkEnhancementProcessing =
          this.isStandardArtwork && !artwork.isLoading && !artwork.enhancementCompleted;

        const customNoteValid = this.getCustomNoteValid(artwork);
        const customRedrawStateValid = this.getCustomRedrawStateValid(artwork);

        return (
          artwork.isValid &&
          !artwork.uploadError &&
          !artwork.isLoading &&
          validMultiQuantity &&
          isValidColor &&
          !artworkEnhancementProcessing &&
          customNoteValid &&
          customRedrawStateValid
        );
      };
    },
    // Helper to validate custom notes
    getCustomNoteValid() {
      return (artwork: ArtworkItem) => {
        const customNote = artwork.enhancementNote;
        if (artwork.enhancementTier === "custom") {
          return customNote && customNote.trim().length > 0;
        }
        if (artwork.enhancementTier === "full_enhancements") {
          return (
            !this.paidExpertEditAddonEnabled ||
            (artwork.hasExpertEditAddon ? customNote && customNote.trim().length > 0 : true)
          );
        }
        return true;
      };
    },
    // Helper to validate custom redraw state
    getCustomRedrawStateValid() {
      return (artwork: ArtworkItem) => {
        if (artwork.enhancementTier !== "custom") return true;
        const customNote = artwork.enhancementNote;
        return customNote && customNote.trim().length > 0;
      };
    }
  },

  actions: {
    // eslint-disable-next-line max-lines-per-function
    addFiles(files: File[], startingIndex: number) {
      const { widthEdited, width, height, enhancementNote } = this.simulation;

      const {
        spangleConfig: { isSpangle }
      } = this;

      const enableCustomSize = widthEdited && !isSpangle;

      // PO-3556: for Spangle, the pre-upload PDP shows the product's canonical
      // default (6×6). Falling back to the generic 1×1 DEFAULT_VALUES between
      // `addFiles` and `setLoadedArtwork` made the Design size panel flash
      // W=1, H=1 (and recompute pricing for 1 sq in) before the backend
      // dimensions landed. Use the Spangle-specific defaults so the artwork's
      // initial placeholder matches what the customer was already looking at.
      const initialValuesForSize = this.printAsIs
        ? GANG_DEFAULT_VALUES
        : isSpangle
          ? DEFAULT_SPANGLE_VALUES
          : DEFAULT_VALUES;

      const mappedFiles = [...files].map((file, index) => {
        const initialValues = {
          width: initialValuesForSize.width,
          height: initialValuesForSize.height,
          // @ts-ignore TS(TS2339)
          previewMetadata: initialValuesForSize.previewMetadata
        };
        const dimensions = enableCustomSize && index === 0 ? { width, height } : initialValues;

        const hasMinOrderQuantity = this.isSticker || this.isPuff || this.isSpangle;
        const quantity =
          index === 0 && !hasMinOrderQuantity
            ? this.simulation?.quantity
            : this.initialValues.quantity;

        return {
          ...emptyArtworkItem,
          file,
          enhancementNote,
          enhanceImage: true,
          isFile: true,
          name: file.name,
          quantity,
          ...dimensions
        };
      });

      this.simulation = { ...this.simulation, enhancementNote: "" };

      if (this.isJiffyMade) {
        const newArtworks = [...this.artworksState];
        newArtworks.splice(startingIndex, mappedFiles.length, ...mappedFiles);
        this.artworksState = newArtworks;
      } else {
        this.artworksState = [...this.artworksState, ...mappedFiles];
      }
    },
    setFileLoading(index: number) {
      this.artworksState = [...this.artworksState];
      this.artworksState[index] = {
        ...this.artworksState[index],
        originalIndex: index,
        isLoading: true
      };
    },
    setSimulation(simulation: Record<string, unknown>) {
      this.simulation = { ...this.simulation, ...simulation };
    },
    setBlankItemsCount(count: number) {
      this.blankItemsCount = count;
    },
    setTransfersInCartCount(count: number) {
      this.transfersInCartCount = count;
    },
    setIsNewToTransfers(value: boolean | null) {
      this.isNewToTransfers = value;
    },
    // eslint-disable-next-line max-lines-per-function
    setLoadedArtwork({
      index,
      isBuyAgain,
      artwork
    }: {
      index: number;
      isBuyAgain: boolean;
      artwork: Record<string, unknown>;
    }) {
      // Exclude enhancementCompleted from the spread so it is never overwritten by an incoming
      // payload. Only the dedicated updateArtworkValuesById({ enhancementCompleted: true }) call
      // may set it.
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { enhancementCompleted: _enhancementCompleted, ...preparedArtwork } =
        objNamesToCamelCase(artwork);

      const { metadata } = preparedArtwork;
      let { sizesAndQuantities } = preparedArtwork;
      let artworkIndex = index;
      const defaultDimensions = {
        // @ts-ignore TS(TS18046)
        width: metadata.widthInch,
        // @ts-ignore TS(TS18046)
        height: metadata.heightInch
      };

      let dimensions = this.showMultiSizeArtwork
        ? // @ts-ignore TS(TS18046)
          calculateDefaultDimensions({ aspectRatio: metadata.aspectRatio })
        : defaultDimensions;

      if (!artworkIndex) {
        // @ts-ignore TS(TS4111)
        artworkIndex = findIndexById(this.artworksState, artwork.id);
      }

      const { isSizesEdited } = this.artworks[artworkIndex] || {};

      const { widthEdited, width } = this.simulation;

      const {
        spangleConfig: { isSpangle }
      } = this;

      if (widthEdited && !isSpangle && artworkIndex === 0) {
        // @ts-ignore TS(TS18046)
        dimensions = calculateDimensions(metadata.aspectRatio, width, this.sticker);
      }

      const defaultSizesAndQuantities: SizesAndQuantityItem[] = [];

      if (this.showMultiSizeArtwork) {
        if (isSizesEdited) {
          sizesAndQuantities = recalculateCustomSizes(
            this.artworks[artworkIndex].sizesAndQuantities,
            // @ts-ignore TS(TS18046)
            metadata.aspectRatio,
            // @ts-ignore TS(TS2554)
            this.sticker
          );
        } else {
          sizesAndQuantities = isBuyAgain ? sizesAndQuantities : defaultSizesAndQuantities;
        }
      } else {
        sizesAndQuantities = [];
      }

      const updatedArtworks = [...this.artworksState];
      updatedArtworks[artworkIndex] = {
        ...updatedArtworks[artworkIndex],
        ...preparedArtwork,
        isLoading: false,
        isFile: false,
        isSimulated: false,
        // @ts-ignore TS(TS18046)
        removeBackground: metadata.removeBackground,
        // @ts-ignore TS(TS18046)
        originalWidth: metadata.widthInch,
        // @ts-ignore TS(TS18046)
        originalHeight: metadata.heightInch,
        // @ts-ignore TS(TS18046)
        lengthFoot: metadata.lengthFoot,
        lastWebSocketEvent: null,
        lastWebSocketEventData: {},
        ...dimensions,
        sizesAndQuantities
      };
      this.artworksState = updatedArtworks;
    },
    setCachedArtworkPrices(prices: Record<string, unknown>) {
      this.cachedArtworkPrices = Object.keys(prices).reduce((acc, price) => {
        // @ts-ignore TS(TS7053)
        acc[price] = objNamesToCamelCase(prices[price]);
        return acc;
      }, {});
    },
    setFailedUploadArtwork({
      index,
      artworkId,
      uploadError,
      uploadErrorCode = null
    }: {
      index: number;
      artworkId: number;
      uploadError: string;
      uploadErrorCode?: string | null;
    }) {
      let artworkIndex = index;

      if (!artworkIndex) {
        artworkIndex = findIndexById(this.artworksState, artworkId);
      }

      if (!this.artworksState[artworkIndex]) return;

      const updatedArtworks = [...this.artworksState];
      updatedArtworks[artworkIndex] = {
        ...updatedArtworks[artworkIndex],
        uploadError,
        uploadErrorCode
      };
      this.artworksState = updatedArtworks;
    },
    /* eslint-disable max-lines-per-function */
    setArtworkPricing({
      index,
      isMultiSize,
      ...responseData
    }: {
      index: number;
      isMultiSize: boolean;
      [key: string]: unknown;
    }) {
      // @ts-ignore TS(TS4111)
      const pricingData = responseData.response;
      const preparedData = objNamesToCamelCase(pricingData);
      const {
        // @ts-ignore TS(TS2339)
        bulkDiscount,
        // @ts-ignore TS(TS2339)
        orderSubtotal,
        // @ts-ignore TS(TS2339)
        orderTotal,
        // @ts-ignore TS(TS2339)
        productCartQuantity,
        // @ts-ignore TS(TS2339)
        artworks,
        // @ts-ignore TS(TS2339)
        enhancements,
        // @ts-ignore TS(TS2339)
        bogoPromotionData
      } = preparedData;

      // Store BOGO promotion data
      if (bogoPromotionData) {
        this.bogoPromotionData = bogoPromotionData;
      }

      if (this.isJerseyNumbers || this.isLetters) {
        this.simulation = {
          ...this.simulation,
          prices: artworks
        };

        this.summary = {
          bulkDiscount,
          orderSubtotal,
          orderTotal
        };
        return;
      }

      if (artworks.simulation && !this.isJiffyMade) {
        this.simulation = {
          ...this.simulation,
          ...(isMultiSize ? artworks.simulation[0] : artworks.simulation),
          id: "simulation",
          sizesAndQuantities: isMultiSize
            ? zipArray(this.simulation.sizesAndQuantities, artworks.simulation)
            : []
        };
        this.summary = initialState.summary;
        this.isPricingLoading = false;
        return;
      }
      const ids = Object.keys(artworks);

      const updatedArtworks = [...this.artworksState];
      ids.forEach(id => {
        let itemIndex = findIndexById(this.artworksState, id);

        if (itemIndex === -1) itemIndex = index;
        if (!this.artworksState[itemIndex]) return;

        updatedArtworks[itemIndex] = {
          ...this.artworksState[itemIndex],
          pricing: isMultiSize ? artworks[id][0] : artworks[id],
          sizesAndQuantities: isMultiSize
            ? zipArrayByKey(this.artworksState[itemIndex].sizesAndQuantities, artworks[id], "id")
            : []
        };
      });
      this.artworksState = updatedArtworks;
      this.summary = {
        bulkDiscount,
        orderSubtotal,
        orderTotal,
        productCartQuantity,
        enhancements
      };
      this.isPricingLoading = false;

      // Trigger a reload of delivery estimates if the delivery date response is available.
      // Timeout is used to ensure that the state is updated before the reload.
      // Pass orderSubtotal directly since the Vue DOM hasn't flushed yet.
      setTimeout(
        () =>
          deliveryDateResponse.reloadDeliveryEstimatesWithoutFetch({ pdpSubtotal: orderSubtotal }),
        0
      );
    },
    /* eslint-enable max-lines-per-function */
    setSimulationPricing({
      artworks,
      isMultiSize
    }: {
      artworks: Record<string, unknown>[];
      isMultiSize: boolean;
    }) {
      const sizesAndQuantities = {
        ...this.simulation.sizesAndQuantities[0],
        // @ts-ignore TS(TS2339)
        ...artworks.simulation
      };
      this.simulation = {
        ...this.simulation,
        // @ts-ignore TS(TS2339)
        ...objNamesToCamelCase(artworks.simulation),
        sizesAndQuantities: isMultiSize ? [sizesAndQuantities] : []
      };
      this.isPricingLoading = false;
    },
    updateArtworkValues({ index, ...values }: { index: number; [key: string]: unknown }) {
      // In Vue, computed refs passed as values are lazily unwrapped by
      // reactive().  In React the conversion turns them into getter
      // functions.  Resolve them: set plain values first so dependent
      // getters read up-to-date state, then call any getter functions.
      const plain: Record<string, unknown> = {};
      const lazy: Record<string, () => unknown> = {};
      for (const [k, v] of Object.entries(values)) {
        if (typeof v === "function") lazy[k] = v as () => unknown;
        else plain[k] = v;
      }

      if (!this.artworksState.length) {
        this.simulation = {
          ...this.simulation,
          ...plain
        };
        if (Object.keys(lazy).length) {
          const resolved: Record<string, unknown> = {};
          for (const [k, fn] of Object.entries(lazy)) resolved[k] = fn();
          this.simulation = { ...this.simulation, ...resolved };
        }
        return;
      }
      const updatedArtworks = [...this.artworksState];
      let artworkIndex = updatedArtworks.findIndex(
        element => String(index) === String(element.originalIndex)
      );

      if (this.isJiffyMade && artworkIndex === -1) {
        artworkIndex = index;
      }

      updatedArtworks[artworkIndex] = { ...updatedArtworks[artworkIndex], ...plain };
      if (Object.keys(lazy).length) {
        const resolved: Record<string, unknown> = {};
        for (const [k, fn] of Object.entries(lazy)) resolved[k] = fn();
        updatedArtworks[artworkIndex] = { ...updatedArtworks[artworkIndex], ...resolved };
      }
      this.artworksState = updatedArtworks;
    },
    updateArtworkValuesById({ id, ...values }: { id: number | string; [key: string]: unknown }) {
      if (!this.artworksState.length) {
        return;
      }
      const updatedArtworks = [...this.artworksState];
      const index = findIndexById(updatedArtworks, id);

      // Guard: verify the artwork at index actually has the matching id
      // findIndexById returns 0 when not found, which could update wrong artwork
      if (!updatedArtworks[index] || String(updatedArtworks[index].id) !== String(id)) {
        return;
      }

      const preparedArtwork = objNamesToCamelCase(values, MIXPANEL_METADATA_KEYS);

      updatedArtworks[index] = { ...updatedArtworks[index], ...preparedArtwork };
      // @ts-ignore TS(TS4111)
      if (values.metadata && !preparedArtwork.width) {
        // @ts-ignore TS(TS18046)
        updatedArtworks[index].width = preparedArtwork.metadata.widthInch;
        // @ts-ignore TS(TS18046)
        updatedArtworks[index].height = preparedArtwork.metadata.heightInch;
      }
      if (Object.prototype.hasOwnProperty.call(values, "removeBackground")) {
        // @ts-ignore TS(TS4111)
        updatedArtworks[index].metadata.removeBackground = values.removeBackground;
      }
      this.artworksState = updatedArtworks;
    },
    setRemovalFile(id: number | string) {
      this.fileToRemove = id;
    },
    setPreCut(preCut: boolean) {
      this.preCut = preCut;
    },
    setPreCutPrice(price: number) {
      this.preCutPrice = price;
    },
    setPreCutEnabled(preCutEnabled: boolean) {
      this.preCutEnabled = preCutEnabled;
    },
    setPreCutDuration(preCutDuration: string | null) {
      this.preCutDuration = preCutDuration;
    },
    setLoadFromConfig(loadFromConfig: boolean) {
      this.loadFromConfig = loadFromConfig;
    },
    setEnablePreCut() {
      this.enablePreCut = true;
    },
    resetRemovalFile() {
      this.fileToRemove = null;
    },
    reindexArtworks() {
      this.artworksState = this.artworksState.map((artwork: ArtworkItem, newIndex: number) => ({
        ...artwork,
        originalIndex: newIndex
      }));
    },
    removeArtwork(id: number | string) {
      if (id) {
        transfersPollingService.stopPolling(Number(id));
        this.clearValidateArtworkStartEventInterval(id);
        // MN-4782: drop stuck/timed-out flags when the artwork is removed so
        // Add-to-Cart isn't kept disabled by a flag that has no backing artwork.
        this.clearEnhancementStuck(id);
        this.clearEnhancementTimedOut(id);
      }

      const artworkToRemove = this.artworksState.find((artwork: ArtworkItem) => artwork.id === id);
      this.cancelPinningSessionForArtwork(artworkToRemove, {
        errorMessage: "Failed to cancel pinning session on artwork removal"
      });

      this.artworksState = this.artworksState.filter((artwork: ArtworkItem) => artwork.id !== id);

      // Reindex remaining artworks to maintain consistent originalIndex values
      this.reindexArtworks();

      this.fileToRemove = null;
      if (this.sticker) {
        this.simulation = { ...this.simulation, width: null, height: null };
      }
      this.spangles = { ...this.spangles, completedSpangleData: [] };
      if (!this.artworksState.length) {
        this.showModal = false;
      }
    },
    clearWorkspace() {
      this.cleanupPolling();

      this.artworksState = [];
      this.summary = initialState.summary;
      this.simulation = { ...DEFAULT_SIMULATION_ARTWORK };
    },
    openModal() {
      this.showModal = true;
    },
    hideModal() {
      this.showModal = false;
    },
    setShowCTA(showCTA: boolean) {
      this.showCTA = showCTA;
    },
    setAllowForceBgRemove(allowForceBgRemove: boolean) {
      this.allowForceBgRemove = allowForceBgRemove;
    },
    setCanvaDtfEnabled(canvaDtfEnabled: boolean) {
      this.canvaDtfEnabledState = canvaDtfEnabled;
    },
    setEnableMobileFooterCTA(enableMobileFooterCTA: boolean) {
      this.enableMobileFooterCTA = enableMobileFooterCTA;
    },
    setCanvaReviewer(canvaReviewer: unknown) {
      this.canvaReviewer = canvaReviewer;
    },
    setVariantId(variantId: number | null) {
      this.variantId = variantId;
    },
    setProductId(productId: number | null) {
      this.productId = productId;
    },
    setProductSlug(productSlug: string) {
      this.productSlug = productSlug;
    },
    setFavorites(favorites: number[]) {
      this.favorites = favorites;
    },
    setPdpType(pdpType: string | null) {
      this.pdpType = pdpType;
    },
    setCatalogNumber(catalogNumber: string | null) {
      this.catalogNumber = catalogNumber;
    },
    setMessagingConsents(messagingConsents: unknown[]) {
      this.messagingConsents = messagingConsents;
    },
    setPrintAsIs(printAsIs: boolean) {
      this.printAsIs = printAsIs;
    },
    setNeckLabel(neckLabel: boolean) {
      this.neckLabel = neckLabel;
    },
    setSticker(sticker: Record<string, unknown> | null) {
      this.sticker = sticker;
    },
    setStickerQrScanned(stickerQrScanned: boolean) {
      this.stickerQrScanned = stickerQrScanned;
    },
    setDtfMaxWidth(dtfMaxWidth: number | null) {
      this.dtfMaxWidth = dtfMaxWidth;
    },
    setDtfMaxHeight(dtfMaxHeight: number | null) {
      this.dtfMaxHeight = dtfMaxHeight;
    },
    setDtfMinWidth(dtfMinWidth: number | null) {
      this.dtfMinWidth = dtfMinWidth;
    },
    setDtfMinHeight(dtfMinHeight: number | null) {
      this.dtfMinHeight = dtfMinHeight;
    },
    setIsRetrying(isRetrying: boolean) {
      this.isRetrying = isRetrying;
    },
    setRetryFailed(value: unknown) {
      this.artworksState = this.artworksState.map((artwork: ArtworkItem) =>
        artwork.id ? artwork : { ...artwork, retryFailed: value }
      );
    },
    setIsLoading(value: unknown) {
      this.artworksState = this.artworksState.map((artwork: ArtworkItem) =>
        artwork.id ? artwork : { ...artwork, isLoading: value }
      );
    },
    setShowDiscardModal() {
      this.showDiscardModal = true;
    },
    hideDiscardModal() {
      this.showDiscardModal = false;
    },
    cancelPinningSessionForArtwork(
      // @ts-ignore TS(TS7006)
      artwork,
      { errorMessage = "Failed to cancel pinning session" } = {}
    ) {
      if (!artwork?.pinningSessionId) return;

      const artworkId = artwork.id;
      const sessionId = artwork.pinningSessionId;

      cancelSession(sessionId)
        .then(() => {
          trackTransfersPinningInstructionsRemoved({
            artworkId,
            sessionId
          });
        })
        .catch(error => {
          notifyError(errorMessage, {
            context: { artworkId, sessionId, error }
          });
        });
    },
    dropMultiArtwork() {
      this.showModal = false;
      this.summary = initialState.summary;
      const discardedArtworks = [...this.artworksState];
      const notUploadedArtworks = this.artworksState.filter(
        (artwork: ArtworkItem) => artwork.isFile || artwork.isLoading
      );

      discardedArtworks.forEach(artwork => {
        this.cancelPinningSessionForArtwork(artwork, {
          errorMessage: "Failed to cancel pinning session on artwork discard"
        });
      });

      this.artworksState = [];
      const initialValuesForSize = this.printAsIs ? GANG_DEFAULT_VALUES : DEFAULT_VALUES;
      this.simulation = { ...DEFAULT_SIMULATION_ARTWORK, ...initialValuesForSize };

      this.cleanupPolling();

      if (!notUploadedArtworks.length) return;
      this.discarded = new Date();
      this.fetchController?.abort();
      this.fetchController = null;
    },
    removeArtworkByIndex(index: number) {
      const artworkToRemove = this.artworksState.find(
        // @ts-ignore TS(TS4111)
        (artwork: ArtworkItem) => artwork.originalIndex === index
      );
      if (artworkToRemove?.id) {
        transfersPollingService.stopPolling(artworkToRemove.id);
        this.clearValidateArtworkStartEventInterval(artworkToRemove.id);
        // MN-4782: mirror removeArtwork — clear stuck/timed-out flags here too.
        this.clearEnhancementStuck(artworkToRemove.id);
        this.clearEnhancementTimedOut(artworkToRemove.id);
      }

      this.artworksState = this.artworksState.filter(
        // @ts-ignore TS(TS4111)
        (artwork: ArtworkItem) => artwork.originalIndex !== index
      );

      // Reindex remaining artworks to maintain consistent originalIndex values
      this.reindexArtworks();

      if (!this.artworksState.length) {
        this.showModal = false;
      }

      if (this.artworksState.length && artworkToRemove?.imageTooSmall) {
        this.getArtworksPricing();
      }
    },
    removeAllErrorArtworks() {
      const errorArtworks = this.artworksState.filter((artwork: ArtworkItem) =>
        isPurgeableUploadError(artwork)
      );
      for (const artwork of errorArtworks) {
        if (artwork.id) {
          transfersPollingService.stopPolling(artwork.id);
          this.clearValidateArtworkStartEventInterval(artwork.id);
        }
      }

      this.artworksState = this.artworksState.filter(
        (artwork: ArtworkItem) => !isPurgeableUploadError(artwork)
      );

      this.reindexArtworks();

      if (!this.artworksState.length) {
        this.showModal = false;
      }
    },
    setEmptyArtwork(id: unknown) {
      this.artworksState = [
        ...this.artworksState,
        {
          ...emptyArtworkItem,
          id,
          isLoading: true,
          isFile: false,
          originalIndex: this.artworksState.length
        }
      ];
    },
    setDiscarded(value: unknown) {
      this.discarded = value;
    },
    setFetchController(signal: AbortController | null) {
      this.fetchController = signal;
    },
    setUseDefaultValues(useDefaultValues: unknown[]) {
      this.useDefaultValues = useDefaultValues;
    },
    setValidationErrorMessage({
      index,
      message,
      isMultiSizeError,
      type
    }: {
      index: number;
      message: unknown;
      isMultiSizeError: boolean;
      type: unknown;
    }) {
      const error = {
        errorMessage: message,
        isMultiSizeError,
        isValid:
          !type ||
          // @ts-ignore TS(TS2339)
          !Object.values(ErrorTypes).some(symbol => symbol.description === type.description)
      };

      if (type !== undefined) {
        // @ts-ignore TS(TS2339)
        error.errorType = type;
      }

      if (!this.artworksState.length) {
        this.simulation = {
          ...this.simulation,
          ...error
        };
        return;
      }

      const updatedArtworks = [...this.artworksState];
      if (!updatedArtworks[index]) return;

      updatedArtworks[index] = { ...updatedArtworks[index], ...error };
      this.artworksState = updatedArtworks;
      this.artworksState = [...this.artworksState];
    },
    setLocale(locale: string) {
      this.locale = locale;
    },
    setReplaceArtwork(replace: boolean) {
      this.replaceArtwork = replace;
    },
    resetFilesError() {
      this.showFilesError = false;
    },
    setShowArtworkHistoryModal(show: boolean) {
      this.showArtworkHistoryModal = show;
    },
    setArtworkHistory(history: Record<string, unknown>[]) {
      this.artworkHistory = history;
    },
    setArtworkHistoryPagination(pageInfo: Record<string, unknown>) {
      this.artworkHistoryPagination = { ...this.artworkHistoryPagination, ...pageInfo };
    },
    setUserType(type: unknown) {
      this.userType = type;
    },
    setBogoEligibility(eligibility: { visible: boolean; reason: string | null }) {
      this.bogoEligibility = eligibility;
    },
    setBogoMaxDimensionLabel(label: string) {
      this.bogoMaxDimensionLabel = label;
    },
    setPromotionResolution(resolution: { winner: string }) {
      this.promotionResolution = resolution;
    },
    setIsMobile(isMobile: boolean) {
      this.isMobile = isMobile;
    },
    setPrintingServiceName(printingServiceName: string | null) {
      this.printingServiceName = printingServiceName;
    },
    setDtfChannelUuid(uuid: unknown) {
      this.dtfChannelUuid = uuid;
    },
    setActionCableOptions(options: Record<string, unknown>) {
      this.actionCableOptions = options;
    },
    setActionCableConnected(value: unknown) {
      this.actionCableConnected = value;
    },

    async handlePollingEnhancementComplete(artwork: ArtworkItem) {
      const artworkIndex = this.artworks.findIndex(
        (a: ArtworkItem) => Number(a.id) === Number(artwork.id)
      );
      if (artworkIndex === -1) {
        return;
      }

      this.clearValidateArtworkStartEventInterval(artwork.id);
      this.updateEnhancedArtwork(artwork);

      this.updatePrintReadyInfoState(artwork.id);
      this.updatePreviewDpi({ artworkId: artwork.id });
      await this.downscaleOriginalImage({ artworkId: artwork.id }).catch((err: unknown) => {
        console.warn("[DTF] downscaleOriginalImage failed, continuing:", err);
      });

      if (this.isGoldFoil) {
        this.generateGoldFoilImages({ artworkId: artwork.id });
        this.convertImageToHexColor({ artwork });
      }

      if (!this.artworks.some((a: ArtworkItem) => a.isLoading)) {
        this.getArtworksPricing();
      }

      this.dispatchTrackingEvents(artwork);
    },
    dispatchTrackingEvents(artwork: ArtworkItem) {
      const existingArtwork = this.artworks.find(
        (a: ArtworkItem) => Number(a.id) === Number(artwork.id)
      );
      if (existingArtwork?.imageProcessingCompletedEventSent) {
        return;
      }

      submitDtfEvent("image_processing_completed", {
        payload: {
          process_data: artwork,
          stream_name: `dtf_channel_${this.dtfChannelUuid}`,
          action_type: "enhancement_complete",
          worker_enhancement: true
        },
        business_line: "transfers",
        artwork_id: artwork.id,
        completion_source: "polling_fallback"
      });

      trackRudderstackImageProcessingCompleted({
        // @ts-ignore TS(TS2322)
        artwork_id: artwork.id,
        // @ts-ignore TS(TS4111)
        dpi: artwork.metadata?.dpi,
        // @ts-ignore TS(TS4111)
        location: artwork.metadata?.uploaded_on,
        file_name: artwork.filename,
        file_type: artwork.filetype,
        file_size: artwork.filesize,
        business_line: this.businessLine,
        artworks_count: this.artworks.length,
        pre_cut_transfers: this.preCut
      });

      // PIP-3054: Emit procolor routable event when image processing completes.
      // De-duped by the imageProcessingCompletedEventSent guard at the top of this method.
      // Polling-path source is DtfArtworkListSerializer, which omits routing details —
      // delta_e/threshold/profile/percentile will be null on this path.
      submitProcolorRoutableTaggedForArtwork(artwork, {
        multiArtwork: this.artworks.length > 1
      });

      this.updateArtworkValuesById({
        id: artwork.id,
        imageProcessingCompletedEventSent: true
      });

      // @ts-ignore TS(TS2322)
      api.dtf.acknowledgeArtwork({ id: artwork.id }, undefined, { silent: true }).catch(() => {
        // Expected: 422 while enhancement is still processing (HB-1851)
      });
    },
    setMockupColorForArtwork(artwork: ArtworkItem) {
      // @ts-ignore TS(TS4111)
      const whitePixelsRatio = Number(artwork.metadata?.white_pixels_ratio || 0);
      const artworkIndex = this.artworks.findIndex((item: ArtworkItem) => item.id === artwork.id);
      if (artworkIndex !== -1) {
        this.setPresetMockupColor({
          index: artworkIndex,
          color: whitePixelsRatio > 50 ? "#000000" : "#E1E1E1"
        });
      }
    },
    getEnhancedArtworkImageUrls(artwork: ArtworkItem) {
      if (artwork.manualEditUrl) {
        return {
          imageUrl: artwork.manualEditUrl,
          enhancedImageUrl: artwork.manualEditUrl,
          url: artwork.manualEditUrl,
          // @ts-ignore TS(TS4111)
          sliderPreviewUrl: artwork.manualEditNoTrimUrl || artwork.manualEditUrl,
          previewUrl: artwork.manualEditUrl,
          displayUrl: artwork.manualEditUrl,
          trimmedWithBgUrl: artwork.manualEditUrl,
          trimmedNoBgUrl: artwork.manualEditUrl,
          trimmedImageUrl: artwork.manualEditUrl
        };
      }

      // @ts-ignore TS(TS4111)
      const useNoBg = artwork.removeBackground || artwork.metadata?.remove_background;
      const imageUrl = useNoBg
        ? // @ts-ignore TS(TS4111)
          artwork.noBgUrl || artwork.imageUrl
        : // @ts-ignore TS(TS4111)
          artwork.withBgUrl || artwork.imageUrl;
      // @ts-ignore TS(TS4111)
      const enhancedImageUrl = artwork.noBgUrl || artwork.imageUrl;

      return {
        imageUrl,
        enhancedImageUrl,
        url: imageUrl,
        sliderPreviewUrl: artwork.noBgNoTrimUrl || artwork.noBgUrl,
        previewUrl: imageUrl,
        displayUrl: imageUrl,
        trimmedWithBgUrl: artwork.withBgUrl,
        trimmedNoBgUrl: artwork.noBgUrl,
        trimmedImageUrl: imageUrl
      };
    },
    getEnhancedArtworkDimensions(artwork: ArtworkItem) {
      // @ts-ignore TS(TS4111)
      const useNoBg = artwork.removeBackground || artwork.metadata?.remove_background;
      const correctMetadata = useNoBg
        ? artwork.enhancedMetadata || artwork.metadata
        : artwork.withBgMetadata || artwork.metadata;
      // @ts-ignore TS(TS4111)
      const widthInch = correctMetadata?.width_inch || correctMetadata?.widthInch;
      // @ts-ignore TS(TS4111)
      const heightInch = correctMetadata?.height_inch || correctMetadata?.heightInch;

      return {
        width: widthInch,
        height: heightInch,
        // @ts-ignore TS(TS4111)
        originalWidth: artwork.originalMetadata?.width_inch || artwork.originalMetadata?.widthInch,
        originalHeight:
          // @ts-ignore TS(TS4111)
          artwork.originalMetadata?.height_inch || artwork.originalMetadata?.heightInch
      };
    },
    // Preserve existing sizesAndQuantities on enhancement-complete. The Custom Size
    // seed from emptyArtworkItem is stripped by handlePresetSelect when the user
    // picks a named preset.
    getEnhancedArtworkSizes(artwork: ArtworkItem, _dimensions: unknown[]) {
      const existingArtwork = this.artworks.find((a: ArtworkItem) => a.id === artwork.id);
      const sizesAndQuantities = existingArtwork?.sizesAndQuantities || [];

      return sizesAndQuantities;
    },
    updateEnhancedArtwork(artwork: ArtworkItem) {
      this.setLoadedArtwork({ artwork });
      this.setMockupColorForArtwork(artwork);

      const dimensions = this.getEnhancedArtworkDimensions(artwork);
      const imageUrls = this.getEnhancedArtworkImageUrls(artwork);
      const sizesAndQuantities = this.getEnhancedArtworkSizes(artwork, dimensions);

      this.updateArtworkValuesById({
        id: artwork.id,
        enhancementCompleted: true,
        enhancedNoBgUrl: artwork.noBgUrl,
        enhancedWithBgUrl: artwork.withBgUrl,
        ...imageUrls,
        ...dimensions,
        metadata: artwork.metadata,
        enhancedMetadata: artwork.enhancedMetadata,
        originalMetadata: artwork.originalMetadata,
        withBgMetadata: artwork.withBgMetadata,
        canRemoveBg: artwork.canRemoveBg,
        // @ts-ignore TS(TS4111)
        removeBackground: artwork.removeBackground || artwork.metadata?.remove_background,
        originalImageUrl: artwork.originalImageUrl,
        // @ts-ignore TS(TS4111)
        originalMime: artwork.metadata?.mime_type,
        // @ts-ignore TS(TS4111)
        enhancedDpi: artwork.metadata?.dpi,
        // @ts-ignore TS(TS4111)
        originalDpi: artwork.originalMetadata?.dpi || 300,
        enhanceImage: true,
        lastWebSocketEvent: "enhancement_complete_via_polling",
        lastWebSocketEventData: {
          source: "polling_fallback",
          data: artwork
        },
        isLoading: false,
        progress: 100,
        progressMessage: "Complete",
        sizesAndQuantities
      });
    },
    handleWebSocketEnhancementComplete(artworkId: number | string | null) {
      if (artworkId != null) {
        transfersPollingService.stopPolling(Number(artworkId));
        this.clearEnhancementStuck(artworkId);
        this.clearEnhancementTimedOut(artworkId);
      }
    },
    cleanupPolling() {
      transfersPollingService.stopAllPolling();
      // MN-4782: drop stale flag maps on teardown. Without this, a previous
      // PDP visit's timed-out artwork could leave hasArtworkEnhancementTimedOut
      // returning true on the next visit — blocking Add-to-Cart with no
      // visible timed-out artwork to explain why.
      this.enhancementStuckAt60s = {};
      this.enhancementTimedOut = {};
    },
    schedulePollingFallback(
      artworkId: number | string,
      { initialDelay }: { initialDelay?: number } = {}
    ) {
      artworkId = Number(artworkId);
      if (!artworkId || !transfersPollingService.isPollingEnabled(this.catalogNumber)) return;

      const artworkExists = this.artworks.some(
        (artwork: ArtworkItem) => artwork.id && Number(artwork.id) === Number(artworkId)
      );

      if (!artworkExists) {
        return;
      }

      // If polling is already active and a shorter delay is requested (e.g. WS disconnect),
      // restart polling with the new delay. Otherwise, skip if already polling.
      if (transfersPollingService.isPolling(artworkId)) {
        if (initialDelay !== undefined) {
          transfersPollingService.stopPolling(artworkId);
        } else {
          return;
        }
      }

      transfersPollingService.startPolling(
        artworkId,
        (enhancedArtwork: Record<string, unknown>) => {
          this.handlePollingEnhancementComplete(enhancedArtwork).catch((err: unknown) => {
            console.error("[DTF] handlePollingEnhancementComplete error:", err);
            notifyError("DTF polling enhancement complete handler error", {
              params: { error: String(err) }
            });
          });
        },
        {
          catalogNumber: this.catalogNumber,
          dtfChannelUuid: this.dtfChannelUuid,
          checkArtworkExists: (id: number | string) =>
            this.artworks.some(
              (artwork: ArtworkItem) => artwork.id && Number(artwork.id) === Number(id)
            ),
          onTimeout: (id: number | string) => {
            this.setEnhancementTimedOut(Number(id));
          },
          ...(initialDelay !== undefined && { initialDelay })
        }
      );
    },
    setSpangleAlgorithms(algorithms: unknown[]) {
      this.spangleConfig = { ...this.spangleConfig, spangleAlgorithms: algorithms };
    },
    setIsSpangle(isSpangle: boolean) {
      this.spangleConfig = { ...this.spangleConfig, isSpangle };
    },
    setSpangleColors(spangleColors: unknown[]) {
      this.spangleConfig = { ...this.spangleConfig, spangleColors };
    },
    setCable(cable: unknown) {
      this.cable = cable;
    },
    setBusinessLine(businessLine: string | null) {
      this.businessLine = businessLine;
    },
    setIsPuff(isPuff: boolean) {
      this.isPuff = isPuff;
    },
    setIsProColor(isProColor: boolean) {
      this.isProColor = isProColor;
    },
    setCmykSoftProofEnabled(cmykSoftProofEnabled: boolean) {
      this.cmykSoftProofEnabled = cmykSoftProofEnabled;
    },
    setIsSticker(isSticker: boolean) {
      this.isSticker = isSticker;
    },
    setIsDieCutSticker(isDieCutSticker: boolean) {
      this.isDieCutSticker = isDieCutSticker;
    },
    setIsJiffyMade(isJiffyMade: boolean) {
      this.isJiffyMade = isJiffyMade;
    },
    setIsStickerSample(isStickerSample: boolean) {
      this.isStickerSample = isStickerSample;
    },
    setMinStickerQuantity(minStickerQuantity: number) {
      this.minStickerQuantity = minStickerQuantity;
    },
    setIsLetters(isLetters: boolean) {
      this.isLetters = isLetters;
    },
    // @ts-ignore TS(TS7031)
    toggleLoading([key, value]) {
      this.loading = { ...this.loading, [key]: value };
    },
    setExperiments(experiments: Record<string, number>) {
      this.experiments = experiments;
    },
    setDtfCategory(dtfCategory: string | null) {
      this.dtfCategory = dtfCategory;
    },
    setPreCutUpsellThreshold(preCutUpsellThreshold: number | null) {
      this.preCutUpsellThreshold = Number(preCutUpsellThreshold);
    },
    setPuff(puffData: Record<string, unknown>) {
      this.puff = { ...this.puff, ...puffData };
    },
    resetPuff() {
      this.puff = { ...DEFAULT_PUFF_VALUES };
    },
    setIsJerseyNumbers(isJerseyNumbers: boolean) {
      this.isJerseyNumbers = isJerseyNumbers;
    },
    setPrintReadyInfoShow(show: boolean) {
      this.printReadyInfoConfig = { ...this.printReadyInfoConfig, show };
    },
    setPrintReadyInfoExpandable(expanded: unknown) {
      this.printReadyInfoConfig = { ...this.printReadyInfoConfig, expanded };
    },
    setArtworkBackground(color: unknown) {
      this.artworkBackground = color;
    },
    setBackgroundType(backgroundType: string | null) {
      this.backgroundType = backgroundType;
    },
    setPreviewCanvasSize({ width, height }: { width: unknown; height: unknown }) {
      const prev = this.previewCanvasSize;
      if (prev && prev.width === width && prev.height === height) return;
      this.previewCanvasSize = { width, height };
    },
    setLetterPreviewMessage({
      textIndex,
      message
    }: {
      textIndex: number | null;
      message: unknown;
    }) {
      // @ts-ignore TS(TS2464)
      this.letterPreviewMessages = { ...this.letterPreviewMessages, [textIndex]: message };
    },
    clearLetterPreviewMessages() {
      this.letterPreviewMessages = {};
    },
    removeLetterPreviewMessage(index: number) {
      const letterPreviewMessagesCopy = { ...this.letterPreviewMessages };

      delete letterPreviewMessagesCopy[index];

      this.letterPreviewMessages = Object.entries(letterPreviewMessagesCopy).reduce(
        (newMessages, [, value], newIndex) => {
          // @ts-ignore TS(TS7053)
          newMessages[newIndex] = value;
          return newMessages;
        },
        {}
      );
    },
    setLetterPreviewLoading(value: unknown) {
      this.letterPreviewLoading = value;
    },
    setIsGoldFoil(value: unknown) {
      this.isGoldFoil = value;
    },
    setForcePdpTransfersRedraw(value: boolean) {
      this.forcePdpTransfersRedraw = value;
    },
    setPinBasedRedrawEnabled(value: boolean) {
      this.pinBasedRedrawEnabled = value;
    },
    setPinBasedRedrawEscaped(value: boolean) {
      this.pinBasedRedrawEscaped = value;
    },
    setEnableRedraw(value: boolean) {
      this.enableRedraw = value;
    },
    setIsPricingLoading(value: boolean) {
      this.isPricingLoading = value;
    },
    setShowMultiSize(value: unknown) {
      this.showMultiSizeArtwork = value;
    },
    setGangSheetBuilder(value: unknown) {
      this.gangSheetBuilder = value;
    },
    setShowGangSheetBuilder(value: unknown) {
      this.showGangSheetBuilder = value;
    },
    setGeneratedGangSheets(value: unknown) {
      this.generatedGangSheets = value;
    },
    setGangSheetBuilderShopId(value: unknown) {
      this.gangSheetBuilderShopId = value;
    },
    setShowGangSheetBuilderFeature(value: unknown) {
      this.showGangSheetBuilderFeature = value;
    },
    setIsGangSheetBuilder(value: unknown) {
      this.isGangSheetBuilder = value;
    },
    setGangSheetBuilderVariants(value: unknown) {
      this.gangSheetBuilderVariants = value;
    },
    updateGangSheetBuilderSettings(value: unknown) {
      this.gangSheetBuilderSettings = {
        ...this.gangSheetBuilderSettings,
        // @ts-ignore TS(TS2698)
        ...value
      };
    },
    setReorderEnabled(value: unknown) {
      this.reorderEnabled = value;
    },
    setIsDtfSheet(value: unknown) {
      this.isDtfSheet = value;
    },
    setGangSheetBulkPrice(value: unknown) {
      this.gangSheetBulkPrice = {
        ...this.gangSheetBulkPrice,
        // @ts-ignore TS(TS2698)
        ...value
      };
    },
    setGangSheetBuilderSizes(value: unknown) {
      this.gangSheetBuilderSizes = value;
    },
    setStoreCreditInfo(info: Record<string, unknown>) {
      this.storeCreditInfo = info;
    },
    setPresetMockupColor({ index, color }: { index: number; color: unknown }) {
      const updated = [...this.presetMockupColor];
      updated[index] = color;
      this.presetMockupColor = updated;
    },
    removePresetMockupColor(index: number) {
      const updated = [...this.presetMockupColor];
      updated.splice(index, 1);
      this.presetMockupColor = updated;
    },
    setGangSheetBuilderCarousels(value: unknown) {
      this.gangSheetBuilderCarousels = value;
    },
    setPreloadedDesignId(value: unknown) {
      this.preloadedDesignId = value;
    },
    setValidateArtworkStartTime(artworkId: number | string, time: number) {
      this.validateArtworkStartTime = { ...this.validateArtworkStartTime, [artworkId]: time };
    },
    setValidateArtworkStartEventIntervalID(artworkId: number | string | null, id: unknown) {
      const prev = { ...this.validateArtworkStartEventIntervalID };
      // @ts-ignore TS(TS2538)
      prev[artworkId] = id;
      this.validateArtworkStartEventIntervalID = prev;
    },
    setPaidExpertEditAddonEnabled(value: unknown) {
      this.paidExpertEditAddonEnabled = value;
    },
    setKlaviyoSmsTransactionalSubscribed(value: boolean) {
      this.klaviyoSmsTransactionalSubscribed = value;
    },
    setSmsTransactionalSubscriptionPdpEnabled(value: boolean) {
      this.smsTransactionalSubscriptionPdpEnabled = value;
    },
    setSmsTransactionalPhone(value: unknown) {
      this.smsTransactionalPhone = value;
    },
    setSmsTransactionalSubscribeButtonText(value: unknown) {
      this.smsTransactionalSubscribeButtonText = value;
    },
    setGangSheetCatalogNumbers(catalogNumbers: string[]) {
      this.gangSheetCatalogNumbers = catalogNumbers;
    },
    setCustomerReviewOnRedraws(value: unknown) {
      this.customerReviewOnRedraws = value;
    },
    setCustomerReviewOnTransferRedraws(value: unknown) {
      this.customerReviewOnTransferRedraws = value;
    },
    setPinSessionRecording(value: unknown) {
      this.pinSessionRecording = value;
    },
    setPinSessionForceMixpanelRecording(value: unknown) {
      this.pinSessionForceMixpanelRecording = value;
    },

    setTransferPdpBackButtonDetection(value: boolean) {
      this.transferPdpBackButtonDetection = value;
    },
    // @ts-ignore TS(TS7006)
    async openPinningSession(artworkIndex, initialMessage = null, userType = undefined) {
      const artwork = this.artworks[artworkIndex];
      if (!artwork) return;

      trackTransfersPinsCtaClicked({ artworkId: artwork.id, ...(userType ? { userType } : {}) });
      startPinSessionRecording({
        enabled: this.pinSessionRecording,
        forceMixpanelRecording: this.pinSessionForceMixpanelRecording
      });
      this.pinningArtworkIndex = artworkIndex;
      this.pinningSessionLoading = true;
      try {
        const previewImageName = getArtworkPreviewImageName(artwork);
        const result = await createSession(String(artwork.id), { previewImageName });
        this.pinningModalSessionId = result["sessionId"];
        this.pendingInitialMessage = initialMessage;
        this.showPinningModal = true;
      } catch {
        this.pinningArtworkIndex = null;
        this.pinningModalSessionId = null;
        this.pendingInitialMessage = null;
      } finally {
        this.pinningSessionLoading = false;
      }
    },
    editPinningSession(artworkIndex: number | null) {
      // @ts-ignore TS(TS2538)
      const artwork = this.artworks[artworkIndex];
      if (!artwork?.pinningSessionId) return;

      trackPinsSessionSummaryEditClicked({
        artworkId: artwork.id,
        sessionId: artwork.pinningSessionId
      });
      this.pinningArtworkIndex = artworkIndex;
      this.pinningModalSessionId = artwork.pinningSessionId;
      this.showPinningModal = true;
    },
    closePinningSession() {
      this.showPinningModal = false;
      this.pinningArtworkIndex = null;
      this.pinningModalSessionId = null;
      this.pendingInitialMessage = null;
    },
    completePinningSession({
      artworkIndex,
      sessionId,
      summary,
      state
    }: {
      artworkIndex: number | null;
      sessionId: number | string | null;
      summary: unknown;
      state: unknown;
    }) {
      // @ts-ignore TS(TS2538)
      const artwork = this.artworks[artworkIndex];
      if (artwork) {
        this.updateArtworkValuesById({
          id: artwork.id,
          pinningSessionId: sessionId,
          pinningSummary: summary,
          pinningSessionState: state ?? "completed"
        });
      }
    },
    clearPinningSession(artworkIndex: number | null) {
      // @ts-ignore TS(TS2538)
      const artwork = this.artworks[artworkIndex];
      if (!artwork) return;

      this.clearPinningSessionFromArtwork(artwork);
    },
    clearPinningSessionFromArtwork(artwork: ArtworkItem) {
      this.cancelPinningSessionForArtwork(artwork);

      if (artwork.manualEditUrl) {
        this.clearManualEdit(artwork);
      }

      this.updateArtworkValuesById({
        id: artwork.id,
        pinningSessionId: null,
        pinningSummary: null,
        pinningSessionState: null
      });
    },
    clearManualEdit(artwork: ArtworkItem) {
      this.updateArtworkValuesById({
        id: artwork.id,
        manualEditUrl: null,
        manualEditNoTrimUrl: null
      });

      if (artwork.id) {
        const formData = new FormData();
        formData.append("manual_edit", "false");
        formData.append("remove_background", String(artwork.removeBackground || false));
        formData.append("start_new_edit", "false");

        api.dtf
          // @ts-ignore TS(TS2322)
          .completeRefineSession({ dtf_artwork_id: artwork.id }, formData, {
            raw: true,
            useAxiosForRequest: true,
            headers: { "Content-Type": undefined }
          })
          .catch((error: unknown) => {
            notifyError("Failed to clear manual edit", {
              context: { artworkId: artwork.id, error }
            });
          });
      }
    },
    setPendingPinningInvalidation(change: unknown) {
      this.pendingPinningInvalidation = change;
    },
    /* eslint-disable-next-line max-lines-per-function */
    confirmPinningInvalidation() {
      const pending = this.pendingPinningInvalidation;
      if (!pending) return;

      const artwork = this.artworks.find(
        ({ id }: ArtworkItem) => String(id) === String(pending.artworkId)
      );
      if (artwork) {
        this.clearPinningSessionFromArtwork(artwork);
      }

      // Execute the pending change directly
      if (pending.type === "enhancementTier" && artwork) {
        const enhancementTier = pending.value;
        if (artwork.enhancementCompleted) {
          this.updateEnableEnhancement({
            artworkId: artwork.id,
            enableEnhancement: enhancementTier !== "print_original",
            enhancementTier
          });
        } else {
          this.updateArtworkValuesById({
            id: artwork.id,
            enhancementTier,
            pricing: this.cachedArtworkPrices[enhancementTier] || {},
            hasExpertEditAddon: artwork.hasExpertEditAddon
          });
        }
      } else if (pending.type === "enableEnhancement" && artwork) {
        this.updateEnableEnhancement({
          artworkId: artwork.id,
          enableEnhancement: pending.value
        });
        if (pending.section) {
          this.lastConfirmedConfigSection = {
            artworkId: artwork.id,
            section: pending.section
          };
        }
      } else if (pending.type === "removeBackground" && artwork) {
        this.updateArtworkStyle({ id: artwork.id, isBgRemoved: pending.value });
        const paddingSize = artwork.paddingSize || "no_padding";
        this.sendUpdateArtworkStyle({
          id: artwork.id,
          isBgRemoved: pending.value,
          padding_size: paddingSize,
          forceBgRemoval: false
        });
      }

      this.pendingPinningInvalidation = null;
    },
    cancelPinningInvalidation() {
      this.pendingPinningInvalidation = null;
    },
    clearValidateArtworkStartEventInterval(artworkId: number | string) {
      this.validateArtworkStartTime = { ...this.validateArtworkStartTime, [artworkId]: null };
      clearInterval(this.validateArtworkStartEventIntervalID[artworkId]);
      const prevIntervalIds = { ...this.validateArtworkStartEventIntervalID };
      prevIntervalIds[artworkId] = null;
      this.validateArtworkStartEventIntervalID = prevIntervalIds;
    },
    // MN-4782
    setEnhancementStuck(artworkId: number | string) {
      // Idempotency guard — handleValidateArtworkProgress ticks every 1s past
      // the 60s threshold. Without this every tick spreads a fresh object and
      // triggers ~120 unnecessary React re-renders across the 2-minute window
      // before MAX_POLLING_DURATION. Mirrors the guard on setEnhancementTimedOut.
      const prev = this.enhancementStuckAt60s as Record<string, boolean>;
      const key = String(artworkId);
      if (prev[key]) return;
      this.enhancementStuckAt60s = { ...prev, [key]: true };
    },
    clearEnhancementStuck(artworkId: number | string) {
      const prev = this.enhancementStuckAt60s as Record<string, boolean>;
      if (!(String(artworkId) in prev)) return;
      const next = { ...prev };
      delete next[String(artworkId)];
      this.enhancementStuckAt60s = next;
    },
    setEnhancementTimedOut(artworkId: number | string) {
      const prev = this.enhancementTimedOut as Record<string, boolean>;
      if (prev[String(artworkId)]) return;
      this.enhancementTimedOut = { ...prev, [String(artworkId)]: true };
      submitDtfEvent("enhancement_timeout_visible_to_user", {
        dtf_channel_uuid: this.dtfChannelUuid,
        artwork_id: artworkId
      });
    },
    clearEnhancementTimedOut(artworkId: number | string) {
      const prev = this.enhancementTimedOut as Record<string, boolean>;
      if (!(String(artworkId) in prev)) return;
      const next = { ...prev };
      delete next[String(artworkId)];
      this.enhancementTimedOut = next;
    },
    async addSampleToCart() {
      const payload = {
        ...getFormPayload(),
        sample_pack: true,
        artworks: [
          {
            artwork_id: 0,
            width: 1,
            height: 1,
            quantity: 1,
            variant_id: this.variantId,
            sample_pack: true
          }
        ]
      };

      api.dtf.addToCart(payload).then((_res: Record<string, unknown>) => {
        // @ts-ignore TS(TS2322)
        window.location = "/cart";
      });
    },
    /* eslint-disable max-lines-per-function */
    async addFilesToQueue({
      files,
      artworkIndex = null,
      existingArtworkId,
      uploadSource = null
    }: {
      files: unknown[];
      artworkIndex?: number | null;
      existingArtworkId?: number | string | null;
      uploadSource?: string | null;
      isDropEvent?: boolean;
    }) {
      // Add files if we are not updating an artwork's file or
      // the current artwork is simulation

      // Set upload_source to catalog_number_PDP if not already set
      if (!uploadSource) {
        uploadSource = `${this.catalogNumber}_PDP`;
      }

      submitDtfEvent("image_upload_count", {
        business_line: this.businessLine,
        image_count: files.length
      });

      if (artworkIndex === null || this.artworks[0].isSimulated) {
        this.addFiles(files, artworkIndex ?? this.artworks.length);
      }

      // Reset specified artwork by index
      if (artworkIndex !== null) {
        const { widthEdited, width, height } = this.simulation;

        const enableCustomSize = widthEdited && !this.isSpangle && artworkIndex === 0;

        let dimensions = {
          width: this.initialValues.width,
          height: this.initialValues.height
        };

        if (enableCustomSize) {
          dimensions = {
            width: this.printAsIs ? this.initialValues.width : width,
            height
          };
        }

        const hasMinOrderQuantity = this.isSticker || this.isPuff || this.isSpangle;
        const quantity =
          artworkIndex === 0 && !hasMinOrderQuantity
            ? this.simulation.quantity
            : this.initialValues.quantity;

        this.setIsRetrying(false);
        this.updateArtworkValues({
          index: artworkIndex,
          ...emptyArtworkItem,
          ...this.initialValues,
          ...dimensions,
          quantity,
          file: files[0],
          isFile: true,
          // @ts-ignore TS(TS2571)
          name: files[0].name,
          errorMessage: null
        });
      }

      if (this.modalArtworks.length > 1) {
        this.openModal();
      }

      const uploadedTimeStamp = new Date();
      const stateFiles = this.artworks.reduce(
        (res: Record<string, unknown>, item: ArtworkItem, index: number) => {
          if (item.isFile) {
            return [
              // @ts-ignore TS(TS2488)
              ...res,
              {
                ...item,
                originalIndex: index,
                uploadedTimeStamp
              }
            ];
          }
          return res;
        },
        []
      );

      // load files one by one
      // eslint-disable-next-line no-restricted-syntax
      for (const file of stateFiles) {
        // If artwork index is specified only update that artwork
        if (
          (typeof artworkIndex === "number" && artworkIndex !== file.originalIndex) ||
          this.artworks[file.originalIndex]?.retryFailed
        )
          // eslint-disable-next-line no-continue
          continue;

        if (!this.discarded || file.uploadedTimeStamp > this.discarded) {
          this.setFileLoading(file.originalIndex);
          // eslint-disable-next-line no-await-in-loop
          this.uploadArtwork({
            file,
            artworkIndex,
            existingArtworkId,
            uploadSource: uploadSource || `${this.catalogNumber}_PDP`
          });
        }
      }
    },
    async uploadArtwork({
      file,
      isDropEvent,
      artworkIndex,
      existingArtworkId,
      uploadSource
    }: {
      file: Record<string, unknown>;
      isDropEvent: boolean;
      artworkIndex: number | null;
      existingArtworkId: number | string | null;
      uploadSource: string | null;
    }) {
      const { printAsIs, pdpType, preCut, businessLine, catalogNumber } = this;

      // Validate file type and materialize for cloud storage providers (Google Drive, Dropbox) on mobile
      // Note: Don't mutate file.file - it's used later for identity checks (line ~2145)
      const {
        valid,
        message,
        errorType,
        file: materializedFile
        // @ts-ignore TS(TS2345)
      } = await validateAndMaterializeFile(file.file, printAsIs);
      if (!valid) {
        this.setFailedUploadArtwork({
          // @ts-ignore TS(TS4111)
          index: file.originalIndex,
          uploadError: message
        });
        if (errorType === "unsupported_type") {
          logUnsupportedFileTypeEvent(
            // @ts-ignore TS(TS4111)
            file.file,
            {
              page: "pdp",
              pdp_type: pdpType,
              business_line: businessLine
            },
            message
          );
        }
        return;
      }

      // Client-side dimension gate: reject images whose smallest dimension is below the minimum.
      // Skip for Gang Sheet Builder thumbnails — their aspect ratio drops below 200px on longer
      // sheets; the server bypasses via `generated_gang_sheet_data` (authoritative backstop).
      const skipResolutionGate = uploadSource === "gang_sheet_builder";
      const imageDimensions = skipResolutionGate
        ? null
        : await getImageDimensions(materializedFile as File);
      if (imageDimensions) {
        const smallestDimension = Math.min(imageDimensions.width, imageDimensions.height);
        if (smallestDimension < MIN_IMAGE_DIMENSION_PX) {
          submitDtfEvent("image_upload_resolution_gate_rejected", {
            file_name: (file["file"] as File).name,
            file_type: (file["file"] as File).type,
            file_size: (file["file"] as File).size,
            resolution_width: imageDimensions.width,
            resolution_height: imageDimensions.height,
            smallest_dimension: smallestDimension,
            min_required: MIN_IMAGE_DIMENSION_PX,
            upload_source: uploadSource,
            pdp_type: pdpType,
            business_line: businessLine,
            catalog_number: catalogNumber,
            multi_artwork: this.artworks.length > 1
          });

          logUploadErrorEvent(
            { pageValue: "pdp", businessLine },
            {
              name: (file["file"] as File).name,
              type: (file["file"] as File).type,
              size: (file["file"] as File).size,
              width: imageDimensions.width,
              height: imageDimensions.height
            },
            { response: { data: { error_type: "resolution_gate" } } }
          );

          this.updateArtworkValues({
            index: file["originalIndex"],
            isLoading: false,
            isFile: false,
            imageTooSmall: true
          });
          return;
        }
      }

      const uploadUuid = this.trackImageUploadStart(file, isDropEvent);
      const maxRetries = 15;
      const { dtfChannelUuid } = this;
      let retryCount = 0;
      // @ts-ignore TS(TS4111)
      const currentArtworkIndex = artworkIndex || file.originalIndex;
      const handleOnlineStatusChange = async () => {
        // @ts-ignore TS(TS2538)
        if (this.artworks[currentArtworkIndex]?.retryFailed) return;

        if (navigator.onLine && this.isRetrying) this.setIsRetrying(false);
        // @ts-ignore TS(TS2554)
        await uploadWithRetry(currentArtworkIndex);
      };

      window.addEventListener("online", handleOnlineStatusChange);
      window.addEventListener("offline", handleOnlineStatusChange);

      const uploadWithRetry = async () => {
        const controller = new AbortController();
        const { signal } = controller;
        const { productId } = this;
        const formData = new FormData();
        const processTimeStamp = Date.now();

        this.setFetchController(controller);
        // @ts-ignore TS(TS2769)
        formData.append("upload_source", uploadSource);
        // @ts-ignore TS(TS2769)
        formData.append("file", materializedFile);
        formData.append("product_id", productId);
        // @ts-ignore TS(TS2769)
        formData.append("file_original_index", file.originalIndex);
        formData.append("dtf_channel_uuid", dtfChannelUuid);
        formData.append("pre_cut", preCut);
        // @ts-ignore TS(TS2769)
        formData.append("process_time_stamp", processTimeStamp);
        formData.append("experiments", JSON.stringify(this.experiments || {}));
        if (existingArtworkId) {
          // @ts-ignore TS(TS2769)
          formData.append("existing_artwork_id", existingArtworkId);
        }

        const generatedGangSheetData =
          this.generatedGangSheets.length > 0 &&
          this.generatedGangSheets.find(
            // @ts-ignore TS(TS4111)
            (gangSheet: Record<string, unknown>) => gangSheet.id === file.file.name.split(".")[0]
          );

        if (generatedGangSheetData) {
          formData.append("generated_gang_sheet_data", JSON.stringify(generatedGangSheetData));
        }
        this.updateArtworkValues({
          index: currentArtworkIndex,
          progress: 0,
          processTimeStamp
        });

        const uploadStartTime = performance.now();
        let artwork = null;
        let uploadProgressWritten = false;

        const uploadTimeout = getUploadTimeout((materializedFile as File | undefined)?.size);

        try {
          artwork = await api.dtf.uploadArtwork(formData, {
            raw: true,
            useAxiosForRequest: true,
            headers: { "Content-Type": undefined },
            signal,
            timeout: uploadTimeout,
            onUploadProgress: ({ progress }: { progress: number }) => {
              if (progress === 1) {
                this.updateArtworkValues({
                  index: currentArtworkIndex,
                  progress: DTF_PROGRESS_MAPPING.upload_artwork.percentage[0],
                  progressMessage: "Processing file"
                });
              } else if (!uploadProgressWritten) {
                uploadProgressWritten = true;
                this.updateArtworkValues({
                  index: currentArtworkIndex,
                  progress: DTF_PROGRESS_MAPPING.upload_artwork.percentage[0]
                });
              }
              this.setIsRetrying(false);
            }
          });

          const artworkObj = this.artworks.find(
            // @ts-ignore TS(TS4111)
            (art: ArtworkItem) => art.originalIndex?.toString() === file.originalIndex.toString()
          );

          if (
            // @ts-ignore TS(TS18046)
            (this.discarded && file.uploadedTimeStamp < this.discarded) ||
            // @ts-ignore TS(TS4111)
            file.file !== artworkObj?.file ||
            artworkObj?.retryFailed
          )
            return;
          if (this.isRetrying) this.setIsRetrying(false);

          const { widthEdited, width, height } = this.simulation;

          const dimensions = {
            width: this.initialValues.width,
            height: this.initialValues.height
          };

          const enableCustomSize = widthEdited && !this.isSpangle && currentArtworkIndex === 0;

          if (enableCustomSize) {
            dimensions.width = this.printAsIs ? this.initialValues.width : width;
            dimensions.height = height;
          }

          const hasMinOrderQuantity = this.isSticker || this.isPuff || this.isSpangle;
          let defaultQuantity =
            currentArtworkIndex === 0 && !hasMinOrderQuantity
              ? this.simulation.quantity
              : this.initialValues.quantity;

          const previewMetadata = this.printAsIs ? { ...GANG_DEFAULT_VALUES.previewMetadata } : {};

          if (generatedGangSheetData) {
            defaultQuantity = generatedGangSheetData.quantity;
            // @ts-ignore TS(TS2339)
            previewMetadata.heightInch = generatedGangSheetData.size.height;
          }

          // MN-4800: tag the artwork with uploadUuid (camelCase) so every
          // updateArtworkValues / setLoadedArtwork spread that follows
          // preserves the correlation id into artworksState. Required for
          // dimension-validator dual-emit to recover the original upload_uuid.
          (artwork as unknown as Record<string, unknown>)["uploadUuid"] = uploadUuid;

          this.updateArtworkValues({
            ...artwork,
            ...this.initialValues,
            ...dimensions,
            index: currentArtworkIndex,
            lastWebSocketEvent: "upload_artwork",
            lastWebSocketEventData: {
              data: artwork.data
            },
            pricing: this.cachedArtworkPrices[emptyArtworkItem.enhancementTier] || {},
            quantity: defaultQuantity,
            previewMetadata,
            fromGangSheetBuilder: this.generatedGangSheets.length > 0,
            catalogNumber
          });

          if (retryCount > 0) {
            submitDtfEvent("image_upload_retries_success", {});
            trackRudderstackImageUploadRetry({
              status: "success",
              // @ts-ignore TS(TS18046)
              file_name: file.file.file_name,
              // @ts-ignore TS(TS18046)
              file_type: file.file.type,
              // @ts-ignore TS(TS18046)
              file_size: file.file.size,
              location: "pdp",
              dpi: 300,
              pre_cut_transfers: this.preCut
            });
          }

          this.trackImageUploadCompleted({
            // @ts-ignore TS(TS4111)
            file: file.file,
            uploadStartTime,
            artwork,
            uploadUuid,
            success: true
          });

          if (this.isStandardArtwork) {
            const attrToUpdate = {
              ...objNamesToCamelCase(artwork),
              index: currentArtworkIndex,
              quantity: this.simulation.quantity
            };

            this.updateArtworkValues({
              ...attrToUpdate,
              originalDpi: artwork.metadata?.dpi,
              sizeBasedDpi: artwork.metadata?.dpi,
              enhancedDpi: 300
            });

            this.schedulePollingFallback(artwork.id);
            this.setLoadedArtwork({ artwork });
            this.updatePreviewDpi({ artworkId: artwork.id });
            await this.downscaleOriginalImage({ artworkId: artwork.id });
          } else if (this.isProColor && this.showMultiSize) {
            // ProColor is excluded from isStandardArtwork, so nothing else clears
            // isFile/isLoading or seeds sizesAndQuantities post-upload. Delegated
            // to common/seed.ts for unit-testability against mutation testing.
            this.updateArtworkValuesById(
              buildProColorUploadSeed({
                artworkId: artwork.id,
                rawMetadata: artwork.metadata as unknown as Record<string, unknown> | null,
                fallbackDimensions: dimensions,
                defaultQuantity
              })
            );
          }

          // @ts-ignore TS(TS2339)
          if (artwork.metadata?.errors?.length > 0) {
            this.setGangsheetValidationError({
              index: currentArtworkIndex,
              artwork,
              type: ErrorTypes.INVALID_GANG_SHEET
            });
          }
        } catch (e) {
          // @ts-ignore TS(TS18046)
          if (e.name === "AbortError" || e.name === "CanceledError") return;

          // @ts-ignore TS(TS2339)
          const errorResponse = e?.response?.data || e;
          const handledError = ["backend_file_validation", "backend_processing_error"].includes(
            errorResponse?.error_type
          );

          if (
            !isTransientServerError(e) &&
            ((errorResponse.error && !errorResponse.success) ||
              // @ts-ignore TS(TS18046)
              (navigator.onLine && e.message !== "Network Error"))
          ) {
            let uploadError;
            if (handledError) {
              uploadError = errorResponse.error;
              // Use the artwork response if available, otherwise pass the error response
              // TODO: properly distinguish artwork object, response object and error object
              this.trackImageUploadCompleted({
                // @ts-ignore TS(TS4111)
                file: file.file,
                response: errorResponse,
                uploadStartTime,
                artwork: artwork || errorResponse,
                uploadUuid,
                success: false
              });
            } else {
              uploadError = "Upload error";
              logUploadError({
                // @ts-ignore TS(TS18046)
                error_message: e.message,
                error: errorResponse.error,
                // @ts-ignore TS(TS2322)
                handledError,
                uploadError,
                errorResponse
              });
            }
            const pageInfo = {
              pageValue: "pdp",
              businessLine: this.businessLine
            };
            // @ts-ignore TS(TS4111)
            logUploadErrorEvent(pageInfo, file.file, e);
            this.setFailedUploadArtwork({
              // @ts-ignore TS(TS4111)
              index: file.originalIndex,
              uploadError,
              uploadErrorCode: errorResponse?.error_code ?? null
            });

            return;
          }

          if (retryCount < maxRetries) {
            this.setIsRetrying(true);
            const retryInterval = RETRY_INTERVALS[retryCount];
            retryCount += 1;
            submitDtfEvent("image_upload_retry", {});
            // @ts-ignore TS(TS2554)
            setTimeout(() => uploadWithRetry(artworkIndex), retryInterval);
          } else {
            submitDtfEvent("image_upload_retries_failed", {});
            const errorContext = {
              // @ts-ignore TS(TS4111)
              ...getErrorContext("pdp", file["file"], e),
              upload_uuid: uploadUuid,
              business_line: this.businessLine,
              page: "pdp"
            };
            submitDtfEvent("image_upload_network_error", errorContext);
            // MN-4800 dual-emit. The closure-scoped uploadUuid (created in
            // trackImageUploadStart) is the authoritative attempt id; pass it
            // explicitly so the new transfer_upload_failed event correlates
            // with started/completed for the same attempt.
            emitTransferUploadParallelEvent({
              legacyEvent: "image_upload_network_error",
              errorContext,
              // @ts-ignore TS(TS4111)
              file: file["file"] as Record<string, unknown>,
              pageInfo: { pageValue: "pdp", businessLine: this.businessLine }
            });
            trackRudderstackImageUploadRetry({
              status: "failed",
              file_name: errorContext.file_name,
              file_type: errorContext.file_type,
              file_size: errorContext.file_size,
              dpi: errorContext.dpi,
              location: errorContext.page,
              business_line: errorContext.business_line,
              pre_cut_transfers: this.preCut
            });
            this.setRetryFailed(true);
            this.setIsLoading(true);
            this.fetchController?.abort();
            this.setFetchController(null);
          }
        } finally {
          window.removeEventListener("online", handleOnlineStatusChange);
          window.removeEventListener("offline", handleOnlineStatusChange);
        }
      };

      // Start the initial upload attempt
      // @ts-ignore TS(TS2554)
      await uploadWithRetry(artworkIndex);
    },
    /* eslint-enable max-lines-per-function */
    downloadAndTriggerArtworkUploadFlow(artworks: ArtworkItem[]) {
      artworks.forEach((artwork: ArtworkItem, index: number) => {
        fetch(artwork.originalImageUrl as string)
          .then(response => response.blob())
          .then(blob => {
            // @ts-ignore TS(TS2345)
            const file = new File([blob], artwork.name, { type: artwork.originalMimeType });
            this.addFilesToQueue({
              files: [file],
              artworkIndex: index,
              existingArtworkId: artwork.id
            });
          });
      });
    },
    handleProcessError({
      file,
      errorResponse
    }: {
      file: Record<string, unknown>;
      errorResponse: unknown;
    }) {
      // @ts-ignore TS(TS18046)
      if (errorResponse.error && !errorResponse.success) {
        let uploadError;
        if (
          // @ts-ignore TS(TS18046)
          ["backend_file_validation", "backend_processing_error"].includes(errorResponse.error_type)
        ) {
          // @ts-ignore TS(TS18046)
          uploadError = errorResponse.error;
        } else {
          uploadError = "Processing error";

          // @ts-ignore TS(TS18046)
          const benign = isBenignUploadError({
            // @ts-ignore TS(TS18046)
            message: errorResponse.message ?? errorResponse.error,
            // @ts-ignore TS(TS18046)
            type: errorResponse.error_type,
            // @ts-ignore TS(TS18046)
            status: errorResponse.status
          });

          if (!benign) {
            notifyError("Upload artwork error", {
              params: {
                // @ts-ignore TS(TS18046)
                error_message: errorResponse.message,
                // @ts-ignore TS(TS18046)
                error: errorResponse.error,
                error_response: errorResponse,
                uploadError
              }
            });
          }
        }

        const pageInfo = {
          pageValue: "pdp",
          businessLine: this.businessLine
        };
        logUploadErrorEvent(pageInfo, file, {
          response: {
            data: errorResponse
          }
        });
        this.setFailedUploadArtwork({
          // @ts-ignore TS(TS4111)
          index: file.originalIndex,
          uploadError,
          // @ts-ignore TS(TS18046)
          uploadErrorCode: errorResponse?.error_code ?? null
        });
      }
    },
    async updateArtworkContent({ data }: { data: Record<string, unknown> }) {
      this.getArtworksPricing();
      this.updatePdpDates();
      this.updateArtworkValuesById(data);
    },
    /* eslint-disable max-lines-per-function */
    async getSimulationPricing(dimensions = {}) {
      const { productId, preCut, showMultiSize } = this;
      const data = {
        artwork_id: "simulation",
        // @ts-ignore TS(TS2339)
        width: Number(dimensions.width) || 1,
        // @ts-ignore TS(TS2339)
        height: Number(dimensions.height) || 1,
        enhancement_tier: this.simulation.enhancementTier || "full_enhancements"
      };
      const pricingData = await api.dtf.dtfPricing(
        { product: productId },
        {
          artworks: [data],
          pre_cut: preCut,
          ...(this.isJiffyMade ? { request_source: "jiffy_made" } : {})
        }
      );

      const storeCredits = objNamesToCamelCase({
        order_subtotal: pricingData.order_subtotal,
        user_store_credits: pricingData.user_specific_store_credits,
        expected_credits: pricingData.expected_transfers_store_credit,
        transfers_cart_subtotal: pricingData.transfers_cart_subtotal,
        tiers: pricingData.transfers_store_credit_tiers
      });

      this.setStoreCreditInfo(storeCredits);

      // @ts-ignore TS(TS2339)
      EventBus.publish(Events.PRICING_UPDATED, storeCredits);

      this.setSimulationPricing({
        artworks: pricingData.artworks,
        isMultiSize: showMultiSize
      });
    },
    async getArtworksPricing() {
      const {
        artworks: allArtworks,
        productId,
        preCut,
        isJerseyNumbers,
        isLetters,
        showMultiSize
      } = this;
      const artworks = allArtworks.filter((a: ArtworkItem) => !a.imageTooSmall);
      let data = [];
      let response;

      if (showMultiSize) {
        artworks.forEach((artwork: ArtworkItem) =>
          artwork.sizesAndQuantities
            .filter((sizeQty: SizesAndQuantityItem) => Number(sizeQty.quantity) > 0)
            .forEach((sizeQty: SizesAndQuantityItem) => {
              const payload = {
                artwork_id: `${artwork.id}--${sizeQty.id}`,
                width: Number(sizeQty.width) || 1,
                height: Number(sizeQty.height) || 1,
                quantity: Number(sizeQty.quantity),
                enhancement_tier: artwork.enhancementTier || "full_enhancements",
                has_expert_edit_addon: artwork.hasExpertEditAddon || false
              };

              if (this.isStandardDTFProduct && !this.isJiffyMade) {
                // @ts-ignore TS(TS2339)
                payload.enhancement_request_note = artwork.enhancementNote || "";
              }

              data.push(payload);
            })
        );
      } else if (this.isJiffyMade) {
        data = artworks
          .filter((artwork: ArtworkItem) => !artwork.isSimulated)
          .map((artwork: ArtworkItem) => ({
            artwork_id: artwork.id,
            width: Number(artwork.width) || 1,
            height: Number(artwork.height) || 1,
            quantity: Number(artwork.quantity),
            enhancement_tier: artwork.enhancementTier || "full_enhancements",
            has_expert_edit_addon: artwork.hasExpertEditAddon || false
          }));
      } else {
        data = (isJerseyNumbers || isLetters ? this.letterNumberArtworks : artworks).map(
          (artwork: ArtworkItem) => {
            const payload = {
              artwork_id: artwork.id || "simulation",
              width: Number(artwork.width) || 1,
              height: Number(artwork.height) || 1,
              quantity: Number(artwork.quantity),
              enhancement_tier: artwork.enhancementTier || "full_enhancements",
              has_expert_edit_addon: artwork.hasExpertEditAddon || false
            };

            if (this.isStandardDTFProduct && !this.isJiffyMade) {
              // @ts-ignore TS(TS2339)
              payload.enhancement_request_note = artwork.enhancementNote || "";
            }

            return payload;
          }
        );
      }

      if (!data.length) return;

      this.setIsPricingLoading(true);

      this.updatePricingAbortSignal?.abort();
      this.updatePricingAbortSignal = new AbortController();
      // Capture signal before closure so retries use the original
      // (not a replacement created by a later invocation)
      const pricingSignal = this.updatePricingAbortSignal.signal;
      try {
        response = await asyncRetryIfTransientError(() =>
          api.dtf.dtfPricing(
            { product: productId },
            {
              artworks: data,
              pre_cut: preCut,
              ...(this.isJiffyMade ? { request_source: "jiffy_made" } : {})
            },
            {
              useAxiosForRequest: true,
              signal: pricingSignal
            }
          )
        );
      } catch (error) {
        if (!shouldReportError(error)) return;

        // @ts-ignore TS(TS2339)
        const status = error?.response?.status || error?.status;
        if (status && [401, 403, 422].includes(status)) {
          this.setIsPricingLoading(false);
          return;
        }

        this.setIsPricingLoading(false);
        notifyError("Error fetching artworks pricing", {
          params: {
            // @ts-ignore TS(TS18046)
            error_message: error.message,
            product_id: productId,
            pre_cut: preCut,
            is_jiffy_made: this.isJiffyMade,
            artworks: data,
            show_multi_size: showMultiSize
          }
        });
        return;
      }

      if (showMultiSize) {
        response = {
          ...response,
          artworks: groupByKeyPrefix(response.artworks, "--")
        };
      }

      const storeCredits = objNamesToCamelCase({
        order_subtotal: response.order_subtotal,
        user_store_credits: response.user_specific_store_credits,
        expected_credits: response.expected_transfers_store_credit,
        transfers_cart_subtotal: response.transfers_cart_subtotal,
        tiers: response.transfers_store_credit_tiers
      });

      this.setStoreCreditInfo(storeCredits);

      this.setArtworkPricing({ response, isMultiSize: showMultiSize });
      // @ts-ignore TS(TS2339)
      EventBus.publish(Events.PRICING_UPDATED, storeCredits);
    },
    async initDefaultValues({ skipDeliveryDateLoading = false } = {}) {
      const {
        initialValues,
        isJerseyNumbers,
        isLetters,
        variantId,
        catalogNumber,
        loadFromConfig
      } = this;

      if (!loadFromConfig && !isJerseyNumbers && !isLetters) return;

      let config;
      try {
        const response = await api.dtf.getInitConfig({ catalog_number: catalogNumber });
        config = objNamesToCamelCase(response);

        if (!config.success) {
          // attempt to retrieve error from server if present
          // @ts-ignore TS(TS2339)
          throw new Error(config.error);
        }
      } catch (error) {
        this.handleInitError(error, "fetch_init_config");
        return;
      }

      // @ts-ignore TS(TS2339)
      const { applyDefaultValues, preCut, dtfChannelUuid, messagingConsents } = config;

      try {
        const pdpDateRequest = {
          ...initialValues,
          variant_id: variantId,
          artwork_id: "simulation"
        };

        if (!loadFromConfig && (isJerseyNumbers || isLetters)) {
          if (isLetters) {
            this.generateLettersPreview(true);
          }

          reloadDeliveryEstimates([pdpDateRequest], preCut);
          return;
        }

        // Only set up cable connection if we're not in enhancement loading flow
        if (!this.isEnhancementLoading) {
          this.setDtfChannelUuid(dtfChannelUuid);

          const cable = initCable(this);
          this.setCable(cable);
        }

        if (messagingConsents) {
          this.setMessagingConsents(messagingConsents);
        }

        if (applyDefaultValues) {
          this.setPreCut(preCut);
          this.setEnablePreCut();

          if (!skipDeliveryDateLoading) {
            reloadDeliveryEstimates([pdpDateRequest], preCut);
          }

          const defaultValues = structuredClone(initialValues);

          // Ensure the default values use the correct enhancement tier based on experiments
          // The simulation object already has the correct enhancement tier set from experiments
          defaultValues.enhancementTier = this.simulation.enhancementTier;

          await this.getSimulationPricing(defaultValues);
          if (isJerseyNumbers || isLetters) {
            defaultValues.height = null;
          }

          this.updateArtworkValues(defaultValues);
        } else {
          this.updatePdpDates();
        }

        this.setUseDefaultValues(applyDefaultValues);
      } catch (error) {
        this.handleInitError(error, "process_init_config");
      }
    },
    handleInitError(error: unknown, operation: string) {
      // @ts-ignore TS(TS18046)
      if (error.message === "Unable to connect to server") {
        // eslint-disable-next-line no-alert
        alert("Unable to connect to server. Please check your internet connection and try again.");
        return;
      }

      if (!isRelevantBrowserError(error)) return;

      const errorParams: Record<string, unknown> = {};
      Object.getOwnPropertyNames(error).forEach(key => {
        // @ts-ignore TS(TS18046)
        errorParams[key] = error[key];
      });

      notifyError("Could not get dtf init meta", {
        params: {
          ...errorParams,
          operation,
          catalog_number: this.catalogNumber,
          load_from_config: this.loadFromConfig,
          url: window?.location?.href
        }
      });
    },
    /* eslint-enable max-lines-per-function */
    async updatePreCut(preCut: unknown) {
      this.setPreCut(preCut);
      this.getArtworksPricing();
      this.updatePdpDates();
    },
    // eslint-disable-next-line max-lines-per-function
    async trackArtworkAddToCart(artwork: ArtworkItem) {
      const { formArtworks, variantId, catalogNumber, businessLine, isStandardArtwork } = this;

      // @ts-ignore TS(TS4111)
      const storeArtwork = this.artworks.find((a: ArtworkItem) => a.id === artwork.artwork_id);
      const variant = await getVariantInfo(variantId);
      const artworkMetadata = artwork.metadata;
      // @ts-ignore TS(TS4111)
      const artworkBorneoMetadata = artwork.borneo_metadata;

      const trackProperties = {
        brand: variant.product.brand,
        product_category: variant.product.adwords_category,
        product: variant.product.name,
        spree_composition_id: variant.compositionId,
        composition: variant.color,
        fulfillment_group: variant.fulfillmentGroup || "",
        sku: variant.sku,
        quantity: artwork.quantity,
        buy_it_again: getIsBuyItAgainStatus(),
        favorite: variant.favorite,
        softness_score: variant.softnessScore,
        dtf_width: artwork.width,
        dtf_height: artwork.height,
        // @ts-ignore TS(TS18047)
        dtf_area: artwork.width * artwork.height,
        // @ts-ignore TS(TS4111)
        from_dam: artwork.from_dam,
        multi_artwork: formArtworks.length > 1,
        // @ts-ignore TS(TS18047)
        dtf_image_souce: artworkMetadata.imageSource,
        business_line: businessLine,
        pre_cut: this.preCut,
        // @ts-ignore TS(TS18047)
        background_removed: artworkMetadata.removeBackground,
        // @ts-ignore TS(TS4111)
        background_color: artwork.bg_color,
        // @ts-ignore TS(TS4111)
        border_size: artwork.padding_size,
        shape: artwork.shape,
        // @ts-ignore TS(TS4111)
        redraw_requested: artwork.enhancement_request_note || storeArtwork?.pinningSummary,
        // @ts-ignore TS(TS4111)
        multi_size: artwork.sizes_and_quantities?.length > 1,
        // @ts-ignore TS(TS4111)
        enhancement_tier: artwork.enhancement_tier,
        catalog_number: variant.product.catalog_number
      };

      if (isStandardArtwork) {
        // @ts-ignore TS(TS2339)
        trackProperties.enhance_image = artwork.enhanceImage;
      }

      if (["SPNG-HGR001", "SPNG-GLS001", "SPNG-RNB001"].includes(catalogNumber)) {
        // @ts-ignore TS(TS2339)
        trackProperties.dtf_spangles_algorithm = spanglesStore.selectedAlgorithm;
        // @ts-ignore TS(TS2339)
        trackProperties.artwork_url = spanglesStore.originalArtworkUrl;
      }

      if (this.isPuff) {
        // @ts-ignore TS(TS2339)
        trackProperties.color = artwork.color;
      }

      // additional params for borneo images
      // @ts-ignore TS(TS18047)
      if (artworkMetadata.imageSource === "borneo") {
        // @ts-ignore TS(TS2339)
        trackProperties.dtf_borneo_fonts_count = artworkBorneoMetadata.fonts.fonts?.length || 0;
        // @ts-ignore TS(TS2339)
        trackProperties.dtf_borneo_font_details = artworkBorneoMetadata.fonts.font_details;

        // @ts-ignore TS(TS18046)
        const summary = summarizeFonts(artworkBorneoMetadata.fonts?.font_details);
        // @ts-ignore TS(TS2339)
        trackProperties.dtf_borneo_non_unique_fonts = summary.fontFamilies;
        // @ts-ignore TS(TS2339)
        trackProperties.dtf_borneo_fonts = [...new Set(summary.fontFamilies)];
        // @ts-ignore TS(TS2339)
        trackProperties.dtf_borneo_non_unique_effects = summary.textEffects;
        // @ts-ignore TS(TS2339)
        trackProperties.dtf_borneo_effects = [...new Set(summary.textEffects)];
        // @ts-ignore TS(TS2339)
        trackProperties.dtf_borneo_images_count = artworkBorneoMetadata.images.total_images;
        // @ts-ignore TS(TS2339)
        trackProperties.dtf_borneo_texts_count = artworkBorneoMetadata.fonts.total_texts;
        // @ts-ignore TS(TS2339)
        trackProperties.dtf_borneo_shapes_count = artworkBorneoMetadata.elements.total_shapes;
        // @ts-ignore TS(TS2339)
        trackProperties.dtf_borneo_enhancements = artworkBorneoMetadata.enhancements;
        // @ts-ignore TS(TS2339)
        trackProperties.dtf_borneo_project_id = artwork.project_id;
      }

      if (this.isJerseyNumbers || this.isLetters) {
        const itemDetails = {
          style: artwork.style,
          height: artwork.height,
          color: artwork.color
        };

        if (this.isLetters) {
          // @ts-ignore TS(TS2339)
          itemDetails.font = artwork.font;
          // @ts-ignore TS(TS2339)
          itemDetails.texts = artwork.texts.filter(Boolean);
          // @ts-ignore TS(TS2339)
          itemDetails.max_length = artwork.maxLength;
        }
        // quantities":{"1":5,"2":2,"3":1}
        // @ts-ignore TS(TS2769)
        if (this.isJerseyNumbers && Object.keys(artwork.quantities).length) {
          // @ts-ignore TS(TS2769)
          Object.keys(artwork.quantities).forEach(key => {
            // @ts-ignore TS(TS7053)
            itemDetails[`number_${key}`] = artwork.quantities[key];
          });
        }

        // @ts-ignore TS(TS2339)
        trackProperties.item_details = itemDetails;
      }

      // @ts-ignore TS(TS4111)
      if (artwork.from_gang_sheet_builder) {
        // @ts-ignore TS(TS2339)
        trackProperties.gang_sheet_builder_variant = artwork.catalog_number;
      }

      // @ts-ignore TS(TS4111)
      if (this.showMultiSize && artwork.sizes_and_quantities?.length > 1) {
        submitDtfEvent("multiple_sizes_added", {
          // @ts-ignore TS(TS18046)
          number_of_sizes: artwork.sizes_and_quantities.length,
          brand: variant.product.brand,
          product_category: variant.product.adwords_category,
          product: variant.product.name,
          spree_composition_id: variant.compositionId,
          composition: variant.color
        });

        // @ts-ignore TS(TS18046)
        artwork.sizes_and_quantities.forEach((sq: SizesAndQuantityItem) => {
          submitDtfEvent("product_added", {
            ...trackProperties,
            dtf_width: sq.width,
            dtf_height: sq.height,
            // @ts-ignore TS(TS2363)
            dtf_area: sq.width * sq.height,
            quantity: sq.quantity,
            predefined_placement: sq.preset,
            placement_size: sq.size
          });
        });
      } else {
        // @ts-ignore TS(TS2339)
        trackProperties.predefined_placement = "custom";
        submitDtfEvent("product_added", trackProperties);
      }
    },
    buildReorderDtfData(selectedArtworks: unknown[], prices: Record<string, unknown>) {
      const currency = this.locale === "en-CA" ? "C$" : "$";
      // @ts-ignore TS(TS2345)
      return selectedArtworks.map(({ id, dtfPrintId, url, metadata }: ArtworkItem) => ({
        id,
        catalogNumber: "Jiffy Transfers",
        productId: this.productId,
        variantId: this.variantId,
        color: "",
        image: url,
        // @ts-ignore TS(TS2538)
        quantity: prices[dtfPrintId].quantity,
        // @ts-ignore TS(TS18047)
        size: `${metadata.widthInch}" x ${metadata.heightInch}${this.printAsIs ? "'" : '"'}`,
        // @ts-ignore TS(TS2538)
        price: `${currency}${Number(prices[dtfPrintId].price).toFixed(2)}`,
        preCut: false,
        preCutPrice: 0
      }));
    },
    async submitPrintReorder(selectedArtworks: unknown[]) {
      try {
        const response = await api.dtf.addToCartPrint({
          variant_id: this.variantId,
          quantity: 1,
          // @ts-ignore TS(TS2345)
          dtf_print_ids: selectedArtworks.map((artwork: ArtworkItem) => artwork.dtfPrintId),
          source_page: "design_library"
        });
        const dtfData = this.buildReorderDtfData(selectedArtworks, response.artwork_prices);
        incrementHeaderCounter(selectedArtworks.length);
        EventBus.publish(Events.MOBILE_GRID_SUBMIT, { dtfData });
        EventBus.publish(Events.ITEMS_ADDED_TO_CART, { ...response, is_dtf: true });
        deliveryDateResponse.reloadDeliveryEstimatesWithoutFetch({
          pdpSubtotal: this.summary?.orderSubtotal
        });
      } catch (error) {
        if (isSessionExpired(error)) {
          redirectTo("/login");
          return;
        }
        const { errorMessage, errorType, httpStatus, responseData } =
          getStructuredErrorContext(error);
        const benign = isBenignUploadError({
          message: errorMessage,
          type: errorType,
          status: httpStatus
        });

        if (!benign) {
          notifyError("Error adding to cart", {
            params: {
              error_message: errorMessage,
              error_type: errorType,
              error_status: httpStatus,
              response_data: responseData
            }
          });
        }
      }
    },
    // eslint-disable-next-line max-lines-per-function
    submitForm() {
      if (this.hasUndismissedResolutionFailures) return;
      if (this.isSubmitting) return;

      const payload = getFormPayload();
      const placementSummary = getDtfPlacementSummary(this.formArtworks);

      submitDtfEvent("dtf_add_to_cart_clicked", {
        ...payload,
        ...placementSummary,
        variant_id: this.variantId,
        quantity: this.totalQuantity,
        artwork_count: Object.values(this.formArtworks).length,
        pre_cut: this.preCut,
        multi_size: this.showMultiSize
      });

      const { formArtworks, preCut, isReadyForOrder } = this;
      const artworkValues = Object.values(formArtworks);
      let hasEmptyValues = false;
      // @ts-ignore TS(TS18046)
      artworkValues.find(artwork => !artwork.quantity);

      if (this.showMultiSize) {
        // @ts-ignore TS(TS2322)
        hasEmptyValues = artworkValues.find(artwork =>
          // @ts-ignore TS(TS18046)
          artwork.sizes_and_quantities?.find((sq: SizesAndQuantityItem) => !sq.quantity)
        );
      } else {
        // @ts-ignore TS(TS2322)
        hasEmptyValues = artworkValues.find(artwork => !artwork.quantity);
      }

      if (!isReadyForOrder) {
        return;
      }

      if (!artworkValues.length || hasEmptyValues) {
        validation.show({ hasFormErrors: true });
        return;
      }

      const requestData = {
        ...payload,
        artworks: formArtworks,
        pre_cut: preCut
      };

      mobileApp.mq.publish("feedback", { type: "vibration" });

      this.isSubmitting = true;

      const submitAddToCart = () => {
        api.dtf
          .addToCart(requestData)
          .then((response: Record<string, unknown>) => {
            // @ts-ignore TS(TS4111)
            if (response.success) {
              incrementHeaderCounter(this.totalQuantity);
              EventBus.publish(Events.ITEMS_ADDED_TO_CART, {
                ...response,
                is_dtf: true
              });
              try {
                submitDtfEvent("add_to_cart_success_displayed", {
                  quantity: this.totalQuantity,
                  // @ts-ignore TS(TS4111)
                  cart_total: response.cart_total
                });
              } catch (_) {
                // analytics failure should not break UX
              }
              formArtworks.forEach(
                async (artwork: ArtworkItem) => await this.trackArtworkAddToCart(artwork)
              );
              // @ts-ignore TS(TS4111)
              trackAddToCart(this.totalQuantity, response.cart_total);
              try {
                sendServerSideConversion("DesignCompleted", {
                  event_id: `DC-${generateUUID()}`,
                  product_id: this.productId
                });
              } catch (_) {
                // analytics failure should not break UX
              }
              this.clearWorkspace();
              this.resetPuff();
              return;
            }

            throw new Error("Add To Cart response is not successful");
          })
          .catch((e: unknown) => {
            // @ts-ignore TS(TS2592)
            $("#continue-shopping-modal").modal("hide");

            if (isSessionExpired(e)) {
              redirectTo("/login");
              return;
            }

            // @ts-ignore TS(TS18046)
            const errorResponse = tryParse(e.message);
            const modalMessage =
              extractAddToCartErrorMessage(errorResponse) ??
              "Items were not added. Please try again.";

            // @ts-ignore TS(TS2592)
            $("#adding-failure").modal("show");
            // @ts-ignore TS(TS2592)
            $("#adding-failure").find("#adding-failure-error").text(modalMessage);

            // HB-1931: emit a Mixpanel event so PM/CS can quantify customer
            // impact of Orders::DtfAddGuard rejections without a Ledger query.
            // submitDtfEvent auto-injects order_number, business_line, etc.
            const blockedProps = buildDtfAddBlockedProperties(errorResponse);
            if (blockedProps) {
              submitDtfEvent(DTF_ADD_BLOCKED_EVENT, blockedProps);
            }

            if (typeof errorResponse !== "object") {
              // only on non-JSON or malformed server response
              notifyError("Add to cart error", {
                // @ts-ignore TS(TS18046)
                params: { error_message: e.message }
              });
            }

            // @ts-ignore TS(TS18046)
            submitDtfEvent("add_to_cart_error", { error: e.message });
          })
          .finally(() => {
            this.isSubmitting = false;
          });
      };

      if (this.showModal) {
        this.hideModal();
      }

      idleCallback(() =>
        EventBus.publish(Events.MOBILE_GRID_SUBMIT, {
          dtfData: this.showMultiSize ? this.csmDataMultiSize : this.csmData
        })
      );

      submitAddToCart();
    },
    updatePdpDates() {
      const { formArtworks, preCut, isJerseyNumbers, isLetters, showMultiSize, artworks } = this;
      let filledArtworks = [];

      if (showMultiSize) {
        formArtworks.forEach((artwork: ArtworkItem) => {
          // @ts-ignore TS(TS18046)
          artwork.sizes_and_quantities
            .filter(({ quantity }: SizesAndQuantityItem) => !!quantity)
            .forEach((sizeQty: SizesAndQuantityItem, index: number) => {
              filledArtworks.push({
                // @ts-ignore TS(TS4111)
                artwork_id: `${artwork.artwork_id}-${index}`,
                // @ts-ignore TS(TS4111)
                dtf_artwork_id: artwork.artwork_id,
                ...sizeQty
              });
            });
        });
      } else {
        filledArtworks =
          isJerseyNumbers || isLetters
            ? this.letterNumberArtworks
            : formArtworks.filter(({ quantity }: SizesAndQuantityItem) => !!quantity);
      }

      const designServicesEnabled = artworks.some(
        (artwork: ArtworkItem) => artwork.hasExpertEditAddon && artwork.enhancementNote?.trim()
      );

      reloadDeliveryEstimates(filledArtworks, preCut, {
        designServicesEnabled,
        // @ts-ignore TS(TS2353)
        pdpSubtotal: this.summary?.orderSubtotal
      });
    },
    updateArtworkStyle({ id, isBgRemoved }: { id: unknown; isBgRemoved: boolean }) {
      // Invariant: `loading.removeBg` must always be cleared before this returns.
      // A stuck `true` permanently disables Add-to-Cart on the DTF PDP, recoverable
      // only via page reload. The try/finally protects against any throw in the body
      // (e.g. stale id, null metadata). All cleanup belongs in finally — early
      // returns inside the try are fine. See MN-5980.
      this.toggleLoading(["removeBg", true]);
      try {
        const { artworks, isSpangle } = this;
        const artwork = artworks.find(
          (artworkItem: ArtworkItem) => String(id) === String(artworkItem.id)
        );
        if (!artwork) {
          notifyError("updateArtworkStyle: artwork not found", { context: { id } });
          return;
        }
        const metadata = isBgRemoved ? artwork.metadata : artwork.withBgMetadata;
        const url = isBgRemoved ? artwork.noBgUrl : artwork.withBgUrl;

        let originalWidth = metadata.widthInch;
        let originalHeight = metadata.heightInch;

        if (artwork.enhanceImage) {
          originalWidth = artwork.withBgMetadata?.originalWidthInch || originalWidth;
          originalHeight = artwork.withBgMetadata?.originalHeightInch || originalHeight;
        }

        this.updateArtworkValuesById({
          id,
          isLoading: false,
          removeBackground: isBgRemoved,
          width: metadata.widthInch,
          height: metadata.heightInch,
          originalWidth,
          originalHeight,
          errorMessage: null,
          toggleBackgroundError: null,
          originalDpi: 300,
          url
        });

        if (isSpangle) {
          spanglesStore.setOriginalArtworkUrl(url);
        }
      } finally {
        this.toggleLoading(["removeBg", false]);
      }
    },
    // eslint-disable-next-line max-lines-per-function
    async sendUpdateArtworkStyle({
      // @ts-ignore TS(TS7031)
      id,
      // @ts-ignore TS(TS7031)
      isBgRemoved,
      updateMetadataCache = false,
      shape = null,
      forceBgRemoval = false
    }) {
      try {
        const artwork =
          this.artworks.find((item: ArtworkItem) => String(item.id) === String(id)) || {};
        this.toggleLoading(["removeBg", true]);
        this.updateArtworkValuesById({ id, processingImage: true });
        const sticker = this.isSticker || this.isStickerSample;

        // let paddingSize = "no_padding";
        // if (sticker) {
        //   paddingSize =
        //     artwork.paddingSize === "no_padding"
        //       ? DEFAULT_STICKER_VALUES.paddingSize
        //       : artwork.paddingSize;
        // }
        const response = await api.dtf.updateArtworkStyle(
          { id },
          {
            remove: isBgRemoved,
            catalog_number: this.catalogNumber,
            enhancement_tier: artwork.enhancementTier,
            options: {
              padding_size: artwork.paddingSize,
              shape: artwork.shape,
              force_bg_removal: forceBgRemoval
            }
          },
          {
            raw: true,
            useAxiosForRequest: true,
            headers: { "Content-Type": undefined }
          }
        );

        let data = {};
        if (sticker) {
          const responseData = objNamesToCamelCase(response);
          const { metadata, stickerCutlineWithBgUrl, stickerCutlineNoBgUrl, noBgUrl, withBgUrl } =
            responseData;
          data = { metadata, stickerCutlineWithBgUrl, stickerCutlineNoBgUrl, noBgUrl, withBgUrl };

          if (updateMetadataCache && shape) {
            const dimensions = this.isStickerSample
              ? { width: metadata.widthInch, height: metadata.heightInch }
              : getStickerDimensions(metadata.widthInch, metadata.heightInch);
            data = { ...data, ...dimensions };

            // dispatch("stickers/updateArtworkDataCache", {
            //   id,
            //   shape,
            //   paddingSize,
            //   data
            // });
          }
        } else {
          // @ts-ignore TS(TS2339)
          data.url = response.remove_background ? response.url : response.with_bg_url;
          // @ts-ignore TS(TS2339)
          data.withBgMetadata = response.with_bg_metadata;
        }

        this.updateArtworkValuesById({ id, processingImage: false, ...data });
        this.getArtworksPricing();
        this.updatePdpDates();
      } catch (e) {
        // @ts-ignore TS(TS2339)
        const errorResponse = e?.response?.data || {
          error: "Something went wrong. Please, try again!"
        };
        // Skip the revert when the artwork is no longer present (user removed it
        // mid-flight). Calling updateArtworkStyle would fire its own notifyError
        // alongside this catch-block error — duplicate Honeybadger noise.
        const stillPresent = this.artworks.some(
          (item: ArtworkItem) => String(item.id) === String(id)
        );
        if (stillPresent) {
          this.updateArtworkStyle({ id, isBgRemoved: !isBgRemoved });
        }
        this.updateArtworkValuesById({
          id,
          toggleBackgroundError: errorResponse.error,
          processingImage: false
        });
      } finally {
        this.toggleLoading(["removeBg", false]);
        this.updateArtworkValuesById({ id, processingImage: false });
      }
    },
    async buyArtworksAgainFromOrder(orderNumber: string | null) {
      const artworks = await api.dtf.getArtworksFromOrder({ order_number: orderNumber });

      this.downloadAndTriggerArtworkUploadFlow(
        artworks.map((artwork: ArtworkItem) => ({
          id: artwork.id,
          name: artwork.name,
          originalImageUrl: artwork.url,
          originalMimeType: artwork.filetype
        }))
      );
    },
    /* eslint-disable max-lines-per-function */
    async buySpangleAgain({ spangledArtwork }: { spangledArtwork: unknown }) {
      const { catalogNumber, dtfChannelUuid } = this;
      const spanglesStore = useSpanglesStore.store; // eslint-disable-line no-shadow

      // spangled true - artwork selected from 'Previous Purchases' under 'Spangle' tab
      // @ts-ignore TS(TS18046)
      const spangleDuplicateAction = spangledArtwork.spangled ? "min" : "all";

      const artwork = await api.dtf.getArtwork(
        // @ts-ignore TS(TS18046)
        { id: spangledArtwork.id },
        {
          catalog_number: catalogNumber,
          dtf_channel_uuid: dtfChannelUuid,
          spangle_duplicate_action: spangleDuplicateAction,
          upload_source: "transfers"
        }
      );

      const preparedArtwork = objNamesToCamelCase({
        // @ts-ignore TS(TS2698)
        ...spangledArtwork,
        ...artwork,
        success: true
      });

      // @ts-ignore TS(TS18046)
      if (spangledArtwork.spangled) {
        this.setLoadedArtwork({
          artwork: preparedArtwork,
          index: 0
        });
      } else {
        this.setEmptyArtwork(null);
        this.updateArtworkValues({
          index: 0,
          ...preparedArtwork,
          isLoading: true,
          isFile: false,
          removeBackground: preparedArtwork.metadata.removeBackground,
          width: preparedArtwork.metadata.widthInch,
          height: preparedArtwork.metadata.heightInch,
          originalWidth: preparedArtwork.metadata.widthInch,
          originalHeight: preparedArtwork.metadata.heightInch,
          lengthFoot: preparedArtwork.metadata.lengthFoot
        });
      }

      // @ts-ignore TS(TS18046)
      if (spangledArtwork.spangled) {
        spanglesStore.setIsSpangleReordering(true);

        const spangleVariation = {
          algorithm: "reorder",
          // @ts-ignore TS(TS18046)
          imageUrl: spangledArtwork.spangledImageUrl || artwork.url,
          spangleCsv: artwork.spangle_csv,
          spanglePagesInfo: artwork.metadata.spangle_pages_info,
          positionsJson: artwork.spangle_positions_json,
          isLoading: false,
          error: false
        };

        spanglesStore.setSpangleVariations([{ ...spangleVariation }]);
        spanglesStore.selectVersion({ version: { ...spangleVariation } });
      }

      spanglesStore.setOriginalArtworkUrl(artwork.url);

      // @ts-ignore TS(TS2339)
      let { width, height } = spangledArtwork;

      if (spangleDuplicateAction === "all") {
        width = artwork.metadata.width_inch;
        height = artwork.metadata.height_inch;
      }

      spanglesStore.setLastSpangledDimensions({ width, height });

      // @ts-ignore TS(TS18046)
      const mode = spangledArtwork.spangled ? SPANGLE_MODES.sizeEdited : SPANGLE_MODES.spangleIt;
      spanglesStore.setSpangleMode(mode);
    },
    /* eslint-enable max-lines-per-function */
    generateSpangleImage({ artwork }: { artwork: ArtworkItem }) {
      const spanglesStore = useSpanglesStore.store; // eslint-disable-line no-shadow
      spanglesStore.prepareVariations({ isRetry: false });
      this.updateArtworkValuesById({ id: artwork.id, progress: 100 });

      api.dtf.generateSpangleImage(
        { id: artwork.id },
        {
          product_id: this.productId,
          dtf_channel_uuid: this.dtfChannelUuid,
          width_inch: artwork.width,
          height_inch: artwork.height,
          process_time_stamp: artwork.processTimeStamp
        }
      );
    },
    /* eslint-disable max-lines-per-function */
    async buyArtworksAgain(artworks: unknown[], index: number) {
      const { artworks: currentArtworks } = this;
      let currentIndex = currentArtworks[0].id === "simulation" ? 0 : currentArtworks.length;

      if (this.isJiffyMade) {
        currentIndex = index;
      }

      // @ts-ignore TS(TS2345)
      const artworksToBuy = artworks.map((artwork: ArtworkItem) => ({
        ...emptyArtworkItem,

        // Allow selecting the same image multiple times on Jiffy Made
        id: this.isJiffyMade ? `${artwork.id}-${currentIndex}` : artwork.id,

        name: artwork.name,
        url: artwork.url,
        metadata: artwork.metadata,
        // @ts-ignore TS(TS18047)
        width: artwork.metadata.widthInch,
        // @ts-ignore TS(TS18047)
        height: artwork.metadata.heightInch,
        // @ts-ignore TS(TS18047)
        lengthFoot: artwork.metadata.lengthFoot,
        quantity: this.initialValues.quantity,
        originalMime: artwork.originalMime,
        progress: 100,
        curProgress: 100,
        isFile: false,
        success: true,
        isLoading: true,

        // Preselect default prices for artwork
        pricing: this.cachedArtworkPrices[emptyArtworkItem.enhancementTier] || {},

        enhancementCompleted: artwork.enhancementCompleted,
        enhanceImage: artwork.enhanceImage,
        enhancedNoBgUrl: artwork.enhancedNoBgUrl,
        enhancedWithBgUrl: artwork.enhancedWithBgUrl,
        originalImageUrl: artwork.originalImageUrl,
        sliderPreviewUrl: artwork.sliderPreviewUrl,
        spangled: artwork.spangled,
        spangledImageUrl: artwork.spangledImageUrl,
        cutlineUrl: artwork.cutlineUrl,
        // @ts-ignore TS(TS4111)
        cmykOriginalImageUrl: artwork.cmykOriginalImageUrl,
        // @ts-ignore TS(TS4111)
        goildFoilPreviewAttached: artwork.goildFoilPreviewAttached,
        originalMetadata: artwork.originalMetadata,
        enhancedMetadata: artwork.enhancedMetadata,
        withBgMetadata: artwork.withBgMetadata,
        previewMetadata: artwork.previewMetadata,
        originalDpi: artwork.originalDpi,
        enhancedDpi: artwork.enhancedDpi,
        enhancedOriginalDpi: artwork.enhancedOriginalDpi,
        originalWidth: artwork.originalWidth,
        originalHeight: artwork.originalHeight,
        sizeBasedDpi: artwork.sizeBasedDpi,
        canRemoveBg: artwork.canRemoveBg,
        processTimeStamp: artwork.processTimeStamp,
        manualEditUrl: artwork.manualEditUrl || null,
        // @ts-ignore TS(TS4111)
        manualEditNoTrimUrl: artwork.manualEditNoTrimUrl || null,
        editImageManual: artwork.editImageManual || false,
        pinningSessionId: artwork.pinningSessionId || null
      }));

      if (this.isSpangle) {
        await this.buySpangleAgain({ spangledArtwork: artworksToBuy[0] });
      } else {
        let lastIndex = currentIndex;
        await Promise.all(
          // @ts-ignore TS(TS2345)
          artworksToBuy.map(async (artwork: ArtworkItem) => {
            let pdpArtworkIndex = this.artworks.findIndex(
              (element: ArtworkItem) => String(artwork.id) === String(element.id)
            );

            if (this.isJiffyMade) {
              pdpArtworkIndex = index;
            }

            // Duplicate artwork on backend when same image is already on PDP
            if (pdpArtworkIndex !== -1 && !this.isJiffyMade) {
              try {
                const dupResponse = objNamesToCamelCase(
                  await api.dtf.duplicateArtwork(
                    { id: artwork.id },
                    { catalog_number: this.catalogNumber }
                  )
                );
                artwork = {
                  ...artwork,
                  id: dupResponse.id,
                  name: dupResponse.fileName
                };
                pdpArtworkIndex = -1;
              } catch (error) {
                notifyError(error as Error, {
                  context: { source: "duplicateArtwork", artworkId: artwork.id }
                });
              }
            }

            const pdpArtwork = currentArtworks[pdpArtworkIndex];

            const sizes = pdpArtwork?.sizesAndQuantities;

            const sameSizeIndex = sizes?.findIndex(
              (size: SizesAndQuantityItem) =>
                `${size.width}${size.height}` === `${artwork.width}${artwork.height}` &&
                size.preset === "custom"
            );

            // @ts-ignore TS(TS4111)
            if (this.isGoldFoil && !artwork.goildFoilPreviewAttached && artwork.url) {
              const coloredImage = await convertImageToHexColor(artwork.url, GOLD_FOIL_HEX);
              artwork.url = coloredImage;
            }

            let artworkWidth = artwork.width;
            let artworkHeight = artwork.height;

            if (!artwork.enhanceImage) {
              // @ts-ignore TS(TS2322)
              artworkWidth = artwork.originalMetadata?.widthInch;
              // @ts-ignore TS(TS2322)
              artworkHeight = artwork.originalMetadata?.heightInch;
            }

            const updatedArtwork = {
              ...artwork,
              metadata: {
                ...artwork.metadata,
                widthInch: artworkWidth,
                heightInch: artworkHeight
              }
            };

            if (this.showMultiSize) {
              let updatedSizes = [];
              const size = {
                width: artwork.width,
                height: artwork.height,
                quantity: artwork.quantity,
                preset: "custom",
                id: getRandomId()
              };

              if (pdpArtwork) {
                // @ts-ignore TS(TS7006)
                updatedSizes = pdpArtwork?.sizesAndQuantities.map((sizeItem, sizeItemIndex) => ({
                  ...sizeItem,

                  quantity:
                    sameSizeIndex === sizeItemIndex ? sizeItem.quantity + 1 : sizeItem.quantity
                }));

                if (pdpArtwork && sameSizeIndex === -1) {
                  updatedSizes.push(size);
                }
              } else {
                updatedSizes = [size];
              }

              updatedArtwork.sizesAndQuantities = updatedSizes;
            } else if (pdpArtwork) {
              updatedArtwork.quantity = pdpArtwork.quantity + 1;
            }

            const newIndex = pdpArtwork ? pdpArtworkIndex : lastIndex;
            lastIndex = pdpArtwork ? lastIndex : lastIndex + 1;

            // @ts-ignore TS(TS2551)
            updatedArtwork.originalIndex = newIndex;

            this.setLoadedArtwork({
              artwork: updatedArtwork,
              isBuyAgain: true,
              index: this.isJiffyMade ? index : newIndex
            });

            if (updatedArtwork.enhancementCompleted) {
              // setLoadedArtwork intentionally strips enhancementCompleted from the spread to
              // prevent server payloads from overwriting it. Restore it here for buy-again
              // artworks that had enhancement completed in the original order.
              this.updateArtworkValuesById({ id: updatedArtwork.id, enhancementCompleted: true });
            }
          })
        );

        // Check for gang sheet validation errors
        // Only validate for gang sheet products (check if catalog number is in gang sheet catalog numbers)
        const isGangSheetProduct =
          this.gangSheetCatalogNumbers.length > 0 &&
          this.gangSheetCatalogNumbers.includes(this.catalogNumber);

        if (isGangSheetProduct) {
          // @ts-ignore TS(TS2345)
          artworksToBuy.forEach((artwork: ArtworkItem) => {
            const metadata = artwork.metadata || {};
            const errors = validateGangSheetDimensions(metadata);

            // Set validation error if any errors found
            if (errors.length > 0) {
              const artworkIndex = this.artworks.findIndex(
                (element: ArtworkItem) => String(artwork.id) === String(element.id)
              );
              if (artworkIndex !== -1) {
                this.setGangsheetValidationError({
                  index: artworkIndex,
                  artwork: {
                    id: artwork.id,
                    metadata: {
                      ...metadata,
                      errors
                    }
                  },
                  type: ErrorTypes.INVALID_GANG_SHEET
                });
              }
            }
          });
        }
      }

      if (this.artworks.length > 1) {
        this.openModal();
      }

      if (this.isSpangle) {
        // DO NOT call generateSpangleImage here for artworks from history
        // because buySpangleAgain creates a NEW artwork with a different ID
        // and we would be calling generateSpangleImage with the OLD ID
        // which causes ActionCable events to be ignored (ID mismatch)

        // If artwork needs spangle generation, we should call it with the NEW ID from store
        const storeArtwork = this.artworks[0];
        if (storeArtwork && storeArtwork.isLoading) {
          this.generateSpangleImage({ artwork: storeArtwork });
        }
      }

      this.getArtworksPricing();
      this.updatePdpDates();
    },
    async loadArtworkAndSetPaddingImage({
      id,
      paddingSize
    }: {
      id: unknown;
      paddingSize: unknown;
    }) {
      const artwork = await api.dtf.getArtwork(
        { id },
        {
          catalog_number: this.catalogNumber,
          dtf_channel_uuid: this.dtfChannelUuid,
          process_artwork: "false",
          file_content_type: null,
          padding_size: paddingSize
        }
      );

      this.updateArtworkValuesById({ ...artwork });
    },
    async preloadArtworks({
      // @ts-ignore TS(TS7031)
      artworkIds,
      // @ts-ignore TS(TS7031)
      artworkWidth,
      // @ts-ignore TS(TS7031)
      artworkHeight,
      // @ts-ignore TS(TS7031)
      processArtwork,
      // @ts-ignore TS(TS7031)
      urlPreCut,
      // @ts-ignore TS(TS7031)
      fileContentType,
      // @ts-ignore TS(TS7031)
      artworkPaddingSize,
      // @ts-ignore TS(TS7031)
      artworkBgColor,
      // @ts-ignore TS(TS7031)
      artworkColor,
      // @ts-ignore TS(TS7031)
      artworkShape
    }) {
      deleteCookie("uploaded_artwork_ids");

      const urlParams = new URLSearchParams(window.location.search);
      const enhancementsStarted = urlParams.get("enhancements_started") === "true";
      const hasDtfChannelUuid = urlParams.has("dtf_channel_uuid");

      if (!enhancementsStarted || !hasDtfChannelUuid) {
        this.cleanupUrlParameters();
      }
      if (artworkIds.length > 1) {
        this.openModal();
      }

      // set preCut only if pre_cut URL param is set
      const preCut = tryParse(urlPreCut);
      // Only buy it again provides artwork width and height
      if (typeof preCut === "boolean") {
        this.setLoadFromConfig(false);
        this.setPreCut(preCut);
        this.setEnablePreCut();
      }

      const fetchArtworkPromises = artworkIds.map(async (id: number | string) => {
        if (!processArtwork) {
          this.updateArtworkValuesById({
            id,
            progress: 100
          });
        }

        this.updateArtworkValuesById({
          id,
          quantity:
            this.isSticker || this.isPuff || this.isSpangle
              ? this.initialValues.quantity
              : this.simulation.quantity
        });

        const artworkIndex = findIndexById(this.artworks, id);

        const fetchArtworkWithRetry = async () => {
          let artwork;
          const delays = [300000, 700000, 900000, 1100000, 1300000]; // delays: 300s to 1300s
          const sticker = this.isSticker || this.isStickerSample;
          const retries = 5;
          const params = {
            catalog_number: this.catalogNumber,
            dtf_channel_uuid: this.dtfChannelUuid,
            process_artwork: processArtwork,
            file_content_type: fileContentType,
            process_time_stamp: this.artworks[artworkIndex]?.processTimeStamp || Date.now(),

            padding_size: artworkPaddingSize
          };

          for (let i = 0; i < retries; i += 1) {
            // eslint-disable-next-line no-await-in-loop
            artwork = await api.dtf.getArtwork({ id }, this.sanitizeObject(params));

            if (artwork && (!sticker || artwork.cutline_url)) {
              return artwork;
            }
            if (i === retries - 1) {
              this.setFailedUploadArtwork({
                index: 0,
                uploadError: "Processing error, try reloading page"
              });
            }

            // eslint-disable-next-line no-await-in-loop, no-promise-executor-return
            await new Promise(resolve => setTimeout(resolve, delays[i]));
          }

          return artwork;
        };

        let artwork;

        if (id) {
          artwork = await fetchArtworkWithRetry();
        }

        if (!artwork || artwork.metadata.process_cancelled) {
          this.removeArtwork(id);
          this.setSimulation({
            ...DEFAULT_SIMULATION_ARTWORK,
            ...this.initialValues
          });
          return;
        }

        if (this.isGoldFoil && artwork.url) {
          const originalUrl = artwork.url;
          const coloredImage = await convertImageToHexColor(artwork.url, GOLD_FOIL_HEX);
          artwork.url = coloredImage;
          artwork.goldFoilOriginalUrl = originalUrl;
        }

        if (this.isSpangle && !processArtwork) {
          await this.buyArtworksAgain([{ ...artwork }]);
        } else {
          this.updateArtworkValuesById({ ...artwork });
        }

        if (artwork.metadata) {
          if (artwork.metadata.errors) {
            const index = this.artworks.length - 1;
            this.setGangsheetValidationError({
              index,
              artwork,
              type: ErrorTypes.INVALID_GANG_SHEET
            });
          }
          submitDtfEvent("external_image_loaded", {
            source: artwork.metadata.uploaded_on,
            business_line: this.businessLine
          });

          if (artwork.process_artwork !== "true" && !this.isStandardArtwork) {
            let artworkValues = {
              ...artwork,
              width: artworkWidth,
              height: artworkHeight,
              lengthFoot: artwork.metadata.length_foot,
              isLoading: false,
              isFile: false,
              removeBackground: artwork.metadata.remove_background
            };

            if (this.printAsIs) {
              const previewMetadata = { heightInch: artwork.metadata.height_inch };
              artworkValues = {
                ...artworkValues,
                previewMetadata,
                isValid: true
              };
            }

            if (this.isSticker || this.isStickerSample) {
              artworkValues = {
                ...artworkValues,
                paddingSize: artworkPaddingSize,
                bgColor: artworkBgColor,
                shape: artworkShape
              };
            } else if (this.isPuff) {
              artworkValues = { ...artworkValues, color: artworkColor };
            }

            this.updateArtworkValuesById(artworkValues);
          } else if (this.isStandardArtwork) {
            const needProcess = artwork.process_artwork === "true";
            const artworkCamelCased = objNamesToCamelCase(artwork);
            const { originalMetadata, metadata, enhanceImage, enhancedMetadata, withBgMetadata } =
              artworkCamelCased;

            let selectedMetadata = originalMetadata;

            if (!needProcess && enhanceImage) {
              selectedMetadata = artworkCamelCased.removeBackground
                ? enhancedMetadata || metadata
                : withBgMetadata;
            }

            if (needProcess || !enhanceImage) {
              artworkWidth = originalMetadata?.widthInch;
              artworkHeight = originalMetadata?.heightInch;
            }

            const artworkValues = {
              ...artworkCamelCased,
              id: artwork.id,
              enhanceImage: !needProcess ? enhanceImage : true,
              width: artworkWidth,
              height: artworkHeight,
              originalWidth: selectedMetadata?.widthInch,
              originalHeight: selectedMetadata?.heightInch,
              originalDpi:
                !needProcess && enhanceImage
                  ? artworkCamelCased?.enhancedOriginalDpi
                  : originalMetadata?.dpi,
              sizeBasedDpi:
                !needProcess && enhanceImage
                  ? artworkCamelCased?.enhancedOriginalDpi
                  : originalMetadata?.dpi,
              metadata: {
                ...artwork.metadata,
                widthInch: artworkWidth,
                heightInch: artworkHeight,
                aspectRatio: (
                  parseFloat(selectedMetadata.width) / parseFloat(selectedMetadata.height)
                ).toPrecision(6)
              },
              lengthFoot: artwork.metadata.length_foot,
              isLoading: false,
              isFile: false,
              enhancementCompleted: !needProcess,
              removeBackground: artwork.metadata.remove_background,
              originalImageUrl: artwork.original_image_url,
              enhancedNoBgUrl: artwork.no_bg_url,
              enhancedWithBgUrl: artwork.with_bg_url,
              sliderPreviewUrl: artwork.no_bg_no_trim_url,
              enhancedDpi: 300,
              enhancedOriginalDpi: artworkCamelCased?.enhancedOriginalDpi
            };

            this.updateArtworkValuesById(artworkValues);

            const index = findIndexById(this.artworks, artwork.id);
            const updatedArtwork = this.artworks[index];

            if (!needProcess && enhanceImage) {
              this.updatePreviewDpi({ artworkId: updatedArtwork.id });
            }
            if (needProcess) {
              this.schedulePollingFallback(artwork.id);
            }
            await this.downscaleOriginalImage({ artworkId: updatedArtwork.id });
          }
        }
      });

      await Promise.all(fetchArtworkPromises);

      this.getArtworksPricing();
      this.updatePdpDates();
    },
    /* eslint-enable max-lines-per-function */
    setGangsheetValidationError({
      index,
      artwork,
      type
    }: {
      index: number;
      artwork: ArtworkItem;
      type: unknown;
    }) {
      const { metadata, id } = artwork;
      submitDtfEvent("invalid_gang_sheet", {
        artwork_id: id,
        ...metadata
      });
      // We only need to show the first gang sheet dimension error
      this.setValidationErrorMessage({
        index,
        // @ts-ignore TS(TS18047)
        message: metadata.errors[0],
        type
      });
    },
    removeArtworkWithActivity(artworkId: number | string | null) {
      const { pdpType, artworks, businessLine } = this;

      const artworkIndex = artworks.findIndex((artwork: ArtworkItem) => artwork.id === artworkId);
      if (artworkIndex === -1) return;

      const artworkToRemove = this.artworks[artworkIndex];

      this.removePresetMockupColor(artworkIndex);

      const eventContext = {
        file_name: artworkToRemove.name,
        file_type: artworkToRemove.filetype,
        file_size: artworkToRemove.filesize,
        width: artworkToRemove.metadata?.width,
        height: artworkToRemove.metadata?.height,
        page: artworkToRemove.metadata?.uploadedOn || "pdp",
        pdp_type: pdpType,
        business_line: businessLine,
        dpi: artworkToRemove.metadata?.upscalingEnabled
          ? Number(artworkToRemove.metadata?.qualityUpscaleDpi)
          : 200,
        resolution_width:
          artworkToRemove.metadata?.trimInfo?.originalWidthPx || artworkToRemove.metadata?.width,
        resolution_height:
          artworkToRemove.metadata?.trimInfo?.originalHeightPx || artworkToRemove.metadata?.height
      };
      submitDtfEvent("image_removed", eventContext);
      trackRudderstackImageRemoved({
        business_line: businessLine,
        file_name: eventContext.file_name,
        file_type: eventContext.file_type,
        file_size: eventContext.file_size,
        location: eventContext.page,
        dpi: artworkToRemove.metadata?.dpi,
        artworks_count: this.artworks?.length,
        pre_cut_transfers: this.preCut
      });

      this.removeArtwork(artworkId);
      this.setSimulation({ ...DEFAULT_SIMULATION_ARTWORK, ...this.initialValues });
    },
    trackImageUploadStart(file: Record<string, unknown>, isDropEvent: boolean) {
      const { pdpType, artworks, businessLine, preCut, catalogNumber } = this;
      const uploadUuid = generateUUID();

      // MN-4800: persist the uploadUuid via the WeakMap-backed tracker so
      // every downstream error path that calls getErrorContext(_, file.file, _)
      // (e.g. logUploadErrorEvent at line 3281, retry-exhausted at 3301)
      // recovers the same correlation id without depending on direct
      // mutation of the native File object.
      setUploadUuid(file["file"], uploadUuid);

      submitDtfEvent("image_upload_started", {
        page: "pdp",
        pdp_type: pdpType,
        type: isDropEvent ? "drop" : "browse",
        // @ts-ignore TS(TS18046)
        file_name: file.file.name,
        // @ts-ignore TS(TS18046)
        file_type: file.file.type,
        // @ts-ignore TS(TS18046)
        file_size: file.file.size,
        dpi: 300,
        project_id: null,
        multi_artwork: artworks?.length > 1,
        artworks_count: artworks?.length,
        business_line: businessLine,
        catalog_number: catalogNumber,
        upload_uuid: uploadUuid
      });

      trackRudderstackImageUploadStarted({
        catalog_number: catalogNumber,
        location: "pdp",
        // @ts-ignore TS(TS18046)
        file_name: file.file.name,
        // @ts-ignore TS(TS18046)
        file_type: file.file.type,
        // @ts-ignore TS(TS18046)
        file_size: file.file.size,
        dpi: 300,
        business_line: businessLine,
        artworks_count: artworks?.length,
        pre_cut_transfers: preCut,
        upload_uuid: uploadUuid
      });

      return uploadUuid;
    },
    trackImageUploadCompleted({ index, ...data }: { index: number; [key: string]: unknown }) {
      const { artwork, file, response, uploadStartTime, uploadUuid, success } = data;
      const { pdpType, artworks, businessLine, preCut } = this;

      // MN-4800: persist the closure-scoped uploadUuid on the artwork object
      // using camelCase (uploadUuid) so it survives objNamesToCamelCase in
      // setLoadedArtwork. Dimension validators read this back as
      // artwork.uploadUuid to correlate post-upload friction events with the
      // original upload attempt.
      if (artwork && typeof artwork === "object" && uploadUuid) {
        (artwork as Record<string, unknown>)["uploadUuid"] = uploadUuid;
      }

      submitCompletedEvent({
        multiArtwork: artworks?.length > 1,
        artworksCount: artworks?.length,
        catalogNumber: this.catalogNumber,
        dpi: 300,
        uploadedOn: "pdp",
        preCutTransfers: preCut,
        uploadStartTime,
        file,
        artwork,
        pdpType,
        response,
        businessLine,
        uploadUuid,
        success
      });

      sendDataLayer({
        genericEvent: true,
        event: "ImageUploadCompleted",
        // @ts-ignore TS(TS2339)
        filetype: artwork?.filetype,
        // @ts-ignore TS(TS2339)
        filesize: artwork?.filesize
      });
    },
    /* eslint-disable max-lines-per-function */
    async getArtworkHistory(payload: Record<string, unknown>) {
      const { search, sortOrder, artworkIds, currentType, apiType, artworksType } = payload;
      try {
        const {
          artworkHistory,
          dtfChannelUuid,
          catalogNumber,
          artworkHistoryPagination: pagination
        } = this;

        const apiParams = {
          per_page: pagination.perPage,
          page: pagination.page,
          tab: artworksType,
          sort: `created_at_${sortOrder}`,
          artwork_ids: artworkIds,
          search,
          dtf_channel_uuid: dtfChannelUuid,
          catalog_number: catalogNumber
        };

        let response;

        if (apiType === "list") {
          // @ts-ignore TS(TS2345)
          response = await api.dtf.getArtworkHistories(apiParams);
        } else {
          // @ts-ignore TS(TS2345)
          response = await api.dtf.getArtworkHistory(apiParams);
        }

        response = objNamesToCamelCase(response);

        const { ...apiPageInfo } = response;
        let { artworks } = response;

        if (this.isGoldFoil && currentType === "true") {
          // @ts-ignore TS(TS2322)
          artworks = await Promise.all(
            // @ts-ignore TS(TS2345)
            artworks.map(async (artwork: ArtworkItem) => {
              const coloredImage = await convertImageToHexColor(
                // @ts-ignore TS(TS18046)
                artwork.ordered.imageUrl,
                GOLD_FOIL_HEX
              );

              // @ts-ignore TS(TS18046)
              artwork.ordered.goldFoilImage = coloredImage;
              // @ts-ignore TS(TS18046)
              artwork.ordered.imageUrl = coloredImage;

              return artwork;
            })
          );
        }

        const newArtworkList = apiPageInfo.page === 1 ? artworks : [...artworkHistory, ...artworks];

        this.setArtworkHistoryPagination(apiPageInfo);
        this.setArtworkHistory(newArtworkList);
      } catch (error) {
        const err = error as {
          status?: number;
          response?: unknown;
          message?: string;
          name?: string;
        };

        if (err?.name === "AbortError" || err?.name === "CanceledError") {
          return;
        }

        const status = err?.status;

        // HB-1923: suppress benign edge responses while preserving HB-1816's
        // 422 domain-error signal from the DTF pipeline.
        if (
          isBenignUploadError({
            message: err?.message ?? null,
            type: err?.name ?? null,
            status: status === 422 ? null : (status ?? null)
          })
        ) {
          return;
        }

        const responseBody =
          typeof err?.response === "string"
            ? err.response.slice(0, 500)
            : JSON.stringify(err?.response ?? null).slice(0, 500);
        const fingerprintLabel = deriveArtworkHistoryFingerprint(status, responseBody);

        notifyError("DTF previous purchase modal error", {
          params: {
            error_message: err?.message,
            status,
            response_body: responseBody,
            error_name: err?.name,
            fingerprint_label: fingerprintLabel
          }
        });
      }
    },

    async changePuffColor({ color, index = 0 }: { color: string; index: number }) {
      const [artwork] = this.artworks;
      this.updateArtworkValues({ index, color });

      let { url } = artwork;
      if (this.isStandardArtwork) {
        if (artwork.enhancementTier === "print_original") {
          url = artwork.originalImageUrl;
        } else {
          url = artwork.removeBackground ? artwork.sliderPreviewUrl : artwork.enhancedWithBgUrl;
        }
      }

      if (!url) return;

      try {
        this.setPuff({ isLoading: true });

        const coloredImage = await convertImageToHexColor(url, color);

        this.setPuff({ image: coloredImage });
      } catch (_error) {
        this.setPuff({ image: null });
      } finally {
        this.setPuff({ isLoading: false });
      }
    },
    async convertImageToHexColor({ artwork }: { artwork: ArtworkItem }) {
      if (artwork.url) {
        const coloredImage = await convertImageToHexColor(artwork.url, GOLD_FOIL_HEX);
        artwork.url = coloredImage;
      }

      this.setLoadedArtwork({ artwork });
    },
    async generateGoldFoilImages({ artworkId }: { artworkId: number | string | null }) {
      const index = findIndexById(this.artworks, artworkId);
      const artwork = this.artworks[index];

      const tint = (url: string) =>
        url ? convertImageToHexColor(url, GOLD_FOIL_HEX) : Promise.resolve(url);

      const [enhancedWithBgUrl, enhancedNoBgUrl, sliderPreviewUrl, goldFoilOriginalUrl] =
        await Promise.all([
          tint(artwork.enhancedWithBgUrl),
          tint(artwork.enhancedNoBgUrl),
          tint(artwork.sliderPreviewUrl),
          tint(artwork.originalImageUrl)
        ]);

      this.updateArtworkValuesById({
        id: artworkId,
        enhancedWithBgUrl,
        enhancedNoBgUrl,
        sliderPreviewUrl,
        goldFoilOriginalUrl,
        enhancementCompleted: true
      });
    },
    updatePrintReadyInfoState(artworkId: number | string | null) {
      const { pdpType, isSpangle, artworks } = this;

      const artwork = artworks.find(({ id }: ArtworkItem) => String(id) === String(artworkId));
      const show =
        pdpType !== "gang_sheets" &&
        !isSpangle &&
        artwork?.metadata &&
        !artwork.metadata.canRemoveBg &&
        !artwork.metadata.upscaleInfo;
      this.updateArtworkValuesById({
        id: artworkId,
        printReadyInfo: {
          show,
          expanded: false
        }
      });
    },
    updateJerseyNumberPdpDates: debounce(function updateJerseyNumberPdpDates(
      this: Record<string, unknown>
    ) {
      // @ts-ignore TS(TS4111)
      if (!this.isValidJerseyArtwork) return;

      // @ts-ignore TS(TS2571)
      this.updatePdpDates();
    }, 800),
    // eslint-disable-next-line max-lines-per-function
    async downloadLettersPreview(simulation = false) {
      try {
        const { style, font, height, maxLength, color, texts, textIndex } =
          this.letterNumberArtwork;
        let text = "ABCD";
        if (texts.length) {
          const index = textIndex;
          text = texts[index];
        }
        const imageIndex = textIndex;
        let letterConfig = {
          font,
          color,
          style,
          letter_height_inch: height,
          text,
          max_length_inch: maxLength
        };

        if (simulation) {
          const presentValues = Object.fromEntries(
            Object.entries(letterConfig).filter(([_, value]) => value !== null)
          );
          // @ts-ignore TS(TS2741)
          letterConfig = {
            ...LETTERS_FILL_IN_VALUES,
            ...presentValues
          };
        }

        if (!letterConfig.text) return;

        this.setLetterPreviewLoading(true);

        const response = await api.dtf.generateLettersPreview({ letter_configs: letterConfig });
        const latestImageIndex = this.letterNumberArtwork.textIndex;

        if (this.artworks[0].texts[textIndex] === text) {
          this.setLetterPreviewMessage({ textIndex, message: response.validation_message });
        }

        if (imageIndex !== latestImageIndex) return;

        const { sizes } = this.letterNumberArtwork;
        sizes[textIndex] = { width: response.width, height: response.height };

        const { url } = response;

        this.updateArtworkValues({ index: 0, url, sizes });
        if (this.isLetterReadyForOrder) {
          this.getArtworksPricing();
          this.updatePdpDates();
        }
      } catch (error) {
        this.updateArtworkValues({ index: 0, url: null });
      } finally {
        this.setLetterPreviewLoading(false);
      }
    },
    debouncedGenerateLettersPreview: debounce(
      function debouncedGenerateLettersPreview(this: Record<string, unknown>) {
        // @ts-ignore TS(TS4111)
        if (this.isLetterPreviewReady) {
          // @ts-ignore TS(TS2571)
          this.downloadLettersPreview();
        } else {
          // @ts-ignore TS(TS2571)
          this.downloadLettersPreview(true);
        }
      },
      800,
      { leading: true }
    ),
    generateLettersPreview(useDebounce = true) {
      if (useDebounce) {
        this.debouncedGenerateLettersPreview();
      } else if (this.isLetterPreviewReady) {
        this.downloadLettersPreview();
      } else {
        this.downloadLettersPreview(true);
      }
    },
    updateAllLetterPreviews: debounce(
      function updateAllLetterPreviews(this: Record<string, unknown>) {
        // @ts-ignore TS(TS4111)
        if (this.isLetterReadyForOrder) {
          // @ts-ignore TS(TS2571)
          this.setLetterPreviewLoading(true);
          // @ts-ignore TS(TS2571)
          this.updateLettersPreviews();
          // @ts-ignore TS(TS4111)
        } else if (!this.isLetterPreviewReady) {
          // @ts-ignore TS(TS2571)
          this.downloadLettersPreview(true);
        }
      },
      800,
      { leading: true }
    ),
    async updateLettersPreviews() {
      try {
        const requestData = { artworks: this.formArtworks };
        const response = await api.dtf.generateLettersSizes(requestData);
        const artwork = {
          sizes: response.reduce(
            (acc: Record<string, unknown>, value: Record<string, unknown>, index: number) => {
              acc[index] = value;
              return acc;
            },
            {}
          )
        };

        const { textIndex } = this.letterNumberArtwork;
        if (textIndex !== null) {
          // @ts-ignore TS(TS2339)
          artwork.url = artwork.sizes[textIndex].url;
        }
        this.updateArtworkValues({ index: 0, ...artwork });
        await this.getArtworksPricing();
        this.updatePdpDates();
      } catch (error) {
        notifyError("Error generating letters preview", {
          params: { error: JSON.stringify(error) }
        });
      }
    },
    async buyAsStickerById({ artworkIds }: { artworkIds: unknown[] }) {
      const { catalogNumber, dtfChannelUuid } = this;

      const artworks = await Promise.all(
        // @ts-ignore TS(TS2345)
        artworkIds.map((id: number | string) =>
          api.dtf.getArtwork(
            { id },
            {
              catalog_number: catalogNumber,
              dtf_channel_uuid: dtfChannelUuid
            }
          )
        )
      );

      this.downloadAndTriggerArtworkUploadFlow(
        artworks.map(artwork => ({
          id: artwork.id,
          name: artwork.name,
          originalImageUrl: artwork.url,
          originalMimeType: artwork.filetype
        }))
      );
    },
    // eslint-disable-next-line max-lines-per-function
    async updateEnableEnhancement({
      artworkId,
      enableEnhancement,
      enhancementTier: explicitTier
    }: {
      artworkId: number | string;
      enableEnhancement: boolean;
      enhancementTier?: string;
    }) {
      const enhancementTier =
        explicitTier ?? (enableEnhancement ? "full_enhancements" : "print_original");
      try {
        const artwork = this.artworks.find(
          ({ id }: ArtworkItem) => String(id) === String(artworkId)
        );
        const initialMetadata = artwork.metadata;
        const { originalMetadata, metadata, enhancedMetadata, withBgMetadata } = artwork;

        let selectedMetadata = originalMetadata;
        if (enableEnhancement && enhancementTier !== "custom") {
          selectedMetadata =
            artwork.removeBackground || enhancementTier === "full_enhancements"
              ? enhancedMetadata || metadata
              : withBgMetadata;
        }

        if (artwork.pricing?.enhancementTier) {
          this.cachedArtworkPrices = {
            ...this.cachedArtworkPrices,
            [artwork.pricing.enhancementTier]: artwork.pricing
          };
        }

        const attributes = {
          id: artworkId,
          enhanceImage: enableEnhancement,
          enhancementTier,
          width: selectedMetadata?.widthInch,
          height: selectedMetadata?.heightInch,
          originalWidth: selectedMetadata?.widthInch,
          originalHeight: selectedMetadata?.heightInch,
          originalDpi: enableEnhancement ? artwork?.enhancedOriginalDpi : originalMetadata?.dpi,
          sizeBasedDpi: enableEnhancement ? null : originalMetadata?.dpi,
          pricing: this.cachedArtworkPrices[enhancementTier] || {},
          metadata: {
            ...initialMetadata,
            aspectRatio: (
              parseFloat(selectedMetadata?.width) / parseFloat(selectedMetadata?.height)
            ).toPrecision(6)
          }
        };

        this.updateArtworkValuesById(attributes);

        if (enableEnhancement) {
          this.updatePreviewDpi({ artworkId });
        }

        await this.downscaleOriginalImage({ artworkId });

        // currently only support for first artwork
        const apiParams = { dtf_artwork: { enhance_image: enableEnhancement } };
        await api.dtf.updateArtworkRedrawData({ id: artworkId }, apiParams);

        this.getArtworksPricing();
        this.updatePdpDates();

        submitDtfEvent("dtf_image_print_perfect_toggle", {
          business_line: this.businessLine,
          artwork_id: artworkId,
          enhance_image: enableEnhancement,
          selected_by: "customer",
          metadata: enableEnhancement ? metadata : originalMetadata
        });

        submitDtfEvent("dtf_enhancement_tier_change", {
          business_line: this.businessLine,
          name: enhancementTier,
          artwork_id: artworkId,
          enhance_image: enableEnhancement,
          metadata: enableEnhancement ? metadata : originalMetadata
        });
      } catch (error) {
        const { errorMessage, errorType, httpStatus, responseData } =
          getStructuredErrorContext(error);
        // @ts-ignore TS(TS2339) — error.stack is universally available on Error instances; helper doesn't return it
        const errorStack = (error as { stack?: string })?.stack || "No stack trace available";
        const errorDetails =
          httpStatus !== null ? { response: { status: httpStatus, data: responseData } } : {};

        // HB-1816: do NOT treat 422 as benign on the enhancement-save path.
        // The backend controller's bare `rescue` turns `ActiveRecord::RecordNotFound`
        // on `DtfPipelineStep` (the race this ticket tracks) into a 422, so
        // filtering 422 here would silence the exact signal we need.
        const benign = isBenignUploadError({
          message: errorMessage,
          type: errorType,
          status: httpStatus === 422 ? null : httpStatus
        });

        if (!benign) {
          notifyError("Artwork enhancement setting save from PDP failed", {
            tags: "enhancement-settings-failed-to-save-pdp",
            params: {
              error_message: errorMessage,
              error_type: errorType,
              stack_trace: errorStack,
              error_details: errorDetails,
              enhance_image: enableEnhancement,
              artwork_id: artworkId,
              enhancement_tier: enhancementTier
            }
          });
        }
      }
    },
    updatePreviewDpi({ artworkId }: { artworkId: number | string | null }) {
      if (!this.isStandardArtwork) return;

      const index = findIndexById(this.artworks, artworkId);
      const artwork = this.artworks[index];

      // forces SVG images to have a 300 DPI on display
      if (artwork?.originalMime === "image/svg+xml") {
        this.updateArtworkValuesById({ id: artworkId, originalDpi: 300, sizeBasedDpi: 300 });
        return;
      }

      // logic to retrieve size
      let requestedWidth = artwork.width;
      let requestedHeight = artwork.height;
      if (artwork.sizesAndQuantities.length > 0) {
        const largestSize = artwork.sizesAndQuantities
          .filter((size: SizesAndQuantityItem) => size.quantity > 0)
          .reduce(
            (largest: SizesAndQuantityItem, current: SizesAndQuantityItem) => {
              // @ts-ignore TS(TS2345)
              const largestDimension = parseFloat(largest.width);
              // @ts-ignore TS(TS2345)
              const currentDimension = parseFloat(current.width);
              return currentDimension > largestDimension ? current : largest;
            },
            artwork.sizesAndQuantities.find((size: SizesAndQuantityItem) => size.quantity > 0) ||
              artwork.sizesAndQuantities[0]
          );

        requestedWidth = largestSize.width;
        requestedHeight = largestSize.height;
      }

      let resultingDpi = artwork.originalDpi;

      if (artwork.originalWidth !== requestedWidth || artwork.originalHeight !== requestedHeight) {
        resultingDpi = artwork.originalDpi / (requestedWidth / artwork.originalWidth);
      }

      if (
        !Number.isNaN(artwork.sizeBasedDpi) &&
        !Number.isNaN(resultingDpi) &&
        artwork.sizeBasedDpi !== resultingDpi
      ) {
        this.updateArtworkValuesById({ id: artworkId, sizeBasedDpi: resultingDpi });
      }
    },
    // eslint-disable-next-line max-lines-per-function
    async downscaleOriginalImage({ artworkId }: { artworkId: number | string | null }) {
      if (!this.isStandardArtwork) return;

      const index = findIndexById(this.artworks, artworkId);
      const artwork = this.artworks[index];

      if (
        artwork?.metadata?.mimeType === "image/pdf" ||
        artwork?.originalImageUrl === null ||
        artwork?.originalImageUrl === undefined ||
        artwork?.filetype === "image/svg+xml" ||
        artwork?.originalMime === "image/svg+xml" ||
        !artwork?.originalImageUrl?.startsWith("http")
      ) {
        return;
      }

      const sourceImage = await this.downloadImage(artwork.originalImageUrl);

      if (
        !sourceImage.width ||
        !sourceImage.height ||
        sourceImage.width === 0 ||
        sourceImage.height === 0
      ) {
        logUploadError({
          error_message: `Invalid image dimensions: ${sourceImage.width}x${sourceImage.height}`,
          error: "Canvas rendering error",
          uploadError: "Image has invalid dimensions",
          // @ts-ignore TS(TS2353)
          errorResponse: {
            imageUrl: artwork.originalImageUrl,
            width: sourceImage.width,
            height: sourceImage.height
          }
        });
        return;
      }

      const originalDpi = 300; // baseline DPI
      // Fallback to originalDpi if sizeBasedDpi is invalid to prevent NaN in qualityRatio calculation
      // which would lead to 0x0 intermediate canvas dimensions and throw an error
      const targetDpi = Number.isFinite(artwork.sizeBasedDpi) ? artwork.sizeBasedDpi : originalDpi;

      if (targetDpi >= originalDpi) {
        this.updateArtworkValuesById({
          id: artworkId,
          downscaledOriginalImage: artwork.originalImageUrl
        });

        return;
      }

      const aspectRatio = sourceImage.width / sourceImage.height;
      const previewCanvasWidth = this.previewCanvasSize.width;

      if (!previewCanvasWidth || previewCanvasWidth === 0) {
        return;
      }

      if (!Number.isFinite(aspectRatio) || aspectRatio === 0) {
        logUploadError({
          error_message: `Invalid aspect ratio: aspectRatio=${aspectRatio}`,
          error: "Canvas rendering error",
          uploadError: "Invalid aspect ratio",
          // @ts-ignore TS(TS2353)
          errorResponse: {
            aspectRatio,
            imageWidth: sourceImage.width,
            imageHeight: sourceImage.height
          }
        });
        return;
      }

      const previewCanvasHeight = previewCanvasWidth / aspectRatio;

      try {
        // Collect diagnostics locally and attach to thrown errors only
        const debugInfo = {
          artworkId,
          previewCanvasWidth,
          previewCanvasHeight,
          aspectRatio,
          targetDpi,
          originalDpi,
          previewCanvasSize: this.previewCanvasSize,
          catalogNumber: this.catalogNumber,
          sizeBasedDpi: artwork.sizeBasedDpi
        };

        const resultCanvas = document.createElement("canvas");
        const resultContext = resultCanvas.getContext("2d");

        // Invert the ratio to create more noticeable blur at lower DPIs
        const qualityRatio = Math.max(0.1, targetDpi / originalDpi); // minimum 0.1 to prevent extreme blur
        // @ts-ignore TS(TS2339)
        debugInfo.qualityRatio = qualityRatio;

        // Create an intermediate canvas at a smaller size to simulate lower DPI
        const intermediateCanvas = document.createElement("canvas");
        const intermediateContext = intermediateCanvas.getContext("2d");

        // Calculate dimensions that simulate the target DPI
        const intermediateWidth = Math.max(1, Math.round(previewCanvasWidth * qualityRatio));
        const intermediateHeight = Math.max(1, Math.round(previewCanvasHeight * qualityRatio));
        // @ts-ignore TS(TS2339)
        debugInfo.intermediateWidth = intermediateWidth;
        // @ts-ignore TS(TS2339)
        debugInfo.intermediateHeight = intermediateHeight;

        // Set intermediate canvas to smaller dimensions
        intermediateCanvas.width = intermediateWidth;
        intermediateCanvas.height = intermediateHeight;

        // Validate intermediate canvas dimensions before drawing
        if (intermediateCanvas.width === 0 || intermediateCanvas.height === 0) {
          const err = new Error(
            `Intermediate canvas has invalid dimensions: ${intermediateCanvas.width}x${intermediateCanvas.height}`
          );
          // @ts-ignore TS(TS2339)
          err.debug = {
            ...debugInfo,
            throwAt: "intermediate_canvas_zero_dimension",
            assignedWidth: intermediateCanvas.width,
            assignedHeight: intermediateCanvas.height
          };
          throw err;
        }

        // First draw to smaller size (simulating lower DPI)
        // @ts-ignore TS(TS18047)
        intermediateContext.imageSmoothingEnabled = true;
        // @ts-ignore TS(TS18047)
        intermediateContext.imageSmoothingQuality = "low";
        // @ts-ignore TS(TS18047)
        intermediateContext.drawImage(sourceImage, 0, 0, intermediateWidth, intermediateHeight);

        // Calculate dimensions that simulate the target DPI
        const resultWidth = Math.max(1, previewCanvasWidth);
        const resultHeight = Math.max(1, previewCanvasHeight);
        // @ts-ignore TS(TS2339)
        debugInfo.resultWidth = resultWidth;
        // @ts-ignore TS(TS2339)
        debugInfo.resultHeight = resultHeight;

        // Set final canvas size
        resultCanvas.width = resultWidth;
        resultCanvas.height = resultHeight;

        // Validate result canvas dimensions before drawing
        if (resultCanvas.width === 0 || resultCanvas.height === 0) {
          const err = new Error(
            `Result canvas has invalid dimensions: ${resultCanvas.width}x${resultCanvas.height}`
          );
          // @ts-ignore TS(TS2339)
          err.debug = {
            ...debugInfo,
            throwAt: "result_canvas_zero_dimension",
            assignedWidth: resultCanvas.width,
            assignedHeight: resultCanvas.height
          };
          throw err;
        }

        // Scale back up to preview size, which will show the quality loss
        // @ts-ignore TS(TS18047)
        resultContext.imageSmoothingEnabled = true;
        // @ts-ignore TS(TS18047)
        resultContext.imageSmoothingQuality = "high";
        // @ts-ignore TS(TS18047)
        resultContext.drawImage(intermediateCanvas, 0, 0, resultWidth, resultHeight);

        const result = resultCanvas.toDataURL("image/png");

        if (result !== "data:,") {
          this.updateArtworkValuesById({ id: artworkId, downscaledOriginalImage: result });
        }
      } catch (error) {
        // @ts-ignore TS(TS2339)
        const dbg = error?.debug;
        logUploadError({
          // @ts-ignore TS(TS18046)
          error_message: error.message,
          error: "Canvas rendering error",
          uploadError: "Failed to downscale image",
          // @ts-ignore TS(TS2353)
          errorResponse: {
            imageUrl: artwork.originalImageUrl,
            imageWidth: sourceImage.width,
            imageHeight: sourceImage.height,
            previewCanvasWidth,
            previewCanvasHeight,
            aspectRatio,
            targetDpi,
            originalDpi,
            // Diagnostics if available
            qualityRatio: dbg?.qualityRatio,
            intermediateWidth: dbg?.intermediateWidth,
            intermediateHeight: dbg?.intermediateHeight,
            resultWidth: dbg?.resultWidth,
            resultHeight: dbg?.resultHeight,
            assignedWidth: dbg?.assignedWidth,
            assignedHeight: dbg?.assignedHeight,
            throwAt: dbg?.throwAt,
            previewCanvasSize: dbg?.previewCanvasSize ?? this.previewCanvasSize,
            catalogNumber: dbg?.catalogNumber ?? this.catalogNumber,
            artworkId: dbg?.artworkId ?? artworkId
          }
        });
      }
    },
    // @ts-ignore TS(TS7006)
    async downloadImage(url, maxRetries = 5) {
      const delays = [250, 500, 1000, 2000, 4000];
      const retryableStatuses = [408, 429, 500, 502, 503, 504];
      let blobUrl: string | null = null;

      /* eslint-disable no-await-in-loop */
      for (let attempt = 0; attempt <= maxRetries; attempt += 1) {
        try {
          const response = await fetch(url);

          if (!response.ok) {
            const error = new Error(
              `Failed to fetch image: HTTP ${response.status} ${response.statusText} for ${url}`
            );
            // @ts-ignore TS(TS2339)
            error.status = response.status;
            throw error;
          }

          const blob = await response.blob();
          blobUrl = URL.createObjectURL(blob);
          break;
        } catch (error) {
          if (blobUrl) {
            URL.revokeObjectURL(blobUrl);
          }

          // @ts-ignore TS(TS2339)
          const isRetryable = error?.status && retryableStatuses.includes(error.status);
          const lastAttempt = attempt === maxRetries;
          if (lastAttempt || !isRetryable) {
            throw error;
          }

          const delay = delays[Math.min(attempt, delays.length - 1)];
          await new Promise(resolve => {
            setTimeout(resolve, delay);
          });
        }
      }
      /* eslint-enable no-await-in-loop */

      const image = new Image();

      await new Promise((resolve, reject) => {
        image.onload = () => {
          // @ts-ignore TS(TS2345)
          URL.revokeObjectURL(blobUrl);
          // @ts-ignore TS(TS2794)
          resolve();
        };
        image.onerror = event => {
          // @ts-ignore TS(TS2345)
          URL.revokeObjectURL(blobUrl);
          const error = new Error("Failed to decode image");
          // @ts-ignore TS(TS2339)
          error.event = event;
          reject(error);
        };
        // @ts-ignore TS(TS2322)
        image.src = blobUrl;
      });

      return image;
    },
    fetchBulkPrice() {
      Object.entries(this.gangSheetBuilderVariants).forEach(async ([_, value]) => {
        // @ts-ignore TS(TS18046)
        const response = await api.dtf.fetchBulkPrice({ variant_id: value.variant_id });
        const bulkPrice = {};

        // @ts-ignore TS(TS7053)
        bulkPrice[value.variant_id] = response;

        this.setGangSheetBulkPrice(bulkPrice);
        this.updateBulkTable();
      });
    },
    updateBulkTable() {
      if (!this.gangSheetBulkPrice[this.gangSheetBuilderSettings.variantId]) return;

      EventBus.publish(Events.BULK_TABLE_UPDATE, {
        htmlTable: this.gangSheetBulkPrice[this.gangSheetBuilderSettings.variantId].table
      });
    },
    updateCarouselImage({ variantId }: { variantId: number | string | null }) {
      EventBus.publish(Events.SELECTED_VARIANT_CHANGED, {
        // @ts-ignore TS(TS2538)
        carouselData: this.gangSheetBuilderCarousels[variantId]
      });
    },
    sanitizeObject(obj: unknown) {
      // @ts-ignore TS(TS2769)
      return Object.fromEntries(Object.entries(obj).filter(([_, value]) => value != null));
    },
    async cancelArtworkProcess(artwork: ArtworkItem) {
      if (!artwork.id) return;

      api.dtf.cancelArtworkProcess({ id: artwork.id });
    },
    sendCancelEvent(artwork: ArtworkItem) {
      const { lastWebSocketEvent, id } = artwork;
      let action;

      if (lastWebSocketEvent !== null) {
        if (lastWebSocketEvent === "fetch_delivery_date") {
          action = "spangle_api";
        } else if (lastWebSocketEvent === "upload_artwork") {
          action = "image_upload";
        } else {
          action = "image_processing";
        }
      } else if (this.isSpangle) {
        action = "spangle_api";
      } else {
        action = "image_upload";
      }

      submitDtfEvent("transfers_cancel_button_clicked", {
        action,
        catalog_number: this.catalogNumber,
        business_line: this.businessLine,
        artwork_id: id
      });
    },
    handleCancelProcess(artwork: ArtworkItem) {
      const spanglesStore = useSpanglesStore.store; // eslint-disable-line no-shadow
      // @ts-ignore TS(TS4111)
      this.updateArtworkValues({ index: artwork.originalIndex, processTimeStamp: Date.now() });
      this.sendCancelEvent(artwork);
      this.cancelArtworkProcess(artwork);
      this.clearValidateArtworkStartEventInterval(artwork.id);

      if (artwork.id) {
        transfersPollingService.stopPolling(Number(artwork.id));
      }

      if (
        !artwork.isLoading &&
        spanglesStore.spangleVariations.some(
          // @ts-ignore TS(TS4111)
          (variation: Record<string, unknown>) => variation.spanglePagesInfo !== null
        )
      ) {
        // @ts-ignore TS(TS2322)
        spanglesStore.cancelSpangleProcess({ artwork });
      } else if (artwork.id) {
        this.removeArtwork(artwork.id);
      } else {
        // @ts-ignore TS(TS4111)
        this.removeArtworkByIndex(artwork.originalIndex);
      }

      // Recalculate pricing and enhancements after removing artwork
      this.getArtworksPricing();
    },

    defineOriginalWidth(ordered: unknown) {
      // @ts-ignore TS(TS18046)
      if (ordered.enhanceImage) {
        // @ts-ignore TS(TS18046)
        return ordered.removeBackground
          ? // @ts-ignore TS(TS18046)
            ordered.enhancedMetadata?.widthInch
          : // @ts-ignore TS(TS18046)
            ordered.withBgMetadata?.widthInch;
      }

      // @ts-ignore TS(TS18046)
      return ordered.originalMetadata?.widthInch;
    },
    defineOriginalHeight(ordered: unknown) {
      // @ts-ignore TS(TS18046)
      if (ordered.enhanceImage) {
        // @ts-ignore TS(TS18046)
        return ordered.removeBackground
          ? // @ts-ignore TS(TS18046)
            ordered.enhancedMetadata?.heightInch
          : // @ts-ignore TS(TS18046)
            ordered.withBgMetadata?.heightInch;
      }

      // @ts-ignore TS(TS18046)
      return ordered.originalMetadata?.heightInch;
    },
    async loadEnhancementArtwork({
      // @ts-ignore TS(TS7031)
      enhancementsStarted,
      // @ts-ignore TS(TS7031)
      dtfChannelUuid,
      // @ts-ignore TS(TS7031)
      rawArtworkUrls,
      // @ts-ignore TS(TS7031)
      artworkWidth,
      // @ts-ignore TS(TS7031)
      artworkHeight
    }) {
      if (!enhancementsStarted || !dtfChannelUuid || !rawArtworkUrls) {
        return;
      }

      this.isEnhancementLoading = true;

      try {
        const { parseArtworkUrls } = await import("common/utils/json");
        const parsedUrls = parseArtworkUrls(rawArtworkUrls);
        // @ts-ignore TS(TS2339)
        if (!parsedUrls?.artworkIds?.length) {
          return;
        }

        // @ts-ignore TS(TS2339)
        const { artworkIds, lastArtworkId } = parsedUrls;

        // Initialize loading state
        this.initializeLoadingState(lastArtworkId);

        // Fetch artwork details
        const artworkDetails = await this.fetchArtworkDetails(artworkIds, dtfChannelUuid);

        if (!artworkDetails?.artworks?.length) {
          return;
        }

        const artwork = artworkDetails.artworks.map(
          ({
            id = null,
            fileName = "",
            originalMime = "",
            enhancementTier = "",
            uploadedOn = "",
            purchasedDate = "",
            ordered = {},
            original = {},
            useFootLength,
            dtfPrintId,
            currentEnhancementState,
            sizesAndQuantities
          }: Record<string, unknown>) => ({
            id,
            dtfPrintId,
            name: fileName,
            uploadedOn,
            purchasedDate,
            originalMime,
            enhancementTier,
            // @ts-ignore TS(TS18046)
            url: ordered.imageUrl,
            // @ts-ignore TS(TS2339)
            spangledImageUrl: ordered?.spangledImageUrl,
            // @ts-ignore TS(TS2339)
            cutlineUrl: ordered?.cutlineUrl,
            // @ts-ignore TS(TS18046)
            originalImageUrl: original.imageUrl,
            // @ts-ignore TS(TS18046)
            originalMimeType: original.mimeType,
            // @ts-ignore TS(TS2339)
            cmykOriginalImageUrl: ordered?.cmykOriginalImageUrl,
            processTimeStamp: Date.now(),
            goildFoilPreviewAttached: this.isGoldFoil,
            // @ts-ignore TS(TS18046)
            enhancedNoBgUrl: ordered.noBgUrl,
            // @ts-ignore TS(TS18046)
            enhancedWithBgUrl: ordered.withBgUrl,
            enhancementCompleted: true,
            // @ts-ignore TS(TS18046)
            originalDpi: ordered.dpi,
            // @ts-ignore TS(TS18046)
            enhancedDpi: ordered.dpi,
            // @ts-ignore TS(TS18046)
            sliderPreviewUrl: ordered.noBgNoTrimUrl,
            // @ts-ignore TS(TS18046)
            canRemoveBg: ordered.canRemoveBg || false,
            useFootLength: useFootLength || false,
            // @ts-ignore TS(TS18046)
            removeBackground: ordered.removeBackground || false,
            // @ts-ignore TS(TS2339)
            metadata: ordered?.metadata,
            // @ts-ignore TS(TS2339)
            originalMetadata: ordered?.originalMetadata,
            // @ts-ignore TS(TS2339)
            enhancedMetadata: ordered?.enhancedMetadata,
            // @ts-ignore TS(TS2339)
            withBgMetadata: ordered?.withBgMetadata,
            // @ts-ignore TS(TS2339)
            enhanceImage: ordered?.enhanceImage,
            // @ts-ignore TS(TS18046)
            previewMetadata: this.printAsIs ? { heightInch: ordered.height } : {},
            // @ts-ignore TS(TS2339)
            enhancedOriginalDpi: ordered?.enhancedOriginalDpi,
            originalWidth: this.defineOriginalWidth(ordered),
            originalHeight: this.defineOriginalHeight(ordered),
            // @ts-ignore TS(TS2339)
            sizeBasedDpi: ordered?.enhanceImage
              ? // @ts-ignore TS(TS2339)
                ordered?.enhancedOriginalDpi
              : // @ts-ignore TS(TS2339)
                ordered?.originalMetadata?.dpi,
            currentEnhancementState,
            sizesAndQuantities
          })
        )[0];

        const isEnhancementComplete = artwork.currentEnhancementState === "complete_processing";

        if (isEnhancementComplete) {
          await this.setupCompletedEnhancement(artwork);
        } else {
          await this.setupInProgressEnhancement(artwork, dtfChannelUuid, {
            width: artworkWidth,
            height: artworkHeight
          });
        }

        this.cleanupUrlParameters();
      } catch (error) {
        notifyError("Enhancement loading failed", {
          // @ts-ignore TS(TS18046)
          params: { error: error.message }
        });
      } finally {
        this.isEnhancementLoading = false;
      }
    },

    initializeLoadingState(artworkId: number | string | null) {
      this.artworksState = [
        {
          ...emptyArtworkItem,
          id: artworkId,
          isLoading: true,
          isFile: false,
          originalIndex: 0
        }
      ];

      this.simulation = { ...DEFAULT_SIMULATION_ARTWORK };

      this.updateArtworkValuesById({
        id: artworkId,
        isLoading: false,
        enhancementCompleted: false,
        imageProcessingCompletedEventSent: false,
        progress: 50,
        progressMessage: "Loading artwork details...",
        processTimeStamp: Date.now()
      });
    },

    async fetchArtworkDetails(artworkIds: unknown[], dtfChannelUuid: string | null) {
      this.updateArtworkValuesById({
        id: artworkIds[artworkIds.length - 1],
        progress: 50,
        currentProgress: 25,
        progressMessage: "Loading artwork details..."
      });

      const responseHistory = await Promise.all([
        api.dtf.getArtworkHistory({
          // @ts-ignore TS(TS2561)
          artwork_ids: artworkIds,
          dtf_channel_uuid: dtfChannelUuid,
          catalog_number: this.catalogNumber,
          enhancement_started: true
        }),
        api.dtf.getArtwork(
          {
            id: artworkIds[artworkIds.length - 1]
          },
          {
            catalog_number: this.catalogNumber,
            dtf_channel_uuid: dtfChannelUuid
          }
        )
      ]);

      // @ts-ignore TS(TS2345)
      const artworks = responseHistory[0].artworks.map((item: ArtworkItem) => ({
        ...item,
        // @ts-ignore TS(TS2698)
        ordered: { ...item.ordered, ...responseHistory[1] }
      }));

      return objNamesToCamelCase({ ...responseHistory[0], artworks });
    },

    async setupCompletedEnhancement(artwork: ArtworkItem) {
      const artworkWithCompletion = {
        ...artwork,
        enhancementCompleted: true
      };

      this.setLoadedArtwork({ artwork: artworkWithCompletion });

      this.updateArtworkValuesById({
        id: artwork.id,
        progress: 100,
        progressMessage: "Enhancement complete",
        processTimeStamp: Date.now(),
        isLoading: false,
        enhancementCompleted: true
      });

      if (this.isStandardArtwork) {
        this.updatePreviewDpi({ artworkId: artwork.id });
        await this.downscaleOriginalImage({ artworkId: artwork.id }).catch((err: unknown) => {
          console.warn("[DTF] downscaleOriginalImage failed, continuing:", err);
        });
      }

      this.updateArtworkValuesById({
        id: artwork.id,
        imageProcessingCompletedEventSent: true
      });

      this.updatePrintReadyInfoState(artwork.id);
    },

    async setupInProgressEnhancement(
      artwork: ArtworkItem,
      dtfChannelUuid: string | null,
      dimensions: unknown[]
    ) {
      this.setDtfChannelUuid(dtfChannelUuid);
      const cable = initCable(this);
      this.setCable(cable);
      // @ts-ignore TS(TS2339)
      const { width: artworkWidth, height: artworkHeight } = dimensions;

      this.updateArtworkValuesById({
        id: artwork.id,
        isLoading: false,
        enhancementCompleted: false,
        progress: 50,
        progressMessage: "Processing enhancements...",
        processTimeStamp: Date.now(),
        url: artwork.url,
        originalImageUrl: artwork.originalImageUrl,
        canRemoveBg: artwork.canRemoveBg,
        removeBackground: artwork.removeBackground,
        filetype: artwork.filetype,
        filesize: artwork.filesize,
        name: artwork.name,
        ...this.initialValues,
        metadata: {
          ...artwork.metadata,
          // @ts-ignore TS(TS4111)
          width: artwork.metadata?.width ?? artworkWidth,
          // @ts-ignore TS(TS4111)
          height: artwork.metadata?.height ?? artworkHeight,
          // @ts-ignore TS(TS4111)
          widthInch: artwork.metadata?.widthInch ?? artworkWidth,
          // @ts-ignore TS(TS4111)
          heightInch: artwork.metadata?.heightInch ?? artworkHeight
        },
        withBgMetadata: {
          ...artwork.withBgMetadata,
          // @ts-ignore TS(TS4111)
          width: artwork.withBgMetadata?.width ?? artworkWidth,
          // @ts-ignore TS(TS4111)
          height: artwork.withBgMetadata?.height ?? artworkHeight,
          // @ts-ignore TS(TS4111)
          widthInch: artwork.withBgMetadata?.widthInch ?? artworkWidth,
          // @ts-ignore TS(TS4111)
          heightInch: artwork.withBgMetadata?.heightInch ?? artworkHeight
        }
      });

      this.schedulePollingFallback(artwork.id);
    },

    cleanupUrlParameters() {
      const newUrl = new URL(window.location.href);
      const paramsToDelete = [
        "uploaded_artwork_ids",
        "artwork_urls",
        "file_content_type",
        "enhancements_started",
        "dtf_channel_uuid",
        "side"
      ];

      paramsToDelete.forEach(param => newUrl.searchParams.delete(param));
      window.history.replaceState({}, "", newUrl.toString());
    }
  }
});

export const dtfStore = useDtfStore.store;

// MN-4782: non-production Playwright test hook. Gated at BUILD time via
// rspack EnvironmentPlugin substitution on process.env.NODE_ENV — the whole
// block is dead-code-eliminated from the production bundle, so no console
// command can turn it on. Runtime `window.__ENABLE_TEST_HOOKS__` flags were
// rejected in code review (cso-scan HIGH: an attacker could set the flag
// before the DTF bundle lazy-loads and gain write access to the store).
// Bracket-access for process.env.NODE_ENV satisfies TS index-signature rule
// (TS4111); rspack EnvironmentPlugin substitutes either access syntax.
if (process.env["NODE_ENV"] !== "production" && typeof window !== "undefined") {
  (window as unknown as { __dtfReactStore?: typeof dtfStore }).__dtfReactStore = dtfStore;
}

export default useDtfStore;
